webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.polythene = {})));
	}(this, (function (exports) { 'use strict';
	
	var isClient = typeof document !== "undefined";
	var isServer = !isClient;
	
	var evts = {
	  "animation": "animationend",
	  "OAnimation": "oAnimationEnd",
	  "MozAnimation": "animationend",
	  "WebkitAnimation": "webkitAnimationEnd"
	};
	
	var getAnimationEndEvent = function getAnimationEndEvent() {
	  if (isClient) {
	    var el = document.createElement("fakeelement");
	    for (var a in evts) {
	      if (el.style[a] !== undefined) {
	        return evts[a];
	      }
	    }
	  }
	};
	
	var Conditional = {
	  view: function view(vnode, _ref) {
	    var h = _ref.renderer;
	
	    var attrs = vnode.attrs;
	    return attrs.permanent || attrs.show ? h(attrs.instance, attrs) : h("span", { className: attrs.placeholderClassName });
	  }
	};
	
	Conditional.displayName = "Conditional";
	
	var r = function r(acc, p) {
	  return acc[p] = 1, acc;
	};
	
	/* 
	Separately handled props:
	- class
	- element
	*/
	
	var defaultAttrs = [
	// Universal
	"key", "style", "href", "id",
	
	// React
	"tabIndex",
	
	// Mithril
	"tabindex", "oninit", "oncreate", "onupdate", "onbeforeremove", "onremove", "onbeforeupdate"];
	
	var filterSupportedAttributes = function filterSupportedAttributes(attrs) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$add = _ref.add,
	      addAttrs = _ref$add === undefined ? [] : _ref$add,
	      _ref$remove = _ref.remove,
	      removeAttrs = _ref$remove === undefined ? [] : _ref$remove;
	
	  var removeLookup = removeAttrs.reduce(r, {});
	  var supported = defaultAttrs.concat(addAttrs).filter(function (item) {
	    return !removeLookup[item];
	  }).reduce(r, {});
	  return Object.keys(attrs).reduce(function (acc, key) {
	    return supported[key] ? acc[key] = attrs[key] : null, acc;
	  }, {});
	};
	
	var unpackAttrs = function unpackAttrs(attrs) {
	  return typeof attrs === "function" ? attrs() : attrs;
	};
	
	var isTouch = isServer ? false : "ontouchstart" in document.documentElement;
	
	var pointerStartEvent = isTouch ? "click" : "mousedown";
	
	var pointerEndEvent = isTouch ? "click" : "mouseup";
	
	var pointerStartMoveEvent = isTouch ? "touchstart" : "mousedown";
	
	var pointerMoveEvent = isTouch ? "touchmove" : "mousemove";
	
	var pointerEndMoveEvent = isTouch ? "touchend" : "mouseup";
	
	if (isClient) {
	  document.querySelector("html").classList.add(isTouch ? "pe-touch" : "pe-no-touch");
	}
	
	var listeners = {};
	
	// https://gist.github.com/Eartz/fe651f2fadcc11444549
	var throttle = function throttle(func) {
	  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.05;
	  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isClient ? window : {};
	
	  var wait = false;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var later = function later() {
	      return func.apply(context, args);
	    };
	    if (!wait) {
	      later();
	      wait = true;
	      setTimeout(function () {
	        return wait = false;
	      }, s);
	    }
	  };
	};
	
	var subscribe = function subscribe(eventName, listener, delay) {
	  listeners[eventName] = listeners[eventName] || [];
	  listeners[eventName].push(delay ? throttle(listener, delay) : listener);
	};
	
	var unsubscribe = function unsubscribe(eventName, listener) {
	  if (!listeners[eventName]) {
	    return;
	  }
	  var index = listeners[eventName].indexOf(listener);
	  if (index > -1) {
	    listeners[eventName].splice(index, 1);
	  }
	};
	
	var emit = function emit(eventName, event) {
	  if (!listeners[eventName]) {
	    return;
	  }
	  listeners[eventName].forEach(function (listener) {
	    return listener(event);
	  });
	};
	
	if (isClient) {
	  window.addEventListener("resize", function (e) {
	    return emit("resize", e);
	  });
	  window.addEventListener("scroll", function (e) {
	    return emit("scroll", e);
	  });
	  window.addEventListener("keydown", function (e) {
	    return emit("keydown", e);
	  });
	  window.addEventListener(pointerEndEvent, function (e) {
	    return emit(pointerEndEvent, e);
	  });
	}
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*
	Helper module to manage multiple items of the same component type.
	*/
	
	var Multi = function Multi(_ref) {
	  var mOptions = _ref.options,
	      renderer = _ref.renderer;
	
	
	  var items = []; // This is shared between all instances of a type (Dialog, Notification, ...)
	  var current = void 0;
	
	  var getInitialState = function getInitialState(vnode, createStream) {
	    current = createStream(null);
	    return {
	      current: current,
	      redrawOnUpdate: createStream.merge([current])
	    };
	  };
	
	  /*
	  @param e: { id, eventName }
	  */
	  var onChange = function onChange(e) {
	    if (!current) {
	      console.error("Cannot set state. Did you set a root element like Dialog to show instances?"); // eslint-disable-line no-console
	    }
	    current(e.id);
	    emit(mOptions.name, e);
	  };
	
	  var itemIndex = function itemIndex(id) {
	    var item = findItem(id);
	    return items.indexOf(item);
	  };
	
	  var removeItem = function removeItem(id) {
	    var index = itemIndex(id);
	    if (index !== -1) {
	      items.splice(index, 1);
	      onChange({ id: id, name: "removeItem" });
	    }
	  };
	
	  var replaceItem = function replaceItem(id, newItem) {
	    var index = itemIndex(id);
	    if (index !== -1) {
	      items[index] = newItem;
	    }
	  };
	
	  var findItem = function findItem(id) {
	    // traditional for loop for IE10
	    for (var i = 0; i < items.length; i++) {
	      if (items[i].instanceId === id) {
	        return items[i];
	      }
	    }
	  };
	
	  var next = function next() {
	    if (items.length) {
	      items[0].show = true;
	    }
	    onChange({ id: items.length ? items[0].instanceId : null, name: "next" });
	  };
	
	  var remove = function remove() {
	    var instanceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mOptions.defaultId;
	
	    if (mOptions.queue) {
	      items.shift();
	      next();
	    } else {
	      removeItem(instanceId);
	    }
	  };
	
	  var removeAll = function removeAll() {
	    items.length = 0;
	    onChange({ id: null, name: "removeAll" });
	  };
	
	  var setPauseState = function setPauseState(pause, instanceId) {
	    var item = findItem(instanceId);
	    if (item) {
	      item.pause = pause;
	      item.unpause = !pause;
	      onChange({ id: instanceId, name: pause ? "pause" : "unpause" });
	    }
	  };
	
	  var createItem = function createItem(itemAttrs, instanceId, spawn) {
	    var resolveShow = void 0;
	    var resolveHide = void 0;
	    var attrs = unpackAttrs(itemAttrs);
	
	    var didShow = function didShow() {
	      if (attrs.didShow) {
	        attrs.didShow(instanceId);
	      }
	      onChange({ id: instanceId, name: "didShow" });
	      return resolveShow(instanceId);
	    };
	    var showPromise = new Promise(function (resolve) {
	      return resolveShow = resolve;
	    });
	
	    var didHide = function didHide() {
	      if (attrs.didHide) {
	        attrs.didHide(instanceId);
	      }
	      onChange({ id: instanceId, name: "didHide" });
	      remove(instanceId);
	      return resolveHide(instanceId);
	    };
	
	    var hidePromise = new Promise(function (resolve) {
	      return resolveHide = resolve;
	    });
	
	    return _extends({}, mOptions, {
	      instanceId: instanceId,
	      spawn: spawn,
	      attrs: itemAttrs,
	      show: mOptions.queue ? false : true,
	      showPromise: showPromise,
	      hidePromise: hidePromise,
	      didShow: didShow,
	      didHide: didHide
	    });
	  };
	
	  var count = function count() {
	    return items.length;
	  };
	  var pause = function pause() {
	    var instanceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mOptions.defaultId;
	    return setPauseState(true, instanceId);
	  };
	  var unpause = function unpause() {
	    var instanceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mOptions.defaultId;
	    return setPauseState(false, instanceId);
	  };
	
	  var show = function show() {
	    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var spawnOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var instanceId = spawnOpts.id || mOptions.defaultId;
	    var spawn = spawnOpts.spawn || mOptions.defaultId;
	    var item = createItem(attrs, instanceId, spawn);
	    onChange({ id: instanceId, name: "show" });
	    if (mOptions.queue) {
	      items.push(item);
	      if (items.length === 1) {
	        next();
	      }
	    } else {
	      var storedItem = findItem(instanceId);
	      if (!storedItem) {
	        items.push(item);
	      } else {
	        replaceItem(instanceId, item);
	      }
	    }
	    return item.showPromise;
	  };
	
	  var hide = function hide() {
	    var spawnOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var instanceId = spawnOpts.id || mOptions.defaultId;
	    var item = mOptions.queue && items.length ? items[0] : findItem(instanceId);
	    if (item) {
	      item.hide = true;
	    }
	    onChange({ id: instanceId, name: "hide" });
	    return item ? item.hidePromise : Promise.resolve(instanceId);
	  };
	
	  var clear = removeAll;
	
	  var view = function view(_ref2) {
	    var attrs = _ref2.attrs;
	
	    var spawn = attrs.spawn || mOptions.defaultId;
	    var candidates = items.filter(function (item) {
	      return item.show && item.spawn === spawn;
	    });
	    if (mOptions.htmlShowClass && isClient && document.documentElement) {
	      document.documentElement.classList[candidates.length ? "add" : "remove"](mOptions.htmlShowClass);
	    }
	    return !candidates.length ? renderer(mOptions.placeholder) // placeholder because we cannot return null
	    : renderer(mOptions.holderSelector, {
	      className: attrs.position === "container" ? "pe-multiple--container" : "pe-multiple--screen"
	    }, candidates.map(function (itemData) {
	      return renderer(mOptions.instance, _extends({}, {
	        key: itemData.key,
	        instanceId: itemData.instanceId,
	        transitions: mOptions.transitions,
	        holderSelector: mOptions.holderSelector,
	        className: mOptions.className,
	        showInstance: itemData.show,
	        hideInstance: itemData.hide,
	        pauseInstance: itemData.pause,
	        unpauseInstance: itemData.unpause,
	        multipleDidShow: itemData.didShow,
	        multipleDidHide: itemData.didHide,
	        multipleClear: clear
	      }, unpackAttrs(itemData.attrs)));
	    }));
	  };
	
	  return {
	    clear: clear,
	    count: count,
	    getInitialState: getInitialState,
	    hide: hide,
	    pause: pause,
	    remove: remove,
	    show: show,
	    unpause: unpause,
	    view: view
	  };
	};
	
	Multi.displayName = "Multi";
	
	/*
	Generic show/hide transition module
	*/
	
	// defaults
	var SHOW_DURATION = .220; // default dialog timing
	var HIDE_DURATION = .200; // default dialog timing
	var SHOW_DELAY = 0;
	var HIDE_DELAY = 0;
	var TRANSITION = "both";
	
	// See: transition
	var show = function show(opts) {
	  return transition(opts, "show");
	};
	
	var hide = function hide(opts) {
	  return transition(opts, "hide");
	};
	
	var getTiming = function getTiming(opts, state, showAttr, hideAttr, defaultShowTiming, defaultHideTiming) {
	  var transition = opts.transition || TRANSITION;
	  if (transition === "none") {
	    return 0;
	  } else if (transition === "show" && state === "hide") {
	    return 0;
	  } else if (transition === "hide" && state === "show") {
	    return 0;
	  } else {
	    // both
	    return state === "show" ? opts[showAttr] !== undefined ? opts[showAttr] : defaultShowTiming : opts[hideAttr] !== undefined ? opts[hideAttr] : defaultHideTiming;
	  }
	};
	
	/*
	opts:
	- transition
	- showDuration
	- hideDuration
	
	- state (show, hide)
	*/
	var getDuration = function getDuration(opts, state) {
	  return getTiming(opts, state, "showDuration", "hideDuration", SHOW_DURATION, HIDE_DURATION);
	};
	
	/*
	opts:
	- transition (show, hide, both)
	- showDelay
	- hideDelay
	
	- state (show, hide)
	*/
	var getDelay = function getDelay(opts, state) {
	  return getTiming(opts, state, "showDelay", "hideDelay", SHOW_DELAY, HIDE_DELAY);
	};
	
	/*
	opts:
	- el
	- duration
	- delay
	- showClass
	- beforeShow
	- show
	- hide
	- afterHide
	- showDelay
	- hideDelay
	
	- state (show, hide)
	*/
	var transition = function transition(opts, state) {
	  var el = opts.el;
	  if (!el) {
	    return Promise.resolve();
	  } else {
	    return new Promise(function (resolve) {
	      var transitionDuration = getDuration(opts, state) * 1000;
	      var delay = getDelay(opts, state) * 1000;
	      var style = el.style;
	      var beforeTransition = opts.beforeShow && state === "show" ? function () {
	        style.transitionDuration = "0ms";
	        style.transitionDelay = "0ms";
	        opts.beforeShow();
	      } : null;
	
	      var afterTransition = opts.afterHide && state === "hide" ? function () {
	        return opts.afterHide();
	      } : null;
	
	      var applyTransition = function applyTransition() {
	        style.transitionDuration = transitionDuration + "ms";
	        style.transitionDelay = delay + "ms";
	
	        if (opts.showClass) {
	          el.classList[state === "show" ? "add" : "remove"](opts.showClass);
	        }
	        if (opts.show && typeof opts.show === "function" && state === "show") {
	          opts.show();
	        }
	        if (opts.hide && typeof opts.hide === "function" && state === "hide") {
	          opts.hide();
	        }
	      };
	
	      var doTransition = function doTransition() {
	        applyTransition();
	        setTimeout(function () {
	          if (afterTransition) {
	            afterTransition();
	          }
	          resolve();
	        }, transitionDuration + delay);
	      };
	
	      var maybeDelayTransition = function maybeDelayTransition() {
	        if (transitionDuration === 0) {
	          doTransition();
	        } else {
	          setTimeout(doTransition, 0);
	        }
	      };
	
	      if (beforeTransition) {
	        beforeTransition();
	        el.offsetHeight; // force reflow
	        setTimeout(function () {
	          maybeDelayTransition();
	        }, 0);
	      } else {
	        maybeDelayTransition();
	      }
	    });
	  }
	};
	
	exports.getAnimationEndEvent = getAnimationEndEvent;
	exports.Conditional = Conditional;
	exports.filterSupportedAttributes = filterSupportedAttributes;
	exports.unpackAttrs = unpackAttrs;
	exports.isClient = isClient;
	exports.isServer = isServer;
	exports.isTouch = isTouch;
	exports.pointerStartEvent = pointerStartEvent;
	exports.pointerEndEvent = pointerEndEvent;
	exports.pointerStartMoveEvent = pointerStartMoveEvent;
	exports.pointerMoveEvent = pointerMoveEvent;
	exports.pointerEndMoveEvent = pointerEndMoveEvent;
	exports.Multi = Multi;
	exports.show = show;
	exports.hide = hide;
	exports.throttle = throttle;
	exports.subscribe = subscribe;
	exports.unsubscribe = unsubscribe;
	exports.emit = emit;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core.js.map


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(5), __webpack_require__(113), __webpack_require__(108), __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-hyperscript', 'react-dom', 'polythene-core'], factory) :
		(factory((global.polythene = {}),global.react,global['react-hyperscript'],global['react-dom'],global['polythene-core']));
	}(this, (function (exports,React,h,ReactDOM,polytheneCore) { 'use strict';
	
	React = React && React.hasOwnProperty('default') ? React['default'] : React;
	h = h && h.hasOwnProperty('default') ? h['default'] : h;
	ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
	
	var keys = {
	  autocomplete: "autoComplete",
	  autofocus: "autoFocus",
	  class: "className",
	  className: "className",
	  enctype: "encType",
	  formaction: "formAction",
	  maxlength: "maxLength",
	  minlength: "minLength",
	  onblur: "onBlur",
	  onchange: "onChange",
	  onclick: "onClick",
	  onfocus: "onFocus",
	  oninput: "onInput",
	  onkeydown: "onKeyDown",
	  onkeyup: "onKeyUp",
	  onmousedown: "onMouseDown",
	  onmouseout: "onMouseOut",
	  onmouseover: "onMouseOver",
	  onmouseup: "onMouseUp",
	  onscroll: "onScroll",
	  onsubmit: "onSubmit",
	  ontouchend: "onTouchEnd",
	  ontouchmove: "onTouchMove",
	  ontouchstart: "onTouchStart",
	  readonly: "readOnly",
	  tabindex: "tabIndex"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	Takes a Mithril component object and returns a React component (for keys oninit and view).
	Automatically redraws when the stream `vnode.state.redrawOnUpdate` exists, and the stream is updated.
	
	Example: 
	
	import stream from "mithril/stream";
	import { renderer as h, RaisedButton } from "polythene-react";
	
	const StateComponent = {
	  oninit: vnode => {
	    const checked = stream(false);
	    Object.assign(vnode.state, {
	      checked,
	      redrawOnUpdate: stream.merge([checked])
	    });
	  },
	  view: vnode => {
	    const state = vnode.state;
	    const attrs = vnode.attrs;
	    const checked = state.checked();
	    return h(RaisedButton, {
	      label: `Click ${attrs.subject} to switch ${checked ? "Off" : "On"}`,
	      events: {
	        [keys.onclick]: () => state.checked(!checked)
	      }
	    });
	  }
	};
	
	h(StateComponent, { subject: "airco"});
	*/
	
	var MithrilToReact = function MithrilToReact(component) {
	  return function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      var vnode = _extends({}, component, {
	        state: {},
	        attrs: _this.props,
	        redrawValues: undefined
	      });
	      if (component.oninit) {
	        component.oninit(vnode);
	      }
	      _this.state = vnode;
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this._mounted = true;
	        this.state.state.redrawOnUpdate && this.state.state.redrawOnUpdate.map(function (values) {
	          if (_this2._mounted) {
	            _this2.setState({ redrawValues: values });
	          }
	        });
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this._mounted = false;
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return component.view({ state: this.state.state, attrs: this.props }, this.props.children);
	      }
	    }]);
	
	    return _class;
	  }(React.Component);
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var renderer = function renderer() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return _typeof(args[0]) === "object" ? h.call.apply(h, [null, MithrilToReact(args[0])].concat(_toConsumableArray(args.slice(1)))) : h.call.apply(h, [null].concat(args));
	};
	
	renderer.trust = function (html) {
	  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "div";
	
	  if (html == null) html = "";
	  return h(element, {
	    dangerouslySetInnerHTML: { __html: html }
	  });
	};
	
	renderer.displayName = "react";
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var stream$2 = createCommonjsModule(function (module) {
		/* eslint-disable */
		(function () {
			var guid = 0,
			    HALT = {};
			function createStream() {
				function stream() {
					if (arguments.length > 0 && arguments[0] !== HALT) updateStream(stream, arguments[0]);
					return stream._state.value;
				}
				initStream(stream);
	
				if (arguments.length > 0 && arguments[0] !== HALT) updateStream(stream, arguments[0]);
	
				return stream;
			}
			function initStream(stream) {
				stream.constructor = createStream;
				stream._state = { id: guid++, value: undefined, state: 0, derive: undefined, recover: undefined, deps: {}, parents: [], endStream: undefined, unregister: undefined };
				stream.map = stream["fantasy-land/map"] = map, stream["fantasy-land/ap"] = ap, stream["fantasy-land/of"] = createStream;
				stream.valueOf = valueOf, stream.toJSON = toJSON, stream.toString = valueOf;
	
				Object.defineProperties(stream, {
					end: { get: function get() {
							if (!stream._state.endStream) {
								var endStream = createStream();
								endStream.map(function (value) {
									if (value === true) {
										unregisterStream(stream);
										endStream._state.unregister = function () {
											unregisterStream(endStream);
										};
									}
									return value;
								});
								stream._state.endStream = endStream;
							}
							return stream._state.endStream;
						} }
				});
			}
			function updateStream(stream, value) {
				updateState(stream, value);
				for (var id in stream._state.deps) {
					updateDependency(stream._state.deps[id], false);
				}if (stream._state.unregister != null) stream._state.unregister();
				finalize(stream);
			}
			function updateState(stream, value) {
				stream._state.value = value;
				stream._state.changed = true;
				if (stream._state.state !== 2) stream._state.state = 1;
			}
			function updateDependency(stream, mustSync) {
				var state = stream._state,
				    parents = state.parents;
				if (parents.length > 0 && parents.every(active) && (mustSync || parents.some(changed))) {
					var value = stream._state.derive();
					if (value === HALT) return false;
					updateState(stream, value);
				}
			}
			function finalize(stream) {
				stream._state.changed = false;
				for (var id in stream._state.deps) {
					stream._state.deps[id]._state.changed = false;
				}
			}
	
			function combine(fn, streams) {
				if (!streams.every(valid)) throw new Error("Ensure that each item passed to stream.combine/stream.merge is a stream");
				return initDependency(createStream(), streams, function () {
					return fn.apply(this, streams.concat([streams.filter(changed)]));
				});
			}
	
			function initDependency(dep, streams, derive) {
				var state = dep._state;
				state.derive = derive;
				state.parents = streams.filter(notEnded);
	
				registerDependency(dep, state.parents);
				updateDependency(dep, true);
	
				return dep;
			}
			function registerDependency(stream, parents) {
				for (var i = 0; i < parents.length; i++) {
					parents[i]._state.deps[stream._state.id] = stream;
					registerDependency(stream, parents[i]._state.parents);
				}
			}
			function unregisterStream(stream) {
				for (var i = 0; i < stream._state.parents.length; i++) {
					var parent = stream._state.parents[i];
					delete parent._state.deps[stream._state.id];
				}
				for (var id in stream._state.deps) {
					var dependent = stream._state.deps[id];
					var index = dependent._state.parents.indexOf(stream);
					if (index > -1) dependent._state.parents.splice(index, 1);
				}
				stream._state.state = 2; //ended
				stream._state.deps = {};
			}
	
			function map(fn) {
				return combine(function (stream) {
					return fn(stream());
				}, [this]);
			}
			function ap(stream) {
				return combine(function (s1, s2) {
					return s1()(s2());
				}, [stream, this]);
			}
			function valueOf() {
				return this._state.value;
			}
			function toJSON() {
				return this._state.value != null && typeof this._state.value.toJSON === "function" ? this._state.value.toJSON() : this._state.value;
			}
	
			function valid(stream) {
				return stream._state;
			}
			function active(stream) {
				return stream._state.state === 1;
			}
			function changed(stream) {
				return stream._state.changed;
			}
			function notEnded(stream) {
				return stream._state.state !== 2;
			}
	
			function merge(streams) {
				return combine(function () {
					return streams.map(function (s) {
						return s();
					});
				}, streams);
			}
	
			function scan(reducer, seed, stream) {
				var newStream = combine(function (s) {
					return seed = reducer(seed, s._state.value);
				}, [stream]);
	
				if (newStream._state.state === 0) newStream(seed);
	
				return newStream;
			}
	
			function scanMerge(tuples, seed) {
				var streams = tuples.map(function (tuple) {
					var stream = tuple[0];
					if (stream._state.state === 0) stream(undefined);
					return stream;
				});
	
				var newStream = combine(function () {
					var changed = arguments[arguments.length - 1];
	
					streams.forEach(function (stream, idx) {
						if (changed.indexOf(stream) > -1) {
							seed = tuples[idx][1](seed, stream._state.value);
						}
					});
	
					return seed;
				}, streams);
	
				return newStream;
			}
	
			createStream["fantasy-land/of"] = createStream;
			createStream.merge = merge;
			createStream.combine = combine;
			createStream.scan = scan;
			createStream.scanMerge = scanMerge;
			createStream.HALT = HALT;
	
			module["exports"] = createStream;
		})();
	});
	
	var stream = stream$2;
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var requiresKeys = true;
	
	var StateComponent = function StateComponent(_ref) {
	  var _ref$createContent = _ref.createContent,
	      createContent = _ref$createContent === undefined ? function () {} : _ref$createContent,
	      _ref$createProps = _ref.createProps,
	      createProps = _ref$createProps === undefined ? function () {
	    return {};
	  } : _ref$createProps,
	      _ref$getElement = _ref.getElement,
	      getElement = _ref$getElement === undefined ? function () {
	    return "div";
	  } : _ref$getElement,
	      component = _ref.component,
	      _ref$getInitialState = _ref.getInitialState,
	      getInitialState = _ref$getInitialState === undefined ? function () {
	    return {};
	  } : _ref$getInitialState,
	      _ref$onMount = _ref.onMount,
	      onMount = _ref$onMount === undefined ? function () {} : _ref$onMount,
	      _ref$onUnMount = _ref.onUnMount,
	      onUnMount = _ref$onUnMount === undefined ? function () {} : _ref$onUnMount,
	      _ref$onUpdate = _ref.onUpdate,
	      onUpdate = _ref$onUpdate === undefined ? function () {} : _ref$onUpdate,
	      _ref$view = _ref.view,
	      view = _ref$view === undefined ? null : _ref$view;
	
	
	  return function (_React$Component) {
	    _inherits$1(_class, _React$Component);
	
	    function _class(props) {
	      _classCallCheck$1(this, _class);
	
	      var _this = _possibleConstructorReturn$1(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _this.dom = null;
	      var protoState = _extends$1({}, component, _this.createVirtualNode(), {
	        redrawValues: undefined
	      });
	      _this.state = getInitialState(protoState, stream);
	      _this.registerDOM = _this.registerDOM.bind(_this);
	      _this._render = _this._render.bind(_this);
	      return _this;
	    }
	
	    _createClass$1(_class, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this._mounted = true;
	        this.state.redrawOnUpdate && this.state.redrawOnUpdate.map(function (values) {
	          return _this2._mounted && _this2.setState({ redrawValues: values });
	        });
	        onMount(this.createVirtualNode(), { keys: keys });
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        onUpdate(this.createVirtualNode());
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this._mounted = false;
	        onUnMount(this.createVirtualNode());
	      }
	    }, {
	      key: "createVirtualNode",
	      value: function createVirtualNode() {
	        return {
	          state: this.state,
	          attrs: this.props,
	          children: this.props.children,
	          dom: this.dom
	        };
	      }
	    }, {
	      key: "registerDOM",
	      value: function registerDOM(el) {
	        if (polytheneCore.isClient && !this.dom && el) {
	          this.dom = el instanceof HTMLElement ? el : ReactDOM.findDOMNode(el);
	        }
	      }
	    }, {
	      key: "_render",
	      value: function _render() {
	        var vnode = this.createVirtualNode();
	        return renderer(component || getElement(vnode), _extends$1({}, createProps(vnode, { renderer: renderer, requiresKeys: requiresKeys, keys: keys }), { ref: this.registerDOM }), [vnode.attrs.before, createContent(vnode, { renderer: renderer, requiresKeys: requiresKeys, keys: keys }), vnode.attrs.after]);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return view ? view(this.createVirtualNode(), { renderer: renderer, render: this._render }) : this._render(this.props);
	      }
	    }]);
	
	    return _class;
	  }(React.Component);
	};
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var requiresKeys$1 = true;
	
	var ViewComponent = function ViewComponent(_ref) {
	  var _ref$createContent = _ref.createContent,
	      createContent = _ref$createContent === undefined ? function () {} : _ref$createContent,
	      _ref$createProps = _ref.createProps,
	      createProps = _ref$createProps === undefined ? function () {
	    return {};
	  } : _ref$createProps,
	      _ref$getElement = _ref.getElement,
	      getElement = _ref$getElement === undefined ? function () {
	    return "div";
	  } : _ref$getElement,
	      _ref$onMount = _ref.onMount,
	      onMount = _ref$onMount === undefined ? function () {} : _ref$onMount,
	      _ref$onUnMount = _ref.onUnMount,
	      onUnMount = _ref$onUnMount === undefined ? function () {} : _ref$onUnMount,
	      component = _ref.component,
	      _ref$view = _ref.view,
	      view = _ref$view === undefined ? null : _ref$view;
	
	
	  return function (_React$Component) {
	    _inherits$2(_class, _React$Component);
	
	    function _class(props) {
	      _classCallCheck$2(this, _class);
	
	      var _this = _possibleConstructorReturn$2(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _this.dom = null;
	      _this.registerDOM = _this.registerDOM.bind(_this);
	      _this._render = _this._render.bind(_this);
	      return _this;
	    }
	
	    _createClass$2(_class, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        onMount(this.createVirtualNode(), { keys: keys });
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        onUnMount(this.createVirtualNode());
	      }
	    }, {
	      key: "createVirtualNode",
	      value: function createVirtualNode() {
	        var props = _extends$2({}, this.props);
	        return {
	          attrs: props,
	          children: props.children,
	          dom: this.dom
	        };
	      }
	    }, {
	      key: "registerDOM",
	      value: function registerDOM(el) {
	        if (polytheneCore.isClient && !this.dom && el) {
	          this.dom = el instanceof HTMLElement ? el : ReactDOM.findDOMNode(el);
	        }
	      }
	    }, {
	      key: "_render",
	      value: function _render() {
	        var vnode = this.createVirtualNode();
	        return renderer(component || getElement(vnode), _extends$2({}, createProps(vnode, { renderer: renderer, requiresKeys: requiresKeys$1, keys: keys }), { ref: this.registerDOM }), [vnode.attrs.before, createContent(vnode, { renderer: renderer, requiresKeys: requiresKeys$1, keys: keys }), vnode.attrs.after]);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return view ? view(this.createVirtualNode(), { renderer: renderer, render: this._render }) : this._render(this.props);
	      }
	    }]);
	
	    return _class;
	  }(React.Component);
	};
	
	exports.keys = keys;
	exports.MithrilToReact = MithrilToReact;
	exports.renderer = renderer;
	exports.StateComponent = StateComponent;
	exports.ViewComponent = ViewComponent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-base.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(106)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-style'], factory) :
		(factory((global.polythene = {}),global['polythene-style']));
	}(this, (function (exports,polytheneStyle) { 'use strict';
	
	// Placeholder for custom theme config file
	// In your app paths setup, change the current path to your custom config file; see the theme README.
	
	// Example:
	
	// export const componentConfig = {
	//     Button: vars => {
	//         const mainColor = '#e4521b';
	//         const textColor = '#fff';
	//         const newVars = Object.assign(
	//           {},
	//           vars,
	//           {
	//             border_radius:                        0,
	//             color_light_raised_normal_background: mainColor,
	//             color_light_raised_normal_text:       textColor,
	//             color_dark_raised_normal_background:  mainColor,
	//             color_dark_raised_normal_text:        textColor
	//           }
	//         );
	//         return [
	//             { '': vars }, // default vars for all pages
	//             { '.example-custom-theme ': newVars } // custom vars for this selector
	//         ];
	//     }
	// };
	
	var componentConfig = {};
	
	exports.vars = polytheneStyle.vars;
	exports.componentConfig = componentConfig;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-theme.js.map


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(68), __webpack_require__(41)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-icon', 'polythene-react-svg'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-icon'],global['polythene-react-svg']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreIcon,polytheneReactSvg) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Icon = polytheneReactBase.ViewComponent(_extends({}, polytheneCoreIcon.coreIcon, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreIcon.coreIcon.createProps(vnode, _extends(args, { SVG: polytheneReactSvg.SVG }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreIcon.coreIcon.createContent(vnode, _extends(args, { SVG: polytheneReactSvg.SVG }));
	  }
	}));
	
	Icon.displayName = "Icon";
	
	exports.Icon = Icon;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-icon.js.map


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(80)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-shadow'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-shadow']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreShadow) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Shadow = polytheneReactBase.ViewComponent(_extends({}, polytheneCoreShadow.coreShadow));
	
	Shadow.displayName = "Shadow";
	
	exports.Shadow = Shadow;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-shadow.js.map


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-control",
	
	  // elements
	  formLabel: "pe-control__form-label",
	  input: "pe-control__input",
	  label: "pe-control__label",
	
	  // states
	  disabled: "pe-control--disabled",
	  inactive: "pe-control--inactive",
	  large: "pe-control--large",
	  medium: "pe-control--medium",
	  off: "pe-control--off",
	  on: "pe-control--on",
	  regular: "pe-control--regular",
	  small: "pe-control--small",
	
	  // control view elements
	  box: "pe-control__box",
	  button: "pe-control__button",
	
	  // control view states
	  buttonOff: "pe-control__button--off",
	  buttonOn: "pe-control__button--on"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var sizeClasses = {
	  small: classes.small,
	  regular: classes.regular,
	  medium: classes.medium,
	  large: classes.large
	};
	
	var classForSize = function classForSize() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "regular";
	  return sizeClasses[size];
	};
	
	var currentState = function currentState(attrs, state) {
	  var checked = attrs.checked !== undefined ? attrs.checked : state.checked();
	  var selectable = attrs.selectable !== undefined ? attrs.selectable(checked) : false;
	  var inactive = attrs.disabled || !selectable;
	  return { checked: checked, inactive: inactive };
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var attrs = vnode.attrs;
	  var isChecked = attrs.defaultChecked !== undefined ? attrs.defaultChecked : attrs.checked || false;
	  var checked = createStream(isChecked);
	
	  var notifyChange = function notifyChange(e, isChecked) {
	    if (attrs.onChange) {
	      attrs.onChange({
	        event: e,
	        checked: isChecked,
	        value: attrs.value
	      });
	    }
	  };
	
	  var onChange = function onChange(e) {
	    var isChecked = e.currentTarget.checked;
	    if (attrs.type === "radio") {
	      // do not set directly
	    } else {
	      checked(isChecked);
	    }
	    notifyChange(e, isChecked);
	  };
	
	  var toggle = function toggle(e) {
	    var newChecked = !checked();
	    checked(newChecked);
	    notifyChange(e, newChecked);
	  };
	
	  return {
	    checked: checked,
	    toggle: toggle,
	    onChange: onChange,
	    redrawOnUpdate: createStream.merge([checked])
	  };
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  var state = vnode.state;
	
	  var _currentState = currentState(attrs, state),
	      checked = _currentState.checked,
	      inactive = _currentState.inactive;
	
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.instanceClass, // for instance pe-checkbox-control
	    checked ? classes.on : classes.off, attrs.disabled ? classes.disabled : null, inactive ? classes.inactive : null, classForSize(attrs.size), attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      k = _ref2.keys,
	      ViewControl = _ref2.ViewControl;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  var _currentState2 = currentState(attrs, state),
	      checked = _currentState2.checked,
	      inactive = _currentState2.inactive;
	
	  var viewControlClickHandler = attrs.events && attrs.events[k.onclick];
	  var viewControlKeyDownHandler = attrs.events && attrs.events[k.onkeydown] ? attrs.events[k.onkeydown] : function (e) {
	    if (e.key === "Enter") {
	      if (viewControlClickHandler) {
	        viewControlClickHandler(e);
	      } else {
	        state.toggle(e);
	      }
	    }
	  };
	
	  return h("label", _extends({}, _defineProperty({
	    className: classes.formLabel
	  }, k.onclick, viewControlClickHandler)), [h(ViewControl, _extends({}, attrs, {
	    inactive: inactive,
	    checked: checked,
	    key: "control",
	    events: _defineProperty({}, k.onkeydown, viewControlKeyDownHandler)
	  })), attrs.label ? h("." + classes.label, { key: "label" }, attrs.label) : null, h("input", _extends({}, attrs.events, {
	    name: attrs.name,
	    type: attrs.type,
	    value: attrs.value,
	    checked: checked
	  }, attrs.disabled || inactive ? { disabled: "disabled" } : _defineProperty({}, k.onchange, state.onChange)))]);
	};
	
	var selectionControl = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		createProps: createProps,
		createContent: createContent
	});
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CONTENT = [{ iconType: "iconOn", className: classes.buttonOn }, { iconType: "iconOff", className: classes.buttonOff }];
	
	var getElement$1 = function getElement(vnode) {
	  return vnode.attrs.element || "." + classes.box;
	};
	
	var createIcon = function createIcon(h, iconType, attrs, className) {
	  return (
	    // if attrs.iconOn/attrs.iconOff is passed, use that icon options object and ignore size
	    // otherwise create a new object
	    _extends$1({}, {
	      className: className,
	      key: iconType
	    }, attrs[iconType] ? attrs[iconType] : { svg: { content: h.trust(attrs.icons[iconType]) } }, attrs.icon, attrs.size ? { size: attrs.size } : null)
	  );
	};
	
	var createContent$1 = function createContent(vnode, _ref) {
	  var h = _ref.renderer,
	      Icon = _ref.Icon,
	      IconButton = _ref.IconButton;
	
	  var attrs = vnode.attrs;
	  return h(IconButton, _extends$1({}, {
	    element: "div",
	    key: attrs.key,
	    className: classes.button,
	    content: CONTENT.map(function (o) {
	      return h(Icon, createIcon(h, o.iconType, attrs, o.className));
	    }),
	    ripple: { center: true },
	    disabled: attrs.disabled,
	    events: attrs.events,
	    inactive: attrs.inactive
	  }, attrs.iconButton // for example for hover behaviour
	  ));
	};
	
	var viewControl = Object.freeze({
		getElement: getElement$1,
		createContent: createContent$1
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  label_font_size: 2 * polytheneTheme.vars.grid_unit_component, // 16
	  label_height: 3 * polytheneTheme.vars.grid_unit_component, // 24
	  label_padding_before: polytheneTheme.vars.grid_unit * 4, // 16
	  label_padding_after: 0,
	  button_size: 6 * polytheneTheme.vars.grid_unit_component,
	  icon_size: 3 * polytheneTheme.vars.grid_unit_component,
	  animation_duration: polytheneTheme.vars.animation_duration,
	
	  color_light_on: rgba(polytheneTheme.vars.color_primary),
	  color_light_off: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_label: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_disabled: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	  color_light_thumb_off_focus_opacity: .08,
	  color_light_thumb_on_focus_opacity: .11,
	
	  // icon colors may be set in theme; set to "inherit" by default
	  // color_light_on_icon
	  // color_light_off_icon
	
	  // label on/off colors may be set in theme; set to color_light_label by default
	  // color_light_on_label
	  // color_light_off_label
	
	  color_light_focus_on: rgba(polytheneTheme.vars.color_primary),
	  color_light_focus_on_opacity: .11,
	  color_light_focus_off: rgba(polytheneTheme.vars.color_light_foreground),
	  color_light_focus_off_opacity: .07,
	
	  color_dark_on: rgba(polytheneTheme.vars.color_primary),
	  color_dark_off: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_label: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_disabled: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled),
	  color_dark_thumb_off_focus_opacity: .08,
	  color_dark_thumb_on_focus_opacity: .11,
	
	  // icon color may be set in theme; set to "inherit" by default
	  // color_dark_on_icon
	  // color_dark_off_icon
	
	  // label on/off colors may be set in theme; set to color_dark_label by default
	  // color_dark_on_label
	  // color_dark_off_label
	
	  color_dark_focus_on: rgba(polytheneTheme.vars.color_primary), // or '#80cbc4'
	  color_dark_focus_on_opacity: .14,
	  color_dark_focus_off: rgba(polytheneTheme.vars.color_dark_foreground),
	  color_dark_focus_off_opacity: .09
	};
	
	exports.coreSelectionControl = selectionControl;
	exports.viewControl = viewControl;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-selection-control.js.map


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(22), __webpack_require__(9), __webpack_require__(18)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-icon-button', 'polythene-react-icon', 'polythene-react-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-icon-button'],global['polythene-react-icon'],global['polythene-react-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreIconButton,polytheneReactIcon,polytheneReactButton) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var IconButton = polytheneReactBase.StateComponent(_extends({}, polytheneCoreIconButton.coreIconButton, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreIconButton.coreIconButton.createProps(vnode, _extends(args, { Icon: polytheneReactIcon.Icon }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreIconButton.coreIconButton.createContent(vnode, _extends(args, { Icon: polytheneReactIcon.Icon }));
	  },
	  component: polytheneReactButton.Button
	}));
	
	IconButton.displayName = "IconButton";
	
	exports.IconButton = IconButton;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-icon-button.js.map


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(36), __webpack_require__(25)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-button', 'polythene-react-ripple'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-button'],global['polythene-react-ripple']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreButton,polytheneReactRipple) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Button = polytheneReactBase.StateComponent(_extends({}, polytheneCoreButton.coreButton, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreButton.coreButton.createProps(vnode, _extends(args, { Ripple: polytheneReactRipple.Ripple }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreButton.coreButton.createContent(vnode, _extends(args, { Ripple: polytheneReactRipple.Ripple }));
	  }
	}));
	
	Button.displayName = "Button";
	
	exports.Button = Button;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-button.js.map


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-spinner",
	
	  // elements
	  animation: "pe-spinner__animation",
	  placeholder: "pe-spinner__placeholder",
	
	  // states
	  animated: "pe-spinner--animated",
	  fab: "pe-spinner--fab",
	  large: "pe-spinner--large",
	  medium: "pe-spinner--medium",
	  permanent: "pe-spinner--permanent",
	  raised: "pe-spinner--raised",
	  regular: "pe-spinner--regular",
	  singleColor: "pe-spinner--single-color",
	  small: "pe-spinner--small",
	  visible: "pe-spinner--visible"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var sizeClasses = {
	  small: classes.small,
	  regular: classes.regular,
	  medium: classes.medium,
	  large: classes.large,
	  fab: classes.fab
	};
	
	var classForSize = function classForSize() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "regular";
	  return sizeClasses[size];
	};
	
	var showSpinner = function showSpinner(state, attrs) {
	  if (attrs.onChange) {
	    attrs.onChange({ visible: false, transitioning: true });
	  }
	  return polytheneCore.show(_extends({}, attrs, {
	    el: state.dom(),
	    showClass: classes.visible
	  })).then(function () {
	    if (attrs.onChange) {
	      attrs.onChange({ visible: true, transitioning: false });
	    }
	    if (attrs.didShow) {
	      attrs.didShow(attrs.id);
	    }
	    state.visible(false);
	  });
	};
	
	var hideSpinner = function hideSpinner(state, attrs) {
	  if (attrs.onChange) {
	    attrs.onChange({ visible: true, transitioning: true });
	  }
	  return polytheneCore.hide(_extends({}, attrs, {
	    el: state.dom(),
	    showClass: classes.visible
	  })).then(function () {
	    if (attrs.onChange) {
	      attrs.onChange({ visible: false, transitioning: false });
	    }
	    if (attrs.didHide) {
	      attrs.didHide(attrs.id);
	    }
	    state.visible(false);
	  });
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var visible = createStream(false);
	  var dom = createStream(null);
	  return {
	    dom: dom,
	    visible: visible,
	    redrawOnUpdate: createStream.merge([visible])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.dom(vnode.dom);
	
	  if (!attrs.permanent) {
	    showSpinner(state, attrs);
	  }
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.instanceClass, classForSize(attrs.size), attrs.singleColor ? classes.singleColor : null, attrs.raised ? classes.raised : null, attrs.animated ? classes.animated : null, attrs.permanent ? classes.permanent : null, attrs.permanent ? classes.visible : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.events);
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      Shadow = _ref2.Shadow;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  if (state.hide) {
	    setTimeout(function () {
	      hideSpinner(state, attrs);
	    }, 0);
	  }
	
	  return [attrs.raised && attrs.content ? h(Shadow, { key: "shadow", z: attrs.z }) : null, attrs.content];
	};
	
	var spinner = Object.freeze({
		getInitialState: getInitialState,
		onMount: onMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  size_small: 3 * polytheneTheme.vars.grid_unit_component,
	  size_regular: 4 * polytheneTheme.vars.grid_unit_component,
	  size_medium: 5 * polytheneTheme.vars.grid_unit_component,
	  size_large: 6 * polytheneTheme.vars.grid_unit_component,
	  size_fab: 7 * polytheneTheme.vars.grid_unit_component,
	
	  raisedSize: function raisedSize(size) {
	    var padding = size * 0.25;
	    var paddedSize = size + padding * 2;
	    return { padding: padding, paddedSize: paddedSize };
	  },
	
	  color_light_raised_background: rgba(polytheneTheme.vars.color_light_background),
	  // also use light background with dark tone
	  color_dark_raised_background: rgba(polytheneTheme.vars.color_light_background)
	};
	
	exports.coreBaseSpinner = spinner;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-base-spinner.js.map


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-theme']));
	}(this, (function (exports,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-button pe-icon-button",
	
	  // elements
	  content: "pe-icon-button__content",
	
	  // states
	  compact: "pe-icon-button--compact"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Don't export 'element': it will be the wrapped button component (set in polythene-xxx-icon-button)
	
	// Props to be passed to a button, including 'content'
	
	var createProps = function createProps(vnode, _ref) {
	  var h = _ref.renderer,
	      Icon = _ref.Icon;
	
	  var attrs = vnode.attrs;
	  var content = attrs.content ? attrs.content : attrs.icon ? h(Icon, attrs.icon) : attrs.children || vnode.children;
	  return _extends({}, {
	    content: h("div", { className: classes.content }, content),
	    parentClassName: [attrs.parentClassName || classes.component, attrs.compact ? classes.compact : null].join(" "),
	    // defaults
	    wash: false,
	    animateOnTap: false
	  }, attrs);
	};
	
	var createContent = function createContent() {
	  return null;
	};
	
	var iconButton = Object.freeze({
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var padding = (polytheneTheme.vars.grid_unit_icon_button - polytheneTheme.vars.unit_icon_size) / 2; // 12
	var padding_compact = (polytheneTheme.vars.grid_unit_icon_button - polytheneTheme.vars.unit_icon_size) / 3; // 8
	var color_light = rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary);
	var color_dark = rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary);
	
	var vars$1 = {
	  padding: padding,
	  padding_compact: padding_compact,
	
	  color_background: "transparent", // only specify this variable to get all 2 states
	  // theme specific background colors may be set in theme; disabled by default
	  // color_light_background:    "none",
	  // color_dark_background:     "none",
	
	  color_light: color_light,
	  color_light_disabled: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	  color_light_wash: color_light,
	  color_light_wash_opacity: polytheneTheme.vars.blend_light_background_hover_medium,
	  color_light_focus_opacity: polytheneTheme.vars.blend_light_background_hover_medium,
	
	  color_dark: color_dark,
	  color_dark_disabled: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled),
	  color_dark_wash: color_dark,
	  color_dark_wash_opacity: polytheneTheme.vars.blend_dark_background_hover_medium,
	  color_dark_focus_opacity: polytheneTheme.vars.blend_dark_background_hover_medium
	};
	
	exports.coreIconButton = iconButton;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-icon-button.js.map


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(21), __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-base-spinner', 'polythene-react-shadow'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-base-spinner'],global['polythene-react-shadow']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreBaseSpinner,polytheneReactShadow) { 'use strict';
	
	var classes = {
	  component: "pe-spinner",
	
	  // elements
	  animation: "pe-spinner__animation",
	  placeholder: "pe-spinner__placeholder",
	
	  // states
	  animated: "pe-spinner--animated",
	  fab: "pe-spinner--fab",
	  large: "pe-spinner--large",
	  medium: "pe-spinner--medium",
	  permanent: "pe-spinner--permanent",
	  raised: "pe-spinner--raised",
	  regular: "pe-spinner--regular",
	  singleColor: "pe-spinner--single-color",
	  small: "pe-spinner--small",
	  visible: "pe-spinner--visible"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var BaseSpinner = polytheneReactBase.StateComponent(_extends({}, polytheneCoreBaseSpinner.coreBaseSpinner, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreBaseSpinner.coreBaseSpinner.createContent(vnode, _extends(args, { Shadow: polytheneReactShadow.Shadow }));
	  }
	}));
	
	BaseSpinner.classes = classes;
	BaseSpinner.displayName = "BaseSpinner";
	
	exports.BaseSpinner = BaseSpinner;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-base-spinner.js.map


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(70), __webpack_require__(9), __webpack_require__(25)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-list-tile', 'polythene-react-icon', 'polythene-react-ripple'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-list-tile'],global['polythene-react-icon'],global['polythene-react-ripple']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreListTile,polytheneReactIcon,polytheneReactRipple) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ListTile = polytheneReactBase.ViewComponent(_extends({}, polytheneCoreListTile.coreListTile, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreListTile.coreListTile.createProps(vnode, _extends(args, { Icon: polytheneReactIcon.Icon, Ripple: polytheneReactRipple.Ripple }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreListTile.coreListTile.createContent(vnode, _extends(args, { Icon: polytheneReactIcon.Icon, Ripple: polytheneReactRipple.Ripple }));
	  }
	}));
	
	ListTile.displayName = "ListTile";
	
	exports.ListTile = ListTile;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-list-tile.js.map


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(78)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-ripple'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-ripple']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreRipple) { 'use strict';
	
	var Ripple = polytheneReactBase.StateComponent(polytheneCoreRipple.coreRipple);
	
	Ripple.displayName = "Ripple";
	
	exports.Ripple = Ripple;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-ripple.js.map


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core'], factory) :
		(factory((global.polythene = {}),global['polythene-core']));
	}(this, (function (exports,polytheneCore) { 'use strict';
	
	var addWebFont = function addWebFont(vendor, family, key) {
	  if (polytheneCore.isServer) return;
	  if (!window.WebFontConfig) {
	    window.WebFontConfig = {};
	    (function () {
	      var wf = document.createElement("script");
	      wf.src = (document.location.protocol === "https:" ? "https" : "http") + "://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js";
	      wf.type = "text/javascript";
	      wf.async = "true";
	      var s = document.getElementsByTagName("script")[0];
	      if (s) {
	        s.parentNode.insertBefore(wf, s);
	      }
	    })();
	  }
	  var vendorCfg = window.WebFontConfig[vendor] || {};
	  vendorCfg.families = vendorCfg.families || [];
	  vendorCfg.families.push(family);
	  if (key) {
	    vendorCfg.key = key;
	  }
	  window.WebFontConfig[vendor] = vendorCfg;
	};
	
	/*
	https://gist.github.com/gre/1650294
	Easing Functions - inspired from http://gizma.com/easing/
	Only considering the t value for the range [0, 1] => [0, 1]
	*/
	
	var easing = {
	  // no easing, no acceleration
	  linear: function linear(t) {
	    return t;
	  },
	  // accelerating from zero velocity
	  easeInQuad: function easeInQuad(t) {
	    return t * t;
	  },
	  // decelerating to zero velocity
	  easeOutQuad: function easeOutQuad(t) {
	    return t * (2 - t);
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuad: function easeInOutQuad(t) {
	    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	  },
	  // accelerating from zero velocity
	  easeInCubic: function easeInCubic(t) {
	    return t * t * t;
	  },
	  // decelerating to zero velocity
	  easeOutCubic: function easeOutCubic(t) {
	    return --t * t * t + 1;
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutCubic: function easeInOutCubic(t) {
	    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	  },
	  // accelerating from zero velocity
	  easeInQuart: function easeInQuart(t) {
	    return t * t * t * t;
	  },
	  // decelerating to zero velocity
	  easeOutQuart: function easeOutQuart(t) {
	    return 1 - --t * t * t * t;
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuart: function easeInOutQuart(t) {
	    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
	  },
	  // accelerating from zero velocity
	  easeInQuint: function easeInQuint(t) {
	    return t * t * t * t * t;
	  },
	  // decelerating to zero velocity
	  easeOutQuint: function easeOutQuint(t) {
	    return 1 + --t * t * t * t * t;
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuint: function easeInOutQuint(t) {
	    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
	  }
	};
	
	/*
	 Animated scroll to a position.
	 Derived from https://github.com/madebysource/animated-scrollto
	 Adapted to Mithril and rewritten to es6.
	*/
	
	var scrollTo = function scrollTo(opts) {
	  if (polytheneCore.isServer) {
	    return;
	  }
	  var element = opts.element;
	  var which = opts.direction === "horizontal" ? "scrollLeft" : "scrollTop";
	  var to = opts.to;
	  var duration = opts.duration * 1000;
	  var easingFn = opts.easing || easing.easeInOutCubic;
	  var start = element[which];
	  var change = to - start;
	  var animationStart = new Date().getTime();
	  var animating = true;
	  return new Promise(function (resolve) {
	    var animateScroll = function animateScroll() {
	      if (!animating) {
	        return;
	      }
	      requestAnimFrame(animateScroll);
	      var now = new Date().getTime();
	      var percentage = (now - animationStart) / duration;
	      var val = start + change * easingFn(percentage);
	      element[which] = val;
	      if (percentage >= 1) {
	        element[which] = to;
	        animating = false;
	        resolve();
	      }
	    };
	    requestAnimFrame(animateScroll);
	  });
	};
	
	var requestAnimFrame = polytheneCore.isServer ? function () {} : function () {
	  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
	    return window.setTimeout(callback, 1000 / 60);
	  };
	}();
	
	var Timer = function Timer() {
	  var timerId = void 0,
	      startTime = void 0,
	      remaining = void 0,
	      cb = void 0;
	
	  var stop = function stop() {
	    if (polytheneCore.isClient) {
	      window.clearTimeout(timerId);
	    }
	  };
	
	  var pause = function pause() {
	    return stop(), remaining -= new Date() - startTime;
	  };
	
	  var startTimer = function startTimer() {
	    if (polytheneCore.isClient) {
	      stop();
	      startTime = new Date();
	      timerId = window.setTimeout(cb, remaining);
	    }
	  };
	
	  var start = function start(callback, delaySeconds) {
	    return cb = callback, remaining = delaySeconds * 1000, startTimer();
	  };
	
	  var resume = function resume() {
	    return startTimer();
	  };
	
	  return {
	    start: start,
	    pause: pause,
	    resume: resume,
	    stop: stop
	  };
	};
	
	exports.addWebFont = addWebFont;
	exports.easing = easing;
	exports.scrollTo = scrollTo;
	exports.Timer = Timer;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-utilities.js.map


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  base: "pe-button",
	  component: "pe-button pe-text-button",
	  row: "pe-button-row",
	
	  // elements
	  content: "pe-button__content",
	  focus: "pe-button__focus",
	  label: "pe-button__label",
	  wash: "pe-button__wash",
	
	  // states
	  borders: "pe-button--borders",
	  disabled: "pe-button--disabled",
	  focused: "pe-button--focus",
	  inactive: "pe-button--inactive",
	  selected: "pe-button--selected"
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "a";
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var dom = createStream(null);
	  var focus = createStream(false);
	  var inactive = createStream(false);
	  var mouseover = createStream(false);
	  return {
	    dom: dom,
	    focus: focus,
	    inactive: inactive,
	    mouseover: mouseover,
	    redrawOnUpdate: createStream.merge([dom, focus, inactive, mouseover])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.dom(vnode.dom);
	
	  if (polytheneCore.isClient) {
	    var noink = attrs.ink !== undefined && attrs.ink === false;
	    var handleInactivate = function handleInactivate() {
	      return (
	        // delay a bit so that the ripple can finish before the hover disappears
	        // the timing is crude and does not take the actual ripple "done" into account
	        setTimeout(function () {
	          return state.inactive(true), setTimeout(function () {
	            return state.inactive(false);
	          }, attrs.inactivate * 1000);
	        }, noink ? 0 : 300)
	      );
	    };
	
	    var onFocus = function onFocus() {
	      return state.focus(!state.mouseover());
	    };
	    var onBlur = function onBlur() {
	      return state.focus(false);
	    };
	    var onMouseOver = function onMouseOver() {
	      return state.mouseover(true);
	    };
	    var onMouseOut = function onMouseOut() {
	      return state.mouseover(false);
	    };
	    var onClick = handleInactivate;
	
	    vnode.dom.addEventListener("focus", onFocus, false);
	    vnode.dom.addEventListener("blur", onBlur, false);
	    vnode.dom.addEventListener("mouseover", onMouseOver, false);
	    vnode.dom.addEventListener("mouseout", onMouseOut, false);
	    vnode.dom.addEventListener("click", onClick, false);
	
	    state.removeEventListeners = function () {
	      return vnode.dom.removeEventListener("focus", onFocus, false), vnode.dom.removeEventListener("blur", onBlur, false), vnode.dom.removeEventListener("mouseover", onBlur, false), vnode.dom.removeEventListener("mouseout", onMouseOut, false), vnode.dom.removeEventListener("click", onClick, false);
	    };
	  }
	};
	
	var onUnMount = function onUnMount(vnode) {
	  return vnode.state.removeEventListeners && vnode.state.removeEventListeners();
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var _ref2;
	
	  var k = _ref.keys;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var disabled = attrs.disabled;
	  var inactive = attrs.inactive || state.inactive();
	  var onKeyDownHandler = attrs.events && attrs.events[k.onkeydown] || onClickHandler;
	  var onClickHandler = attrs.events && attrs.events[k.onclick];
	
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs, { add: [k.formaction, "type"], remove: ["style"] }), // Set style on content, not on component
	  {
	    className: [attrs.parentClassName || classes.component, attrs.selected ? classes.selected : null, disabled ? classes.disabled : null, inactive ? classes.inactive : null, attrs.borders ? classes.borders : null, state.focus() ? classes.focused : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.events, inactive ? null : (_ref2 = {}, _defineProperty(_ref2, k.tabindex, disabled || inactive ? -1 : attrs[k.tabindex] || 0), _defineProperty(_ref2, k.onclick, onClickHandler), _defineProperty(_ref2, k.onkeydown, function (e) {
	    if (e.key === "Enter" && state.focus()) {
	      state.focus(false);
	      if (onKeyDownHandler) {
	        onKeyDownHandler(e);
	      }
	    }
	  }), _ref2), attrs.url, disabled ? { disabled: true } : null);
	};
	
	var createContent = function createContent(vnode, _ref3) {
	  var _h;
	
	  var h = _ref3.renderer,
	      k = _ref3.keys,
	      Ripple = _ref3.Ripple;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var noink = attrs.ink !== undefined && attrs.ink === false;
	  var disabled = attrs.disabled;
	  var children = attrs.children || vnode.children;
	  var label = attrs.content ? attrs.content : attrs.label ? _typeof(attrs.label) === "object" ? attrs.label : h("div", { className: classes.label }, attrs.label) : children ? children : null;
	  var noWash = disabled || attrs.wash !== undefined && !attrs.wash;
	  return label ? h("div", (_h = {}, _defineProperty(_h, k.class, classes.content), _defineProperty(_h, "style", attrs.style), _h), [attrs.shadowComponent // "protected" option, used by raised-button
	  ? attrs.shadowComponent : null,
	  // Ripple
	  disabled || noink || !Ripple || (h.displayName === "react" ? !state.dom() : false)
	  // somehow Mithril does not update when the dom stream is updated
	  ? null : h(Ripple, _extends({}, {
	    key: "ripple",
	    target: state.dom()
	  }, attrs.ripple)),
	  // hover
	  noWash ? null : h("div", { key: "wash", className: classes.wash }),
	  // focus
	  disabled ? null : h("div", { key: "focus", className: classes.focus }), label]) : null;
	};
	
	var button = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		onMount: onMount,
		onUnMount: onUnMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var touch_height = polytheneTheme.vars.unit_touch_height;
	var height = 36;
	
	var vars$1 = {
	  margin_h: polytheneTheme.vars.grid_unit,
	  border_radius: polytheneTheme.vars.unit_item_border_radius,
	  font_size: 14,
	  font_weight: 500,
	  outer_padding_v: (touch_height - height) / 2,
	  padding_h: 2 * polytheneTheme.vars.grid_unit,
	  padding_v: 11,
	  min_width: 8 * polytheneTheme.vars.grid_unit_component,
	  text_transform: "uppercase",
	  border_width: 0, // no border in MD, but used to correctly set the height when a theme does set a border
	  animation_duration: polytheneTheme.vars.animation_duration,
	
	  color_light_background: "transparent",
	  color_light_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_light_hover_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  color_light_focus_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  color_light_active_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_active),
	  color_light_disabled_background: "transparent",
	  color_light_disabled_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	
	  // border colors may be set in theme; disabled by default
	  // color_light_border:              "transparent", // only specify this variable to get all 4 states
	  // color_light_hover_border:        "transparent",
	  // color_light_active_border:       "transparent",
	  // color_light_disabled_border:     "transparent",
	
	  color_dark_background: "transparent",
	  color_dark_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_hover_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_hover),
	  color_dark_focus_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_hover),
	  color_dark_active_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_active),
	  color_dark_disabled_background: "transparent",
	  color_dark_disabled_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled)
	
	  // border colors may be set in theme; disabled by default
	  // color_dark_border:               "transparent", // only specify this variable to get all 4 states
	  // color_dark_hover_border:         "transparent",
	  // color_dark_active_border:        "transparent",
	  // color_dark_disabled_border:      "transparent"
	};
	
	exports.coreButton = button;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-button.js.map


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(26), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-utilities', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-utilities'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneUtilities,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-notification",
	
	  // elements
	  action: "pe-notification__action",
	  content: "pe-notification__content",
	  holder: "pe-notification__holder",
	  placeholder: "pe-notification__placeholder",
	  title: "pe-notification__title",
	
	  // states
	  hasContainer: "pe-notification--container",
	  horizontal: "pe-notification--horizontal",
	  multilineTitle: "pe-notification__title--multi-line",
	  vertical: "pe-notification--vertical"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DEFAULT_TIME_OUT = 3;
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var pauseInstance = function pauseInstance(state) {
	  state.paused(true);
	  if (state.timer) {
	    state.timer.pause();
	  }
	};
	
	var unpauseInstance = function unpauseInstance(state) {
	  state.paused(false);
	  if (state.timer) {
	    state.timer.resume();
	  }
	};
	
	var stopTimer = function stopTimer(state) {
	  if (state.timer) {
	    state.timer.stop();
	  }
	};
	
	var prepareShow = function prepareShow(state, attrs) {
	  if (!state.containerEl && polytheneCore.isClient) {
	    // attrs.holderSelector is passed as option to Multiple
	    state.containerEl = document.querySelector(attrs.containerSelector || attrs.holderSelector);
	  }
	  if (!state.containerEl && polytheneCore.isClient) {
	    console.error("No container element found"); // eslint-disable-line no-console
	  }
	  if (attrs.containerSelector && state.containerEl) {
	    state.containerEl.classList.add(classes.hasContainer);
	  }
	};
	
	var showInstance = function showInstance(state, attrs) {
	  if (state.transitioning()) {
	    return Promise.resolve();
	  }
	  state.transitioning(true);
	  stopTimer(state);
	  prepareShow(state, attrs);
	  var id = attrs.instanceId;
	  var transitions = attrs.transitions;
	  return polytheneCore.show(_extends({}, attrs, transitions.show(_extends({}, attrs, {
	    containerEl: state.containerEl,
	    el: state.el
	  })))).then(function () {
	    if (attrs.multipleDidShow) {
	      attrs.multipleDidShow(id); // this will call attrs.didShow
	    }
	    // set timer to hide in a few seconds
	    var timeout = attrs.timeout;
	    if (timeout === 0) {
	      // do not time out
	    } else {
	      var timeoutSeconds = timeout !== undefined ? timeout : DEFAULT_TIME_OUT;
	      state.timer.start(function () {
	        hideInstance(state, attrs);
	      }, timeoutSeconds);
	    }
	    state.visible(true);
	    state.transitioning(false);
	  });
	};
	
	var hideInstance = function hideInstance(state, attrs) {
	  if (state.transitioning()) {
	    return Promise.resolve();
	  }
	  state.transitioning(true);
	  stopTimer(state);
	  var id = attrs.instanceId;
	  var transitions = attrs.transitions;
	  return polytheneCore.hide(_extends({}, attrs, transitions.hide(_extends({}, attrs, {
	    containerEl: state.containerEl,
	    el: state.el
	  })))).then(function () {
	    if (attrs.multipleDidHide) {
	      attrs.multipleDidHide(id); // this will call attrs.didHide
	    }
	    state.visible(false);
	    state.transitioning(false);
	  });
	};
	
	var setTitleStyles = function setTitleStyles(titleEl) {
	  if (polytheneCore.isServer) return;
	  var height = titleEl.getBoundingClientRect().height;
	  var lineHeight = parseInt(window.getComputedStyle(titleEl).lineHeight, 10);
	  var paddingTop = parseInt(window.getComputedStyle(titleEl).paddingTop, 10);
	  var paddingBottom = parseInt(window.getComputedStyle(titleEl).paddingBottom, 10);
	  if (height > lineHeight + paddingTop + paddingBottom) {
	    titleEl.classList.add(classes.multilineTitle);
	  }
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var transitioning = createStream(false);
	  var paused = createStream(false);
	  var mounted = createStream(false);
	  var visible = createStream(false);
	  return {
	    cleanUp: undefined,
	    containerEl: undefined,
	    dismissEl: undefined,
	    el: undefined,
	    timer: new polytheneUtilities.Timer(),
	    paused: paused,
	    transitioning: transitioning,
	    visible: visible,
	    mounted: mounted,
	    redrawOnUpdate: createStream.merge([visible])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  var dom = vnode.dom;
	  if (!dom) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.el = dom;
	  var titleEl = state.el.querySelector("." + classes.title);
	  if (titleEl) {
	    setTitleStyles(titleEl);
	  }
	  if (attrs.showInstance && !state.visible()) {
	    showInstance(state, attrs);
	  }
	  state.mounted(true);
	};
	
	var onUnMount = function onUnMount(vnode) {
	  return vnode.state.mounted(false);
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs, { remove: ["style"] }), // style set in content, and set by show/hide transition
	  _defineProperty({
	    className: [classes.component, attrs.tone === "light" ? null : "pe-dark-tone", // default dark tone
	    attrs.tone === "light" ? "pe-light-tone" : null, attrs.containerSelector ? classes.hasContainer : null, attrs.layout === "vertical" ? classes.vertical : classes.horizontal, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, k.onclick, function (e) {
	    return e.preventDefault();
	  }));
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  if (state.mounted() && !state.transitioning()) {
	    if (attrs.hideInstance && state.visible()) {
	      hideInstance(state, attrs);
	    } else if (attrs.showInstance && !state.visible()) {
	      showInstance(state, attrs);
	    }
	  }
	  if (attrs.pauseInstance && !state.paused()) {
	    pauseInstance(state, attrs);
	  } else if (attrs.unpauseInstance && state.paused()) {
	    unpauseInstance(state, attrs);
	  }
	
	  return h("div", {
	    className: classes.content,
	    style: attrs.style
	  }, attrs.content || [attrs.title ? h("div", { className: classes.title }, attrs.title) : null, attrs.action ? h("div", { className: classes.action }, attrs.action) : null]);
	};
	
	var notificationInstance = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		onMount: onMount,
		onUnMount: onUnMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var buttonPaddingH = 8; // padding, inner text space
	
	var vars$1 = {
	  width: 288,
	  min_height: 80,
	  border_radius: polytheneTheme.vars.unit_block_border_radius,
	  title_padding_h: buttonPaddingH,
	  title_single_padding_v: 14,
	  title_multi_padding_v: 20, // 24 - natural line height
	  side_padding: 24 - buttonPaddingH,
	  font_size: 14,
	  line_height: 20,
	
	  color_light_background: rgba(polytheneTheme.vars.color_light_background),
	  color_light_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_dark_primary),
	
	  color_dark_background: rgba(polytheneTheme.vars.color_dark_background),
	  color_dark_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_light_text_primary)
	};
	
	var ANIMATION_DURATION = .5;
	
	var show$1 = function show$$1(_ref) {
	  var el = _ref.el,
	      showDuration = _ref.showDuration,
	      showDelay = _ref.showDelay;
	  return {
	    el: el,
	    showDuration: showDuration || ANIMATION_DURATION,
	    showDelay: showDelay || 0,
	    beforeShow: function beforeShow() {
	      return el.style.opacity = 0;
	    },
	    show: function show$$1() {
	      return el.style.opacity = 1;
	    }
	  };
	};
	
	var hide$1 = function hide$$1(_ref2) {
	  var el = _ref2.el,
	      hideDuration = _ref2.hideDuration,
	      hideDelay = _ref2.hideDelay;
	  return {
	    el: el,
	    hideDuration: hideDuration || ANIMATION_DURATION,
	    hideDelay: hideDelay || 0,
	    hide: function hide$$1() {
	      return el.style.opacity = 0;
	    }
	  };
	};
	
	var transitions = {
	  show: show$1,
	  hide: hide$1
	};
	
	exports.coreNotificationInstance = notificationInstance;
	exports.vars = vars$1;
	exports.transitions = transitions;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-notification.js.map


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(65)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-dialog-pane'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-dialog-pane']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreDialogPane) { 'use strict';
	
	var DialogPane = polytheneReactBase.StateComponent(polytheneCoreDialogPane.coreDialogPane);
	
	DialogPane.displayName = "DialogPane";
	
	exports.DialogPane = DialogPane;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-dialog-pane.js.map


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(75), __webpack_require__(14), __webpack_require__(9), __webpack_require__(16)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-radio-button', 'polythene-core-selection-control', 'polythene-react-icon', 'polythene-react-icon-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-radio-button'],global['polythene-core-selection-control'],global['polythene-react-icon'],global['polythene-react-icon-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreRadioButton,polytheneCoreSelectionControl,polytheneReactIcon,polytheneReactIconButton) { 'use strict';
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ViewControl = polytheneReactBase.ViewComponent(_extends$2({}, polytheneCoreSelectionControl.viewControl, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSelectionControl.viewControl.createContent(vnode, _extends$2(args, { Icon: polytheneReactIcon.Icon, IconButton: polytheneReactIconButton.IconButton }));
	  }
	}));
	
	ViewControl.displayName = "ViewControl";
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SelectionControl = polytheneReactBase.StateComponent(_extends$1({}, polytheneCoreSelectionControl.coreSelectionControl, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSelectionControl.coreSelectionControl.createContent(vnode, _extends$1(args, { ViewControl: ViewControl }));
	  }
	}));
	
	SelectionControl.displayName = "SelectionControl";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var RadioButton = polytheneReactBase.StateComponent(_extends({}, polytheneCoreRadioButton.coreRadioButton, {
	  component: SelectionControl
	}));
	
	RadioButton.displayName = "RadioButton";
	
	exports.RadioButton = RadioButton;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-radio-button.js.map


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(77), __webpack_require__(18), __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-raised-button', 'polythene-react-button', 'polythene-react-shadow'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-raised-button'],global['polythene-react-button'],global['polythene-react-shadow']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreRaisedButton,polytheneReactButton,polytheneReactShadow) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var RaisedButton = polytheneReactBase.StateComponent(_extends({}, polytheneCoreRaisedButton.coreRaisedButton, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreRaisedButton.coreRaisedButton.createProps(vnode, _extends(args, { Shadow: polytheneReactShadow.Shadow }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreRaisedButton.coreRaisedButton.createContent(vnode, _extends(args, { Shadow: polytheneReactShadow.Shadow }));
	  },
	  component: polytheneReactButton.Button
	}));
	
	RaisedButton.displayName = "RaisedButton";
	
	exports.RaisedButton = RaisedButton;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-raised-button.js.map


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(83)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-svg'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-svg']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreSvg) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SVG = polytheneReactBase.ViewComponent(_extends({}, polytheneCoreSvg.coreSVG));
	
	SVG.displayName = "SVG";
	
	exports.SVG = SVG;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-svg.js.map


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(86)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-textfield'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-textfield']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreTextfield) { 'use strict';
	
	var TextField = polytheneReactBase.StateComponent(polytheneCoreTextfield.coreTextField);
	
	TextField.displayName = "TextField";
	
	exports.TextField = TextField;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-textfield.js.map


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-card",
	
	  // elements
	  actions: "pe-card__actions",
	  any: "pe-card__any",
	  content: "pe-card__content",
	  header: "pe-card__header",
	  headerTitle: "pe-card__header-title",
	  media: "pe-card__media",
	  mediaDimmer: "pe-card__media__dimmer",
	  overlay: "pe-card__overlay",
	  overlayContent: "pe-card__overlay__content",
	  primary: "pe-card__primary",
	  primaryMedia: "pe-card__primary-media",
	  subtitle: "pe-card__subtitle",
	  text: "pe-card__text",
	  title: "pe-card__title",
	
	  // states
	  actionsBordered: "pe-card__actions--borders",
	  actionsHorizontal: "pe-card__actions--horizontal",
	  actionsJustified: "pe-card__actions--justified",
	  actionsTight: "pe-card__actions--tight",
	  actionsVertical: "pe-card__actions--vertical",
	  mediaCropX: "pe-card__media--crop-x",
	  mediaCropY: "pe-card__media--crop-y",
	  mediaLarge: "pe-card__media--large",
	  mediaMedium: "pe-card__media--medium",
	  mediaRatioLandscape: "pe-card__media--landscape",
	  mediaRatioSquare: "pe-card__media--square",
	  mediaRegular: "pe-card__media--regular",
	  mediaSmall: "pe-card__media--small",
	  overlaySheet: "pe-card__overlay--sheet",
	  primaryHasMedia: "pe-card__primary--media",
	  primaryTight: "pe-card__primary--tight",
	  textTight: "pe-card__text--tight"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var createOverlay = function createOverlay(_ref) {
	  var dispatcher = _ref.dispatcher,
	      attrs = _ref.attrs,
	      h = _ref.h,
	      k = _ref.k;
	
	  var element = attrs.element || "div";
	  var content = attrs.content.map(dispatcher);
	  return h("div", {
	    key: attrs.key || "card-overlay",
	    style: attrs.style,
	    className: [classes.overlay, attrs.sheet ? classes.overlaySheet : null, attrs.tone === "light" ? null : "pe-dark-tone", // default dark tone
	    attrs.tone === "light" ? "pe-light-tone" : null].join(" ")
	  }, [h(element, {
	    key: "content",
	    className: [classes.overlayContent, attrs.className || attrs[k.class]].join(" ")
	  }, content), h("div", {
	    key: "dimmer",
	    className: classes.mediaDimmer
	  })]);
	};
	
	var createAny = function createAny(_ref2) {
	  var attrs = _ref2.attrs,
	      h = _ref2.h,
	      k = _ref2.k;
	
	  var element = attrs.element || "div";
	  return h(element, _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    key: attrs.key || "card-any",
	    className: [classes.any, attrs.tight ? classes.textTight : null, attrs.className || attrs[k.class]].join(" ")
	  }), attrs.content);
	};
	
	var createText = function createText(_ref3) {
	  var attrs = _ref3.attrs,
	      h = _ref3.h,
	      k = _ref3.k;
	
	  var element = attrs.element || "div";
	  return h(element, _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    key: attrs.key || "card-text",
	    className: [classes.text, attrs.tight ? classes.textTight : null, attrs.className || attrs[k.class]].join(" ")
	  }), attrs.content);
	};
	
	var createHeader = function createHeader(_ref4) {
	  var attrs = _ref4.attrs,
	      h = _ref4.h,
	      k = _ref4.k,
	      Icon = _ref4.Icon,
	      ListTile = _ref4.ListTile;
	
	  return h(ListTile, _extends({}, attrs, {
	    key: attrs.key || "card-header",
	    className: [classes.header, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.icon ? { front: h(Icon, attrs.icon) } : null));
	};
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || vnode.attrs.url ? "a" : "div";
	};
	
	var createProps = function createProps(vnode, _ref5) {
	  var k = _ref5.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.url, attrs.events);
	};
	
	var createContent = function createContent(vnode, _ref6) {
	  var h = _ref6.renderer,
	      k = _ref6.keys,
	      CardActions = _ref6.CardActions,
	      CardMedia = _ref6.CardMedia,
	      CardPrimary = _ref6.CardPrimary,
	      Icon = _ref6.Icon,
	      Shadow = _ref6.Shadow,
	      ListTile = _ref6.ListTile;
	
	
	  var dispatcher = function dispatcher(block) {
	    var key = Object.keys(block)[0];
	    var attrs = _extends({}, block[key], {
	      dispatcher: dispatcher,
	      key: key
	    });
	    switch (key) {
	      case "actions":
	        return h(CardActions, attrs);
	      case "header":
	        return createHeader({ attrs: attrs, h: h, k: k, Icon: Icon, ListTile: ListTile });
	      case "media":
	        return h(CardMedia, attrs);
	      case "overlay":
	        return createOverlay({ dispatcher: dispatcher, attrs: attrs, h: h, k: k });
	      case "primary":
	        return h(CardPrimary, attrs);
	      case "text":
	        return createText({ attrs: attrs, h: h, k: k });
	      case "any":
	        return createAny({ attrs: attrs, h: h, k: k });
	      default:
	        throw "Content type \"" + key + "\" does not exist";
	    }
	  };
	
	  var attrs = vnode.attrs;
	  var contents = Array.isArray(attrs.content) ? attrs.content.map(dispatcher) : attrs.content;
	
	  return [h(Shadow, {
	    z: attrs.z !== undefined ? attrs.z : 1,
	    animated: true,
	    key: "shadow"
	  }), h("div", {
	    className: classes.content,
	    key: "content"
	  }, contents)];
	};
	
	var card = Object.freeze({
		getElement: getElement,
		createProps: createProps,
		createContent: createContent
	});
	
	var buttonClasses = {
	  base: "pe-button",
	  component: "pe-button pe-text-button",
	  row: "pe-button-row",
	
	  // elements
	  content: "pe-button__content",
	  focus: "pe-button__focus",
	  label: "pe-button__label",
	  wash: "pe-button__wash",
	
	  // states
	  borders: "pe-button--borders",
	  disabled: "pe-button--disabled",
	  focused: "pe-button--focus",
	  inactive: "pe-button--inactive",
	  selected: "pe-button--selected"
	};
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var actionLayoutClasses = {
	  horizontal: classes.actionsHorizontal,
	  vertical: classes.actionsVertical,
	  justified: classes.actionsJustified
	};
	
	var actionClassForLayout = function actionClassForLayout() {
	  var layout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "horizontal";
	  return actionLayoutClasses[layout];
	};
	
	var createProps$1 = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends$1({}, polytheneCore.filterSupportedAttributes(attrs), {
	    key: "card-actions",
	    className: [classes.actions, attrs.layout !== "vertical" ? buttonClasses.row : null, actionClassForLayout(attrs.layout), attrs.bordered ? classes.actionsBordered : null, attrs.tight ? classes.actionsTight : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent$1 = function createContent(vnode) {
	  return vnode.attrs.content;
	};
	
	var cardActions = Object.freeze({
		createProps: createProps$1,
		createContent: createContent$1
	});
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var imageRatios = {
	  landscape: 16 / 9,
	  square: 1
	};
	
	var mediaSizeClasses = {
	  small: classes.mediaSmall,
	  regular: classes.mediaRegular,
	  medium: classes.mediaMedium,
	  large: classes.mediaLarge
	};
	
	var mediaSizeClass = function mediaSizeClass() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "regular";
	  return mediaSizeClasses[size];
	};
	
	var initImage = function initImage(_ref) {
	  var dom = _ref.dom,
	      img = _ref.img,
	      ratio = _ref.ratio,
	      origin = _ref.origin;
	
	  img.onload = function () {
	    var naturalRatio = this.naturalWidth / this.naturalHeight;
	    // crop-x: crop over x axis
	    // crop-y: crop over y axis
	    var cropClass = naturalRatio < imageRatios[ratio] ? classes.mediaCropX : classes.mediaCropY;
	    img.className = cropClass;
	
	    var containerWidth = dom.clientWidth;
	    var containerHeight = dom.clientHeight;
	
	    if (naturalRatio < imageRatios[ratio]) {
	      // orient on y axis
	      if (origin === "center") {
	        var imageHeight = containerWidth / naturalRatio;
	        var diff = containerHeight - imageHeight;
	        var offset = diff / 2;
	        this.style.marginTop = offset + "px";
	      } else if (origin === "start") {
	        this.style.top = 0;
	        this.style.bottom = "auto";
	      } else {
	        // end
	        this.style.top = "auto";
	        this.style.bottom = 0;
	      }
	    } else {
	      // orient on x axis
	      if (origin === "center") {
	        var imageWidth = containerHeight * naturalRatio;
	        var _diff = containerWidth - imageWidth;
	        var _offset = _diff / 2;
	        this.style.marginLeft = _offset + "px";
	      } else if (origin === "start") {
	        this.style.left = 0;
	        this.style.right = "auto";
	      } else {
	        // end
	        this.style.left = "auto";
	        this.style.right = 0;
	      }
	    }
	  };
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  var attrs = vnode.attrs;
	  var ratio = attrs.ratio || "landscape";
	  var origin = attrs.origin || "center";
	  var dom = vnode.dom;
	  var img = dom.querySelector("img");
	  initImage({ dom: dom, img: img, ratio: ratio, origin: origin });
	};
	
	var createProps$2 = function createProps(vnode, _ref2) {
	  var k = _ref2.keys;
	
	  var attrs = vnode.attrs;
	  var ratio = attrs.ratio || "landscape";
	  return _extends$2({}, polytheneCore.filterSupportedAttributes(attrs), {
	    key: "card-media",
	    className: [classes.media, mediaSizeClass(attrs.size), ratio === "landscape" ? classes.mediaRatioLandscape : classes.mediaRatioSquare, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent$2 = function createContent(vnode, _ref3) {
	  var h = _ref3.renderer;
	
	  var attrs = vnode.attrs;
	  var dispatcher = attrs.dispatcher;
	  return [_extends$2({}, attrs.content, { key: "content" }), attrs.overlay ? dispatcher({ overlay: attrs.overlay, key: "overlay" }) : h("div", {
	    className: classes.mediaDimmer,
	    key: "dimmer"
	  })];
	};
	
	var cardMedia = Object.freeze({
		onMount: onMount,
		createProps: createProps$2,
		createContent: createContent$2
	});
	
	var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var createProps$3 = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  var primaryHasMedia = Array.isArray(attrs.content) ? attrs.content.reduce(function (total, current) {
	    return Object.keys(current)[0] === "media" ? true : total;
	  }, false) : attrs.media || false;
	  return _extends$3({}, polytheneCore.filterSupportedAttributes(attrs), {
	    key: "card-primary",
	    className: [classes.primary, attrs.tight ? classes.primaryTight : null, primaryHasMedia ? classes.primaryHasMedia : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent$3 = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer;
	
	  var attrs = vnode.attrs;
	  var dispatcher = attrs.dispatcher;
	  var primaryDispatch = {
	    title: function title(pAttrs) {
	      return pAttrs.attrs || pAttrs.props ? pAttrs || pAttrs.props : h("div", {
	        className: classes.title,
	        key: "title",
	        style: pAttrs.style
	      }, [pAttrs.title, pAttrs.subtitle ? h("div", {
	        className: classes.subtitle,
	        key: "subtitle"
	      }, pAttrs.subtitle) : null]);
	    },
	    media: function media(pAttrs) {
	      return h("div", {
	        className: classes.primaryMedia,
	        key: "media",
	        style: pAttrs.style
	      }, dispatcher({ media: pAttrs }));
	    },
	    actions: function actions(pAttrs) {
	      return dispatcher({ actions: pAttrs });
	    }
	  };
	
	  return Array.isArray(attrs.content) ? attrs.content.map(function (block) {
	    var key = Object.keys(block)[0];
	    var pAttrs = block[key];
	    return primaryDispatch[key] ? primaryDispatch[key](pAttrs) : block;
	  }) : [attrs.title ? primaryDispatch.title({
	    title: attrs.title,
	    subtitle: attrs.subtitle,
	    key: "title"
	  }) : null, attrs.media ? primaryDispatch.media(attrs.media) : null, attrs.actions ? primaryDispatch.actions(attrs.actions) : null, attrs.content];
	};
	
	var cardPrimary = Object.freeze({
		createProps: createProps$3,
		createContent: createContent$3
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var padding_v = 24;
	var padding_actions_v = 8;
	var actions_button_margin_v = 2;
	
	var vars$1 = {
	  image_size_small: 1 * 80,
	  image_size_regular: 1.4 * 80,
	  image_size_medium: 2 * 80,
	  image_size_large: 3 * 80,
	  border_radius: polytheneTheme.vars.unit_block_border_radius,
	  padding_h: 16,
	  offset_small_padding_v: padding_v - 16,
	  padding_actions_h: 8,
	  title_padding_h: 16,
	  title_padding_v: 24,
	  tight_title_padding_bottom: 16,
	  text_padding_h: 16,
	  text_padding_v: 16,
	  text_padding_bottom: 24,
	  tight_text_padding_bottom: 16,
	  subtitle_line_height_padding_bottom: 7,
	  text_line_height_padding_top: 6,
	  text_line_height_padding_bottom: 7,
	  one_line_height_with_icon: 72,
	  icon_element_width: 72 - 4,
	  one_line_padding_v: 8,
	  actions_padding_v: 0,
	  actions_button_margin_v: actions_button_margin_v,
	  actions_vertical_padding_v: padding_actions_v - actions_button_margin_v,
	
	  color_light_main_background: rgba(polytheneTheme.vars.color_light_background),
	  color_light_title_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_light_subtitle_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_regular),
	  color_light_actions_border: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_border_light),
	  color_light_overlay_background: rgba(polytheneTheme.vars.color_light_background, polytheneTheme.vars.blend_light_overlay_background),
	
	  color_dark_main_background: rgba(polytheneTheme.vars.color_dark_background),
	  color_dark_title_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_subtitle_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_regular),
	  color_dark_actions_border: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_border_light),
	  color_dark_overlay_background: rgba(polytheneTheme.vars.color_dark_background, polytheneTheme.vars.blend_dark_overlay_background)
	};
	
	exports.coreCard = card;
	exports.coreCardActions = cardActions;
	exports.coreCardMedia = cardMedia;
	exports.coreCardPrimary = cardPrimary;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-card.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(14)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core-selection-control'], factory) :
		(factory((global.polythene = {}),global['polythene-core-selection-control']));
	}(this, (function (exports,polytheneCoreSelectionControl) { 'use strict';
	
	var classes = {
	  component: "pe-checkbox-control"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Don't export 'element': it will be the wrapped selection control component (set in polythene-xxx-checkbox)
	
	var iconOn = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg>";
	var iconOff = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\"/></svg>";
	
	var icons = {
	  iconOff: iconOff,
	  iconOn: iconOn
	};
	
	// Props to be passed to a selection control
	
	var createProps = function createProps(vnode) {
	  var attrs = vnode.attrs;
	  return _extends({}, attrs, {
	    icons: icons,
	    selectable: attrs.selectable || function () {
	      return true;
	    }, // default: always selectable, regardless the checked state
	    instanceClass: classes.component,
	    type: "checkbox"
	  });
	};
	
	var checkbox = Object.freeze({
		createProps: createProps
	});
	
	exports.coreCheckbox = checkbox;
	exports.vars = polytheneCoreSelectionControl.vars;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-checkbox.js.map


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-dialog-pane",
	
	  // elements
	  actions: "pe-dialog-pane__actions",
	  body: "pe-dialog-pane__body",
	  content: "pe-dialog-pane__content",
	  footer: "pe-dialog-pane__footer",
	  header: "pe-dialog-pane__header",
	  title: "pe-dialog-pane__title",
	
	  // states
	  withHeader: "pe-dialog-pane--header",
	  withFooter: "pe-dialog-pane--footer",
	  headerWithTitle: "pe-dialog-pane__header--title",
	  footerWithButtons: "pe-dialog-pane__footer--buttons",
	  footerHigh: "pe-dialog-pane__footer--high",
	  borderBottom: "pe-dialog-pane--border-bottom",
	  borderTop: "pe-dialog-pane--border-top",
	  fullBleed: "pe-dialog-pane--body-full-bleed"
	};
	
	var buttonClasses = {
	  base: "pe-button",
	  component: "pe-button pe-text-button",
	  row: "pe-button-row",
	
	  // elements
	  content: "pe-button__content",
	  focus: "pe-button__focus",
	  label: "pe-button__label",
	  wash: "pe-button__wash",
	
	  // states
	  borders: "pe-button--borders",
	  disabled: "pe-button--disabled",
	  focused: "pe-button--focus",
	  inactive: "pe-button--inactive",
	  selected: "pe-button--selected"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "form";
	};
	
	var SCROLL_WATCH_END_TIMER = 150;
	
	var updateScrollOverflowState = function updateScrollOverflowState(vnode) {
	  var state = vnode.state;
	  var scroller = state.scrollEl();
	  if (!scroller) {
	    return;
	  }
	  state.topOverflow(scroller.scrollTop > 0);
	  state.bottomOverflow(scroller.scrollHeight - (scroller.scrollTop + scroller.getBoundingClientRect().height) > 0);
	};
	
	var updateFooterState = function updateFooterState(vnode) {
	  var state = vnode.state;
	  var footerEl = state.footerEl();
	  if (!footerEl) {
	    return;
	  }
	  var style = window.getComputedStyle(footerEl);
	  var height = footerEl.getBoundingClientRect().height;
	  var minHeight = parseInt(style.minHeight, 10);
	  if (height > minHeight) {
	    footerEl.classList.add(classes.footerHigh);
	  } else {
	    footerEl.classList.remove(classes.footerHigh);
	  }
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var bottomOverflow = createStream(false);
	  var footerEl = createStream(null);
	  var headerEl = createStream(null);
	  var isScrolling = createStream(false);
	  var scrollEl = createStream(null);
	  var topOverflow = createStream(false);
	  var el = createStream(null);
	
	  return {
	    cleanUp: undefined,
	    bottomOverflow: bottomOverflow,
	    el: el,
	    footerEl: footerEl,
	    headerEl: headerEl,
	    isScrolling: isScrolling,
	    scrollEl: scrollEl,
	    scrollWatchId: undefined,
	    topOverflow: topOverflow,
	    redrawOnUpdate: createStream.merge([topOverflow, bottomOverflow, isScrolling])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  var dom = vnode.dom;
	  if (!dom) {
	    return;
	  }
	  var state = vnode.state;
	  state.el(dom);
	
	  state.scrollEl(dom.querySelector("." + classes.body));
	  state.footerEl(dom.querySelector("." + classes.footer));
	  state.headerEl(dom.querySelector("." + classes.title));
	
	  state.isScrolling.map(function () {
	    return updateScrollOverflowState(vnode);
	  });
	
	  var update = function update() {
	    updateScrollOverflowState(vnode);
	    updateFooterState(vnode);
	  };
	
	  state.cleanUp = function () {
	    return polytheneCore.unsubscribe("resize", update);
	  };
	
	  // resize: update scroll state ("overflow" borders)
	  polytheneCore.subscribe("resize", update);
	
	  updateScrollOverflowState(vnode);
	};
	
	var onUnMount = function onUnMount(vnode) {
	  return vnode.state.cleanUp();
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var state = vnode.state;
	  var attrs = polytheneCore.unpackAttrs(vnode.attrs);
	  var borders = attrs.borders || "overflow";
	  var showTopBorder = borders === "always" || borders === "overflow" && state.topOverflow();
	  var showBottomBorder = borders === "always" || borders === "overflow" && state.bottomOverflow();
	  var withHeader = attrs.header !== undefined || attrs.title !== undefined;
	  var withFooter = attrs.footer !== undefined || attrs.footerButtons !== undefined;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs, { remove: ["style"] }), // style set in content, and set by show/hide transition
	  {
	    className: [classes.component, attrs.fullBleed ? classes.fullBleed : null, showTopBorder ? classes.borderTop : null, showBottomBorder ? classes.borderBottom : null, withHeader ? classes.withHeader : null, withFooter ? classes.withFooter : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.formOptions);
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      k = _ref2.keys;
	
	  var state = vnode.state;
	  var attrs = polytheneCore.unpackAttrs(vnode.attrs);
	
	  return h("div", {
	    className: [classes.content, attrs.menu ? classes.menuContent : null].join(" "),
	    style: attrs.style
	  }, [attrs.header ? attrs.header : attrs.title ? h("div", {
	    className: [classes.header, classes.headerWithTitle].join(" "),
	    key: "title"
	  }, h("div", { className: classes.title }, attrs.title)) : null, h("div", _defineProperty({
	    className: classes.body,
	    key: "body"
	  }, k.onscroll, function () {
	    state.isScrolling(true);
	    clearTimeout(state.scrollWatchId);
	    state.scrollWatchId = setTimeout(function () {
	      state.isScrolling(false);
	    }, SCROLL_WATCH_END_TIMER);
	  }), attrs.content || attrs.body || attrs.menu), attrs.footer ? h("div", {
	    className: classes.footer,
	    key: "footer"
	  }, attrs.footer) : attrs.footerButtons ? h("div", {
	    className: [classes.footer, classes.footerWithButtons, buttonClasses.row].join(" "),
	    key: "footer"
	  }, h("div", { className: classes.actions }, attrs.footerButtons)) : null]);
	};
	
	var dialogPane = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		onMount: onMount,
		onUnMount: onUnMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  max_width: 7 * polytheneTheme.vars.grid_unit_menu, // 56   
	  side_padding_mobile: 6 * polytheneTheme.vars.grid_unit, // 48
	  padding: 3 * polytheneTheme.vars.grid_unit_component, // 24
	  header_bottom: 20,
	  header_height: 60,
	  footer_height: 52,
	
	  border_width: 1,
	
	  color_light_title_text: "inherit",
	  color_light_body_text: "inherit",
	  color_light_body_border: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_border_light),
	  color_light_background: "inherit",
	
	  color_dark_title_text: "inherit",
	  color_dark_body_text: "inherit",
	  color_dark_body_border: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_border_light),
	  color_dark_background: "inherit"
	};
	
	exports.coreDialogPane = dialogPane;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-dialog-pane.js.map


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var listTileClasses = {
	  component: "pe-list-tile",
	
	  // elements
	  content: "pe-list-tile__content",
	  highSubtitle: "pe-list-tile__high-subtitle",
	  primary: "pe-list-tile__primary",
	  secondary: "pe-list-tile__secondary",
	  subtitle: "pe-list-tile__subtitle",
	  title: "pe-list-tile__title",
	  contentFront: "pe-list-tile__content-front",
	
	  // states
	  compact: "pe-list-tile--compact",
	  compactFront: "pe-list-tile--compact-front",
	  disabled: "pe-list-tile--disabled",
	  hasFront: "pe-list-tile--front",
	  hasHighSubtitle: "pe-list-tile--high-subtitle",
	  hasSubtitle: "pe-list-tile--subtitle",
	  header: "pe-list-tile--header",
	  hoverable: "pe-list-tile--hoverable",
	  selectable: "pe-list-tile--selectable",
	  selected: "pe-list-tile--selected",
	  highlight: "pe-list-tile--highlight",
	  sticky: "pe-list-tile--sticky"
	};
	
	var menuClasses = {
	  component: "pe-menu",
	
	  // elements
	  content: "pe-menu__content",
	  placeholder: "pe-menu__placeholder",
	  target: "pe-menu__target",
	
	  // states
	  permanent: "pe-menu--permanent",
	  visible: "pe-menu--visible",
	  width_auto: "pe-menu--width-auto",
	  width_n: "pe-menu--width-",
	
	  // lookup
	  listTile: listTileClasses.component,
	  selectedListTile: listTileClasses.selected
	};
	
	var classes = {
	  component: "pe-dialog",
	
	  // elements
	  placeholder: "pe-dialog__placeholder",
	  holder: "pe-dialog__holder",
	  content: "pe-dialog__content",
	
	  // states
	  fullScreen: "pe-dialog--full-screen",
	  backdrop: "pe-dialog--backdrop",
	  open: "pe-dialog--open",
	
	  // lookup
	  menuContent: menuClasses.content
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var DEFAULT_Z = 3;
	
	var showDialog = function showDialog(state, attrs) {
	  if (state.transitioning()) {
	    return Promise.resolve();
	  }
	  var id = state.instanceId;
	  state.transitioning(true);
	  var transitions = attrs.transitions;
	  return polytheneCore.show(_extends({}, attrs, transitions.show({ el: state.el, showDuration: attrs.showDuration, showDelay: attrs.showDelay }))).then(function () {
	    if (attrs.multipleDidShow) {
	      attrs.multipleDidShow(id); // this will call attrs.didShow
	    }
	    state.transitioning(false);
	  });
	};
	
	var hideDialog = function hideDialog(state, attrs) {
	  if (state.transitioning()) {
	    return Promise.resolve();
	  }
	  var id = state.instanceId;
	  state.transitioning(true);
	  var transitions = attrs.transitions;
	  return polytheneCore.hide(_extends({}, attrs, transitions.hide({ el: state.el, hideDuration: attrs.hideDuration, hideDelay: attrs.hideDelay }))).then(function () {
	    if (attrs.multipleDidHide) {
	      attrs.multipleDidHide(id); // this will call attrs.didHide
	    }
	    state.transitioning(false);
	  });
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var transitioning = createStream(false);
	  return {
	    cleanUp: undefined,
	    el: undefined,
	    transitioning: transitioning
	  };
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.el = vnode.dom;
	
	  var handleEscape = function handleEscape(e) {
	    if (attrs.fullScreen || attrs.modal) return;
	    if (e.key === "Escape") {
	      hideDialog(state, _extends({}, attrs, {
	        hideDelay: 0
	      }));
	    }
	  };
	
	  state.cleanUp = function () {
	    return polytheneCore.unsubscribe("keydown", handleEscape);
	  };
	
	  polytheneCore.subscribe("keydown", handleEscape);
	
	  if (attrs.showInstance) {
	    showDialog(state, attrs);
	  }
	};
	
	var onUnMount = function onUnMount(vnode) {
	  return vnode.state.cleanUp();
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs, { remove: ["style"] }), // style set in content, and set by show/hide transition
	  _defineProperty({
	    className: [classes.component, attrs.fullScreen ? classes.fullScreen : null, attrs.backdrop ? classes.backdrop : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, k.onclick, function (e) {
	    if (e.target !== state.el) {
	      return;
	    }
	    if (attrs.modal) {
	      // not allowed
	      return;
	    }
	    hideDialog(state, _extends({}, attrs, {
	      hideDelay: 0
	    }));
	  }), attrs.formOptions ? attrs.formOptions : null);
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      Shadow = _ref2.Shadow,
	      DialogPane = _ref2.DialogPane;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  if (attrs.hideInstance) {
	    hideDialog(state, attrs);
	  }
	  var pane = attrs.panes && attrs.panes.length ? attrs.panes[0] : h(DialogPane, {
	    title: attrs.title,
	    header: attrs.header,
	    body: attrs.content || attrs.body || attrs.menu,
	    footer: attrs.footer,
	    footerButtons: attrs.footerButtons,
	    className: attrs.className,
	    style: attrs.style,
	    fullBleed: attrs.fullBleed
	  });
	  return h("div", {
	    className: [classes.content, attrs.menu ? classes.menuContent : null].join(" ")
	  }, [attrs.fullScreen ? null : h(Shadow, {
	    z: attrs.z !== undefined ? attrs.z : DEFAULT_Z,
	    animated: true
	  }), pane]);
	};
	
	var dialogInstance = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		onMount: onMount,
		onUnMount: onUnMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  border_radius: polytheneTheme.vars.unit_block_border_radius,
	  padding_vertical: 3 * polytheneTheme.vars.grid_unit_component,
	  padding_horizontal: 5 * polytheneTheme.vars.grid_unit_component,
	  color_light_backdrop_background: "rgba(0, 0, 0, .4)",
	  color_dark_backdrop_background: "rgba(0, 0, 0, .5)",
	
	  color_light_background: rgba(polytheneTheme.vars.color_light_background),
	  color_dark_background: rgba(polytheneTheme.vars.color_dark_background),
	
	  color_light_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_regular),
	  color_dark_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_regular)
	};
	
	var ANIMATION_DURATION = .220;
	
	var show$1 = function show$$1(_ref) {
	  var el = _ref.el,
	      showDuration = _ref.showDuration,
	      showDelay = _ref.showDelay;
	  return {
	    el: el,
	    showDuration: showDuration || ANIMATION_DURATION,
	    showDelay: showDelay || 0,
	    beforeShow: function beforeShow() {
	      return el.style.opacity = 0;
	    },
	    show: function show$$1() {
	      return el.style.opacity = 1;
	    }
	  };
	};
	
	var hide$1 = function hide$$1(_ref2) {
	  var el = _ref2.el,
	      hideDuration = _ref2.hideDuration,
	      hideDelay = _ref2.hideDelay;
	  return {
	    el: el,
	    hideDuration: hideDuration || ANIMATION_DURATION,
	    hideDelay: hideDelay || 0,
	    hide: function hide$$1() {
	      return el.style.opacity = 0;
	    }
	  };
	};
	
	var transitions = {
	  show: show$1,
	  hide: hide$1
	};
	
	exports.coreDialogInstance = dialogInstance;
	exports.vars = vars$1;
	exports.transitions = transitions;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-dialog.js.map


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-theme']));
	}(this, (function (exports,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-fab",
	
	  // elements
	  content: "pe-fab__content",
	
	  // states
	  mini: "pe-fab--mini"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Don't export 'element': it will be the wrapped raised button component (set in polythene-xxx-fab)
	
	// Props to be passed to a raised button, including 'content'
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys,
	      h = _ref.renderer,
	      Icon = _ref.Icon;
	
	  var attrs = vnode.attrs;
	  var content = attrs.content ? attrs.content : attrs.icon ? h(Icon, attrs.icon) : attrs.children || vnode.children;
	  return _extends({}, {
	    content: h("div", { className: classes.content }, content),
	    parentClassName: [classes.component, attrs.mini ? classes.mini : null, attrs.className || attrs[k.class]].join(" "),
	    // defaults
	    ripple: {
	      center: true,
	      opacityDecayVelocity: 0.24
	    },
	    shadow: { increase: 5 },
	    ink: true,
	    wash: true,
	    animateOnTap: attrs.animateOnTap !== undefined ? attrs.animateOnTap : true
	  }, attrs);
	};
	
	var createContent = function createContent() {
	  return null;
	};
	
	var fab = Object.freeze({
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  size_regular: 7 * polytheneTheme.vars.grid_unit_component,
	  size_mini: 5 * polytheneTheme.vars.grid_unit_component,
	  padding_regular: 2 * polytheneTheme.vars.grid_unit_component,
	
	  color_light: rgba(polytheneTheme.vars.color_primary_foreground),
	  color_light_focus_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	
	  color_light_focus_opacity: polytheneTheme.vars.blend_light_background_hover_medium, // same as button
	  color_light_background: rgba(polytheneTheme.vars.color_primary),
	
	  color_dark: rgba(polytheneTheme.vars.color_primary_foreground),
	  color_dark_focus_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_hover), // same as button
	  color_dark_background: rgba(polytheneTheme.vars.color_primary)
	};
	
	exports.coreFAB = fab;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-fab.js.map


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-icon",
	
	  // states
	  avatar: "pe-icon--avatar",
	  large: "pe-icon--large",
	  medium: "pe-icon--medium",
	  regular: "pe-icon--regular",
	  small: "pe-icon--small"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var sizeClasses = {
	  small: classes.small,
	  regular: classes.regular,
	  medium: classes.medium,
	  large: classes.large
	};
	
	var classForSize = function classForSize() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "regular";
	  return sizeClasses[size];
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, classForSize(attrs.size), attrs.avatar ? classes.avatar : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.events);
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      SVG = _ref2.SVG;
	
	  var attrs = vnode.attrs;
	  return attrs.content ? attrs.content : attrs.svg ? h(SVG, attrs.svg) : attrs.src ? h("img", { src: attrs.src }) : attrs.children || vnode.children;
	};
	
	var icon = Object.freeze({
		getElement: getElement,
		createProps: createProps,
		createContent: createContent
	});
	
	var vars$1 = {
	  size_small: polytheneTheme.vars.unit_icon_size_small,
	  size_regular: polytheneTheme.vars.unit_icon_size,
	  size_medium: polytheneTheme.vars.unit_icon_size_medium,
	  size_large: polytheneTheme.vars.unit_icon_size_large,
	  color_light: "currentcolor",
	  color_dark: "currentcolor"
	};
	
	exports.coreIcon = icon;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-icon.js.map


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-theme']));
	}(this, (function (exports,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-ios-spinner",
	
	  // elements
	  blades: "pe-ios-spinner__blades",
	  blade: "pe-ios-spinner__blade"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var blade = function blade(num, h) {
	  return h("div", {
	    key: "blade-" + num,
	    className: classes.blade
	  });
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var h = _ref.renderer;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.content = state.content || h("div", {
	    key: "content",
	    className: classes.blades
	  }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (num) {
	    return blade(num, h);
	  }));
	  return _extends({}, attrs, {
	    className: [classes.component, attrs.className].join(" "),
	    content: state.content
	  });
	};
	
	var spinner = Object.freeze({
		createProps: createProps
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  animation_duration: 1, // seconds
	
	  color_light: rgba(polytheneTheme.vars.color_light_foreground),
	  color_dark: rgba(polytheneTheme.vars.color_dark_foreground)
	};
	
	exports.coreIOSSpinner = spinner;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-ios-spinner.js.map


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-list-tile",
	
	  // elements
	  content: "pe-list-tile__content",
	  highSubtitle: "pe-list-tile__high-subtitle",
	  primary: "pe-list-tile__primary",
	  secondary: "pe-list-tile__secondary",
	  subtitle: "pe-list-tile__subtitle",
	  title: "pe-list-tile__title",
	  contentFront: "pe-list-tile__content-front",
	
	  // states
	  compact: "pe-list-tile--compact",
	  compactFront: "pe-list-tile--compact-front",
	  disabled: "pe-list-tile--disabled",
	  hasFront: "pe-list-tile--front",
	  hasHighSubtitle: "pe-list-tile--high-subtitle",
	  hasSubtitle: "pe-list-tile--subtitle",
	  header: "pe-list-tile--header",
	  hoverable: "pe-list-tile--hoverable",
	  selectable: "pe-list-tile--selectable",
	  selected: "pe-list-tile--selected",
	  highlight: "pe-list-tile--highlight",
	  sticky: "pe-list-tile--sticky"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement() {
	  return "div";
	}; // because primary or secondary content can be an "a", the container is always defined as "div", and option `element` is passed to primary content
	
	var primaryContent = function primaryContent(h, k, requiresKeys, attrs, children) {
	  var url = attrs.keyboardControl ? null : attrs.url;
	  var element = attrs.element ? attrs.element : url ? "a" : "div";
	  var contentFrontClass = [classes.content, classes.contentFront, attrs.compactFront ? classes.compactFront : null].join(" ");
	  var frontComp = attrs.front ? h("div", _extends({}, requiresKeys ? { key: "front" } : null, { className: contentFrontClass }), attrs.front) : attrs.indent ? h("div", _extends({}, requiresKeys ? { key: "front" } : null, { className: contentFrontClass })) : null;
	  var hasTabIndex = !attrs.header && attrs.url;
	  var props = _extends({}, polytheneCore.filterSupportedAttributes(attrs), attrs.events, {
	    className: classes.primary,
	    style: null
	  }, hasTabIndex && _defineProperty({}, k.tabindex, attrs[k.tabindex] || 0), url);
	  var content = attrs.content ? attrs.content : [frontComp, h("div", {
	    className: classes.content,
	    style: attrs.style
	  }, [attrs.content ? _extends({}, requiresKeys ? { key: "content" } : null, attrs.content) : children, attrs.title && !attrs.content ? h("div", _extends({}, requiresKeys ? { key: "title" } : null, { className: classes.title }), attrs.title) : null, attrs.subtitle ? h("div", _extends({}, requiresKeys ? { key: "subtitle" } : null, { className: classes.subtitle }), attrs.subtitle) : null, attrs.highSubtitle ? h("div", _extends({}, requiresKeys ? { key: "highSubtitle" } : null, { className: classes.subtitle + " " + classes.highSubtitle }), attrs.highSubtitle) : null, attrs.subContent ? h("div", _extends({}, requiresKeys ? { key: "subContent" } : null, { className: classes.subContent }), attrs.subContent) : null])];
	  return h(element, props, content);
	};
	
	var secondaryContent = function secondaryContent(h, k, requiresKeys, Icon) {
	  var attrs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  var url = attrs.keyboardControl ? null : attrs.url;
	  var element = attrs.element ? attrs.element : url ? "a" : "div";
	  var hasTabIndex = attrs.url;
	  return h(element, _extends({}, url, {
	    className: classes.secondary
	  }, requiresKeys ? { key: "secondary" } : null, polytheneCore.filterSupportedAttributes(attrs), hasTabIndex && _defineProperty({}, k.tabindex, attrs[k.tabindex] || 0)), h("div", { className: classes.content }, [attrs.icon ? h(Icon, attrs.icon) : null, attrs.content ? attrs.content : null]));
	};
	
	var createProps = function createProps(vnode, _ref3) {
	  var k = _ref3.keys;
	
	  var attrs = vnode.attrs;
	  var hasTabIndex = !attrs.header && !attrs.url && !(attrs.secondary && attrs.secondary.url);
	  var heightClass = attrs.subtitle ? classes.hasSubtitle : attrs.highSubtitle ? classes.hasHighSubtitle : attrs.front || attrs.indent ? classes.hasFront : null;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs, { remove: ["tabindex", "tabIndex"] }), // tabindex is set elsewhere
	  {
	    className: [classes.component, attrs.selected ? classes.selected : null, attrs.disabled ? classes.disabled : null, attrs.sticky ? classes.sticky : null, attrs.compact ? classes.compact : null, attrs.hoverable ? classes.hoverable : null, attrs.selectable ? classes.selectable : null, attrs.highlight ? classes.highlight : null, attrs.header ? classes.header : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, heightClass, attrs.className || attrs[k.class]].join(" ")
	  }, hasTabIndex && _defineProperty({}, k.tabindex, attrs[k.tabindex] || 0)
	  // events and url are attached to primary content to not interfere with controls
	  );
	};
	
	var createContent = function createContent(vnode, _ref5) {
	  var h = _ref5.renderer,
	      requiresKeys = _ref5.requiresKeys,
	      k = _ref5.keys,
	      Ripple = _ref5.Ripple,
	      Icon = _ref5.Icon;
	
	  var attrs = vnode.attrs;
	  var primaryAttrs = _extends({}, requiresKeys ? { key: "primary" } : null, attrs);
	  delete primaryAttrs.id;
	  delete primaryAttrs[k.class];
	  return [attrs.ink && !attrs.disabled ? h(Ripple, _extends({}, attrs.ripple, requiresKeys ? { key: "ripple" } : null)) : null, primaryContent(h, k, requiresKeys, primaryAttrs, attrs.children || vnode.children), attrs.secondary ? secondaryContent(h, k, requiresKeys, Icon, attrs.secondary) : null];
	};
	
	var listTile = Object.freeze({
		getElement: getElement,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	// SPECS
	//
	// heights:
	// single line: 48
	// single line, dense: 40
	// single line, with icon: 48
	// single line, with icon, dense: 40
	// single line, with avatar: 56
	// single line, with avatar, dense: 48
	// two-line: 72
	// two-line, dense: 60
	// three-line: 88
	// three-line, dense: 76
	
	var single_height = 48;
	var padding = 8;
	var single_with_icon_height = 56;
	
	var vars$1 = {
	  single_height: single_height,
	  single_line_height: single_height - 2 * padding - (2 * 5 + 1),
	  single_with_icon_height: single_with_icon_height,
	  single_with_icon_line_height: single_with_icon_height - 2 * padding - (2 * 5 + 1),
	  padding: 13,
	  compact_padding: 9,
	  subtitle_line_count: 1,
	  has_subtitle_padding: 15,
	  high_subtitle_line_count: 2,
	  has_high_subtitle_padding: 13,
	  front_item_width: 72,
	  compact_front_item_width: 64,
	  side_padding: 2 * polytheneTheme.vars.grid_unit_component,
	  compact_side_padding: 1 * polytheneTheme.vars.grid_unit_component,
	  font_size_title: 16,
	  font_size_subtitle: 14,
	  line_height_subtitle: 20,
	  font_size_list_header: 14,
	  font_size_small: 12,
	
	  color_light_title: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_light_subtitle: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_info: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_tertiary),
	  color_light_text_disabled: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	  color_light_list_header: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_tertiary),
	  color_light_secondary: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_hover_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  color_light_focus_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  color_light_selected_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  color_light_highlight_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  // background color may be set in theme; disabled by default
	  // color_light_background:          "inherit",
	
	  color_dark_title: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_subtitle: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_info: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_tertiary),
	  color_dark_text_disabled: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled),
	  color_dark_list_header: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_tertiary),
	  color_dark_secondary: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_hover_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_hover),
	  color_dark_selected_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_hover),
	  color_dark_highlight_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_hover)
	  // background color may be set in theme; disabled by default
	  // color_dark_background:           "inherit",
	};
	
	exports.coreListTile = listTile;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-list-tile.js.map


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var listTileClasses = {
	  component: "pe-list-tile",
	
	  // elements
	  content: "pe-list-tile__content",
	  highSubtitle: "pe-list-tile__high-subtitle",
	  primary: "pe-list-tile__primary",
	  secondary: "pe-list-tile__secondary",
	  subtitle: "pe-list-tile__subtitle",
	  title: "pe-list-tile__title",
	  contentFront: "pe-list-tile__content-front",
	
	  // states
	  compact: "pe-list-tile--compact",
	  compactFront: "pe-list-tile--compact-front",
	  disabled: "pe-list-tile--disabled",
	  hasFront: "pe-list-tile--front",
	  hasHighSubtitle: "pe-list-tile--high-subtitle",
	  hasSubtitle: "pe-list-tile--subtitle",
	  header: "pe-list-tile--header",
	  hoverable: "pe-list-tile--hoverable",
	  selectable: "pe-list-tile--selectable",
	  selected: "pe-list-tile--selected",
	  highlight: "pe-list-tile--highlight",
	  sticky: "pe-list-tile--sticky"
	};
	
	var classes = {
	  component: "pe-list",
	
	  // states
	  borders: "pe-list--borders",
	  compact: "pe-list--compact",
	  hasHeader: "pe-list--header",
	  indentedBorders: "pe-list--indented-borders",
	  padding: "pe-list--padding",
	  paddingTop: "pe-list--padding-top",
	  paddingBottom: "pe-list--padding-bottom",
	
	  // lookup
	  header: listTileClasses.header
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var paddingClasses = {
	  both: classes.padding,
	  bottom: classes.paddingBottom,
	  top: classes.paddingTop,
	  none: null
	};
	
	var paddingClass = function paddingClass() {
	  var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "both";
	  return paddingClasses[attr];
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.borders ? classes.borders : null, attrs.indentedBorders ? classes.indentedBorders : null, attrs.header ? classes.hasHeader : null, attrs.compact ? classes.compact : null, paddingClass(attrs.padding), attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      requiresKeys = _ref2.requiresKeys,
	      k = _ref2.keys,
	      ListTile = _ref2.ListTile;
	
	  var attrs = vnode.attrs;
	  var headerOpts = void 0;
	  if (attrs.header) {
	    headerOpts = _extends({}, attrs.header);
	    headerOpts[k.class] = [classes.header, headerOpts[k.class] || null].join(" ");
	  }
	  var tiles = attrs.tiles ? attrs.tiles : attrs.content ? attrs.content : attrs.children || vnode.children;
	  return [headerOpts ? h(ListTile, _extends({}, requiresKeys ? { key: "header" } : null, attrs.all, headerOpts, {
	    header: true
	  })) : null, attrs.all ? tiles.map(function (tileOpts) {
	    return h(ListTile, _extends({}, attrs.all, tileOpts));
	  }) : tiles];
	};
	
	var list = Object.freeze({
		getElement: getElement,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  padding: polytheneTheme.vars.grid_unit_component, // vertical padding
	  padding_compact: polytheneTheme.vars.grid_unit_component * 3 / 4,
	  border_width_stacked: 1,
	  border_width_bordered: 1,
	
	  color_light_border: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_border_light),
	  color_dark_border: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_border_light)
	
	  // background color may be set in theme; disabled by default
	  // color_light_background: "inherit",
	  // color_dark_background:  "inherit"
	};
	
	exports.coreList = list;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-list.js.map


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(26), __webpack_require__(3), __webpack_require__(21)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-utilities', 'polythene-theme', 'polythene-core-base-spinner'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-utilities'],global['polythene-theme'],global['polythene-core-base-spinner']));
	}(this, (function (exports,polytheneCore,polytheneUtilities,polytheneTheme,polytheneCoreBaseSpinner) { 'use strict';
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var themeVars = _extends$1({}, polytheneCoreBaseSpinner.vars, {
	  border_width_small: polytheneCoreBaseSpinner.vars.size_small / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  border_width_regular: 3,
	  border_width_medium: polytheneCoreBaseSpinner.vars.size_medium / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  border_width_large: polytheneCoreBaseSpinner.vars.size_large / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  border_width_fab: polytheneCoreBaseSpinner.vars.size_fab / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  animation_duration: "1.5s",
	
	  color_light: rgba(polytheneTheme.vars.color_primary),
	  color_dark: rgba(polytheneTheme.vars.color_primary)
	});
	
	var classes = {
	  component: "pe-md-progress-spinner",
	
	  // elements
	  animation: "pe-md-progress-spinner__animation",
	  circle: "pe-md-progress-spinner__circle",
	  circleRight: "pe-md-progress-spinner__circle-right",
	  circleLeft: "pe-md-progress-spinner__circle-left"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var DEFAULT_UPDATE_DURATION = .8;
	
	var sizeFromName = function sizeFromName() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "regular";
	  return themeVars["size_" + size];
	};
	
	var percentageValue = function percentageValue(min, max) {
	  var percentage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  return min + (max - min) * percentage;
	};
	
	var rotateCircle = function rotateCircle(el, min, max, percentage) {
	  var style = el.style;
	  style["transform"] = style["-webkit-transform"] = style["-moz-transform"] = style["-ms-transform"] = style["-o-transform"] = "rotate(" + percentageValue(min, max, percentage) + "deg)";
	};
	
	var animate = function animate(stateEl, size, percentage) {
	  var animationEl = stateEl.querySelector("." + classes.animation);
	  var animationElStyle = animationEl.style;
	  if (percentage < 0.5) {
	    animationElStyle.clip = "rect(0px, " + size + "px, " + size + "px, " + size / 2 + "px)";
	  } else {
	    animationElStyle.clip = "rect(auto, auto, auto, auto)";
	  }
	  var leftCircle = stateEl.querySelector("." + classes.circleLeft);
	  var rightCircle = stateEl.querySelector("." + classes.circleRight);
	  leftCircle.style.clip = rightCircle.style.clip = "rect(0px, " + size / 2 + "px, " + size + "px, " + "0px)";
	  rotateCircle(rightCircle, 0, 180, Math.min(1, percentage * 2));
	  rotateCircle(leftCircle, 0, 360, percentage);
	};
	
	var handlePercentage = function handlePercentage(percentage, state, size, attrs) {
	  if (!state.dom()) {
	    return;
	  }
	  if (state.animating()) {
	    return;
	  }
	  var previousPercentage = state.percentage();
	  if (attrs.animated && previousPercentage !== percentage) {
	    var animationDuration = (attrs.updateDuration || DEFAULT_UPDATE_DURATION) * 1000;
	    var el = state.dom();
	    var start = null;
	    var step = function step(timestamp) {
	      if (!start) start = timestamp;
	      var progress = timestamp - start;
	      var stepPercentage = 1.0 / animationDuration * progress;
	      var newPercentage = previousPercentage + stepPercentage * (percentage - previousPercentage);
	      animate(el, size, polytheneUtilities.easing.easeInOutQuad(newPercentage));
	      if (start && progress < animationDuration) {
	        window.requestAnimationFrame(step);
	      } else {
	        start = null;
	        state.percentage(percentage);
	        state.animating(false);
	      }
	    };
	    state.animating(true);
	    window.requestAnimationFrame(step);
	  } else {
	    animate(state.dom(), size, percentage);
	    state.percentage(percentage);
	  }
	};
	
	var notifyState = function notifyState(state, attrs, size) {
	  if (attrs.percentage !== undefined) {
	    var percentage = polytheneCore.unpackAttrs(attrs.percentage);
	    handlePercentage(percentage, state, size, attrs);
	  }
	};
	
	var getSize = function getSize(attrs) {
	  var rawSize = sizeFromName(attrs.size);
	
	  var _themeVars$raisedSize = themeVars.raisedSize(rawSize),
	      padding = _themeVars$raisedSize.padding,
	      paddedSize = _themeVars$raisedSize.paddedSize;
	
	  return attrs.raised ? paddedSize - 2 * padding : rawSize;
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var percentage = createStream(0);
	  var dom = createStream(null);
	  var animating = createStream(false);
	  return {
	    dom: dom,
	    percentage: percentage,
	    animating: animating
	  };
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.dom(vnode.dom);
	  var size = getSize(attrs);
	  notifyState(state, attrs, size);
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var h = _ref.renderer;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var size = getSize(attrs);
	  notifyState(state, attrs, size);
	
	  var content = h("div", {
	    key: "content",
	    className: classes.animation,
	    style: {
	      width: size + "px",
	      height: size + "px"
	    }
	  }, [h("div", {
	    key: "left",
	    className: [classes.circle, classes.circleLeft].join(" ")
	  }), h("div", {
	    key: "right",
	    className: [classes.circle, classes.circleRight].join(" ")
	  })]);
	
	  return _extends({}, attrs, {
	    className: [classes.component, attrs.className].join(" "),
	    content: content
	  });
	};
	
	var spinner = Object.freeze({
		getInitialState: getInitialState,
		onMount: onMount,
		createProps: createProps
	});
	
	exports.coreMaterialDesignProgressSpinner = spinner;
	exports.vars = themeVars;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-material-design-progress-spinner.js.map


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(3), __webpack_require__(21)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-theme', 'polythene-core-base-spinner'], factory) :
		(factory((global.polythene = {}),global['polythene-theme'],global['polythene-core-base-spinner']));
	}(this, (function (exports,polytheneTheme,polytheneCoreBaseSpinner) { 'use strict';
	
	var classes = {
	  component: "pe-md-spinner",
	
	  // elements
	  animation: "pe-md-spinner__animation",
	  circle: "pe-md-spinner__circle",
	  circleClipper: "pe-md-spinner__circle-clipper",
	  circleClipperLeft: "pe-md-spinner__circle-clipper-left",
	  circleClipperRight: "pe-md-spinner__circle-clipper-right",
	  gapPatch: "pe-md-spinner__gap-patch",
	  layer: "pe-md-spinner__layer",
	  layerN: "pe-md-spinner__layer-"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var layer = function layer(num, h) {
	  return h("div", {
	    key: num,
	    className: [classes.layer, classes.layerN + num].join(" ")
	  }, [h("div", {
	    key: "clipper-left",
	    className: [classes.circleClipper, classes.circleClipperLeft].join(" ")
	  }, h("div", {
	    key: "circle",
	    className: classes.circle
	  })), h("div", {
	    key: "gap-patch",
	    className: classes.gapPatch
	  }, h("div", { className: classes.circle })), h("div", {
	    key: "clipper-right",
	    className: [classes.circleClipper, classes.circleClipperRight].join(" ")
	  }, h("div", { className: classes.circle }))]);
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var h = _ref.renderer;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.content = state.content || h("div", {
	    key: "content",
	    className: classes.animation
	  }, [1, 2, 3, 4].map(function (num) {
	    return layer(num, h);
	  }));
	  return _extends({}, attrs, {
	    className: [classes.component, attrs.className].join(" "),
	    content: state.content
	  });
	};
	
	var spinner = Object.freeze({
		createProps: createProps
	});
	
	/*
	Derived from https://github.com/PolymerElements/paper-spinner
	
	@license
	Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
	This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
	The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
	The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
	Code distributed by Google as part of the polymer project is also
	subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
	*/
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var arc_size = 270; // degrees - amount of circle the arc takes up
	var arc_time = 1.333; // s - time it takes to expand and contract arc
	var arc_start_degrees = 360 / 5 * 3; // degrees - how much the start location of the arc should rotate each time, 216 gives us a 5 pointed star shape (it"s 360/5 * 3). For a 7 pointed star, we might do 360/7 * 3 = 154.286.
	var rotation_duration = 360 * arc_time / (arc_start_degrees + (360 - arc_size)); // 1.568s
	
	var blue400 = "#42a5f5";
	var red500 = "#f44336";
	var yellow600 = "#fdd835";
	var green500 = "#4caf50";
	
	var vars$2 = {
	  border_width_small: polytheneCoreBaseSpinner.vars.size_small / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  border_width_regular: 3,
	  border_width_medium: polytheneCoreBaseSpinner.vars.size_medium / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  border_width_large: polytheneCoreBaseSpinner.vars.size_large / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  border_width_fab: polytheneCoreBaseSpinner.vars.size_fab / polytheneCoreBaseSpinner.vars.size_regular * 3,
	  rotation_duration: rotation_duration,
	  arc_size: arc_size,
	  arc_time: arc_time,
	  arc_start_degrees: arc_start_degrees,
	
	  color_light_single: rgba(polytheneTheme.vars.color_primary),
	  color_light_1: blue400,
	  color_light_2: red500,
	  color_light_3: yellow600,
	  color_light_4: green500,
	
	  color_dark_single: rgba(polytheneTheme.vars.color_primary),
	  color_dark_1: blue400,
	  color_dark_2: red500,
	  color_dark_3: yellow600,
	  color_dark_4: green500
	};
	
	exports.coreMaterialDesignSpinner = spinner;
	exports.vars = vars$2;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-material-design-spinner.js.map


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var listTileClasses = {
	  component: "pe-list-tile",
	
	  // elements
	  content: "pe-list-tile__content",
	  highSubtitle: "pe-list-tile__high-subtitle",
	  primary: "pe-list-tile__primary",
	  secondary: "pe-list-tile__secondary",
	  subtitle: "pe-list-tile__subtitle",
	  title: "pe-list-tile__title",
	  contentFront: "pe-list-tile__content-front",
	
	  // states
	  compact: "pe-list-tile--compact",
	  compactFront: "pe-list-tile--compact-front",
	  disabled: "pe-list-tile--disabled",
	  hasFront: "pe-list-tile--front",
	  hasHighSubtitle: "pe-list-tile--high-subtitle",
	  hasSubtitle: "pe-list-tile--subtitle",
	  header: "pe-list-tile--header",
	  hoverable: "pe-list-tile--hoverable",
	  selectable: "pe-list-tile--selectable",
	  selected: "pe-list-tile--selected",
	  highlight: "pe-list-tile--highlight",
	  sticky: "pe-list-tile--sticky"
	};
	
	var classes = {
	  component: "pe-menu",
	
	  // elements
	  content: "pe-menu__content",
	  placeholder: "pe-menu__placeholder",
	  target: "pe-menu__target",
	
	  // states
	  permanent: "pe-menu--permanent",
	  visible: "pe-menu--visible",
	  width_auto: "pe-menu--width-auto",
	  width_n: "pe-menu--width-",
	
	  // lookup
	  listTile: listTileClasses.component,
	  selectedListTile: listTileClasses.selected
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var SHADOW_Z = 1;
	var OFFSET_V = -8;
	var DEFAULT_OFFSET_H = 0;
	var MIN_SIZE = 1.5;
	
	var positionMenu = function positionMenu(state, attrs) {
	  if (polytheneCore.isServer) {
	    return;
	  }
	  var targetEl = document.querySelector(attrs.target);
	  if (!targetEl) {
	    return;
	  }
	  var offsetH = attrs.offset !== undefined ? attrs.offset : DEFAULT_OFFSET_H;
	  var menuEl = state.dom();
	  if (!menuEl) {
	    return;
	  }
	  var contentEl = state.dom().querySelector("." + classes.content);
	  var origin = attrs.origin || "top-left";
	  var positionOffset = 0;
	  if (attrs.reposition) {
	    var firstItem = contentEl.querySelectorAll("." + classes.listTile)[0];
	    var selectedItem = contentEl.querySelector("." + classes.selectedListTile);
	    if (firstItem && selectedItem) {
	      // calculate v position: menu should shift upward relative to the first item
	      var firstItemRect = firstItem.getBoundingClientRect();
	      var selectedItemRect = selectedItem.getBoundingClientRect();
	      positionOffset = selectedItemRect.top - firstItemRect.top;
	    }
	    // align to middle of target
	    var alignEl = selectedItem || firstItem;
	    var alignRect = alignEl.getBoundingClientRect();
	    var _targetRect = targetEl.getBoundingClientRect();
	    var heightDiff = alignRect.height - _targetRect.height;
	    positionOffset += heightDiff / 2;
	  }
	  var targetRect = targetEl.getBoundingClientRect();
	  if (menuEl.parentNode) {
	    var parentRect = menuEl.parentNode.getBoundingClientRect();
	    var alignLeft = function alignLeft() {
	      return menuEl.style.left = targetRect.left - parentRect.left + offsetH + "px";
	    };
	    var alignRight = function alignRight() {
	      return menuEl.style.right = targetRect.right - parentRect.right + offsetH + "px";
	    };
	    var alignTop = function alignTop() {
	      return menuEl.style.top = targetRect.top - parentRect.top - positionOffset + OFFSET_V + "px";
	    };
	    var alignBottom = function alignBottom() {
	      return menuEl.style.bottom = targetRect.bottom - parentRect.bottom - positionOffset + "px";
	    };
	    var alignFn = {
	      "top-left": function topLeft() {
	        return alignTop() && alignLeft();
	      },
	      "top-right": function topRight() {
	        return alignTop() && alignRight();
	      },
	      "bottom-left": function bottomLeft() {
	        return alignBottom() && alignLeft();
	      },
	      "bottom-right": function bottomRight() {
	        return alignBottom() && alignRight();
	      }
	    };
	    alignFn[origin].call();
	  }
	};
	
	var showMenu = function showMenu(state, attrs) {
	  if (attrs.onChange) {
	    attrs.onChange({ visible: false, transitioning: true });
	  }
	  positionMenu(state, attrs);
	  var transitions = attrs.transitions;
	  var el = state.dom();
	  return polytheneCore.show(_extends({}, attrs, transitions ? transitions.show(el, attrs) : {
	    el: el,
	    showClass: classes.visible
	  })).then(function () {
	    if (attrs.onChange) {
	      attrs.onChange({ visible: true, transitioning: false });
	    }
	    if (attrs.didShow) {
	      attrs.didShow(attrs.id);
	    }
	    state.visible(false);
	  });
	};
	
	var hideMenu = function hideMenu(state, attrs) {
	  if (attrs.onChange) {
	    attrs.onChange({ visible: true, transitioning: true });
	  }
	  var transitions = attrs.transitions;
	  var el = state.dom();
	  return polytheneCore.hide(_extends({}, attrs, transitions ? transitions.hide(el, attrs) : {
	    el: el,
	    showClass: classes.visible
	  })).then(function () {
	    if (attrs.onChange) {
	      attrs.onChange({ visible: false, transitioning: false });
	    }
	    if (attrs.didHide) {
	      attrs.didHide(attrs.id);
	    }
	    state.visible(false);
	  });
	};
	
	var unifySize = function unifySize(size) {
	  return size < MIN_SIZE ? MIN_SIZE : size;
	};
	
	var widthClass = function widthClass(size) {
	  return classes.width_n + size.toString().replace(".", "-");
	};
	
	var handleSubscriptions = function handleSubscriptions(vnode, which) {
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  if (which === "mount") {
	    polytheneCore.subscribe("resize", state.update);
	    polytheneCore.subscribe("keydown", state.handleEscape);
	    setTimeout(function () {
	      state.activateDismissTap();
	      showMenu(state, attrs);
	    }, 0);
	  } else {
	    polytheneCore.unsubscribe("resize", state.update);
	    polytheneCore.unsubscribe("keydown", state.handleEscape);
	    state.deActivateDismissTap();
	  }
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  state.dom(vnode.dom);
	
	  if (!attrs.permanent) {
	    state.handleDismissTap = function (e) {
	      if (e.target === state.dom()) {
	        return;
	      }
	      if (e.defaultPrevented) {
	        // clicked on .pe-menu__content
	        hideMenu(state, attrs);
	      } else {
	        hideMenu(state, _extends({}, attrs, {
	          hideDelay: 0
	        }));
	      }
	    };
	
	    state.update = function () {
	      positionMenu(state, attrs);
	    };
	
	    state.activateDismissTap = function () {
	      if (polytheneCore.isTouch) {
	        document.addEventListener("touchstart", state.handleDismissTap);
	      } else {
	        document.addEventListener("click", state.handleDismissTap);
	      }
	    };
	
	    state.deActivateDismissTap = function () {
	      if (polytheneCore.isTouch) {
	        document.removeEventListener("touchstart", state.handleDismissTap);
	      } else {
	        document.removeEventListener("click", state.handleDismissTap);
	      }
	    };
	
	    state.handleEscape = function (e) {
	      if (e.key === "Escape" || e.key === "Esc") {
	        hideMenu(state, _extends({}, attrs, { hideDelay: 0 }));
	      }
	    };
	
	    handleSubscriptions(vnode, "mount");
	  }
	};
	
	var onUnMount = function onUnMount(vnode) {
	  var attrs = vnode.attrs;
	  if (!attrs.permanent) {
	    handleSubscriptions(vnode, "unmount");
	  }
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var dom = createStream(null);
	  var visible = createStream(false);
	  return {
	    dom: dom,
	    visible: visible,
	    activateDismissTap: undefined, // set in onMount
	    deActivateDismissTap: undefined, // set in onMount
	    handleDismissTap: undefined, // set in onMount
	    handleEscape: undefined, // set in onMount
	    update: undefined, // set in onMount
	    redrawOnUpdate: createStream.merge([visible])
	  };
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.permanent ? classes.permanent : null, attrs.target ? classes.target : null, attrs.size ? widthClass(unifySize(attrs.size)) : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var _h;
	
	  var h = _ref2.renderer,
	      k = _ref2.keys,
	      Shadow = _ref2.Shadow;
	
	  var attrs = vnode.attrs;
	  var z = attrs.z !== undefined ? attrs.z : SHADOW_Z;
	  return h("div", (_h = {
	    className: classes.content
	  }, _defineProperty(_h, k.onclick, function (e) {
	    return e.preventDefault();
	  }), _defineProperty(_h, "style", attrs.style), _h), [z > 0 && h(Shadow, {
	    z: z,
	    animated: true
	  }), attrs.content ? attrs.content : vnode.children]);
	};
	
	var menu = Object.freeze({
		getElement: getElement,
		onMount: onMount,
		onUnMount: onUnMount,
		getInitialState: getInitialState,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  sizes: [1, 1.5, 2, 3, 4, 5, 6, 7],
	  min_size: 1.5,
	  max_size_small_screen: 5,
	  size_factor: polytheneTheme.vars.grid_unit_menu,
	  border_radius: polytheneTheme.vars.unit_block_border_radius,
	
	  color_light_background: rgba(polytheneTheme.vars.color_light_background),
	  color_dark_background: rgba(polytheneTheme.vars.color_dark_background)
	  // text colors are set by content, usually list tiles
	};
	
	exports.coreMenu = menu;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-menu.js.map


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(14)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core-selection-control'], factory) :
		(factory((global.polythene = {}),global['polythene-core-selection-control']));
	}(this, (function (exports,polytheneCoreSelectionControl) { 'use strict';
	
	var classes = {
	  component: "pe-radio-control"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Don't export 'element': it will be the wrapped selection control component (set in polythene-xxx-checkbox)
	
	var iconOn = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"/></svg>";
	var iconOff = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"/></svg>";
	
	var icons = {
	  iconOff: iconOff,
	  iconOn: iconOn
	};
	
	// Props to be passed to a selection control
	
	var createProps = function createProps(vnode) {
	  var attrs = vnode.attrs;
	  return _extends({}, attrs, {
	    icons: icons,
	    selectable: attrs.selectable || function (selected) {
	      return !selected;
	    }, // default: only selectable when not checked
	    instanceClass: classes.component,
	    type: "radio"
	  });
	};
	
	var radioButton = Object.freeze({
		createProps: createProps
	});
	
	exports.coreRadioButton = radioButton;
	exports.vars = polytheneCoreSelectionControl.vars;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-radio-button.js.map


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core'], factory) :
		(factory((global.polythene = {}),global['polythene-core']));
	}(this, (function (exports,polytheneCore) { 'use strict';
	
	var classes = {
	  component: "pe-radio-group"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var checkedValue = createStream(null);
	  return {
	    checkedValue: checkedValue,
	    redrawOnUpdate: createStream.merge([checkedValue])
	  };
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      RadioButton = _ref2.RadioButton;
	
	  var attrs = vnode.attrs;
	  var state = vnode.state;
	  var checkedValue = state.checkedValue();
	
	  var buttons = attrs.content ? attrs.content : attrs.buttons ? attrs.buttons : attrs.children || vnode.children || [];
	
	  return buttons.length ? buttons.map(function (buttonOpts) {
	    if (!buttonOpts) {
	      return null;
	    }
	    // Only set defaultChecked the first time when no value has been stored yet
	    var isDefaultChecked = (buttonOpts.defaultChecked || buttonOpts.checked) && checkedValue === null;
	    if (buttonOpts.value === undefined) {
	      console.error("Option 'value' not set for radio button"); // eslint-disable-line no-console
	    }
	    var isChecked = isDefaultChecked || buttonOpts.checked || checkedValue === buttonOpts.value;
	    return h(RadioButton, _extends({}, {
	      /* group attributes that may be overwritten by individual buttons */
	      name: attrs.name,
	      key: buttonOpts.value
	    }, attrs.all,
	    /* individual button options */
	    buttonOpts, {
	      /* this component's options */
	      onChange: function onChange(newState) {
	        return state.checkedValue(newState.value), attrs.onChange && attrs.onChange({ value: newState.value });
	      },
	      checked: isChecked
	    }));
	  }) : null;
	};
	
	var radioGroup = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		createProps: createProps,
		createContent: createContent
	});
	
	exports.coreRadioGroup = radioGroup;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-radio-group.js.map


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-button pe-text-button pe-raised-button"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Don't export 'getElement': it will be the wrapped button component (set in polythene-xxx-raised-button)
	
	var MAX_Z = 5;
	
	var tapStart = void 0;
	var tapEndAll = function tapEndAll() {};
	var downButtons = [];
	
	polytheneCore.subscribe(polytheneCore.pointerEndEvent, function () {
	  return tapEndAll();
	});
	
	var animateZ = function animateZ(which, vnode) {
	  var zBase = vnode.state.zBase;
	  var increase = vnode.attrs.increase || 1;
	  var z = vnode.state.z();
	  var newZ = which === "down" && zBase < MAX_Z ? Math.min(zBase + increase, MAX_Z) : which === "up" ? Math.max(z - increase, zBase) : z;
	  if (newZ !== z) {
	    vnode.state.z(newZ);
	  }
	};
	
	var tapHandler = function tapHandler(which, vnode) {
	  if (which === "down") {
	    downButtons.push(_extends({}, vnode));
	  }
	  var animateOnTap = vnode.attrs.animateOnTap !== false ? true : false;
	  if (animateOnTap) {
	    animateZ(which, vnode);
	  }
	};
	
	var initTapEvents = function initTapEvents(vnode) {
	  if (polytheneCore.isServer) return;
	  tapStart = function tapStart() {
	    return tapHandler("down", vnode);
	  };
	  tapEndAll = function tapEndAll() {
	    downButtons.map(function (buttonVnode) {
	      return tapHandler("up", buttonVnode);
	    });
	    downButtons = [];
	  };
	  vnode.dom.addEventListener(polytheneCore.pointerStartMoveEvent, tapStart);
	};
	
	var clearTapEvents = function clearTapEvents(vnode) {
	  return vnode.dom.removeEventListener(polytheneCore.pointerStartMoveEvent, tapStart);
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var attrs = vnode.attrs;
	  var zBase = attrs.z !== undefined ? attrs.z : 1;
	  var z = createStream(zBase);
	  var tapEventsInited = createStream(false);
	  return {
	    zBase: zBase,
	    z: z,
	    tapEventsInited: tapEventsInited,
	    redrawOnUpdate: createStream.merge([z])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  var state = vnode.state;
	  if (vnode.dom && !state.tapEventsInited()) {
	    initTapEvents(vnode);
	    state.tapEventsInited(true);
	  }
	};
	
	var onUnMount = function onUnMount(vnode) {
	  if (vnode.state.tapEventsInited()) {
	    clearTapEvents(vnode);
	  }
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var h = _ref.renderer,
	      Shadow = _ref.Shadow;
	
	  var attrs = vnode.attrs;
	  var state = vnode.state;
	  var children = attrs.children || vnode.children || [];
	  return _extends({}, {
	    parentClassName: [attrs.parentClassName || classes.component].join(" "),
	    animateOnTap: false,
	    shadowComponent: h(Shadow, {
	      z: attrs.disabled ? 0 : state.z,
	      animated: true
	    }),
	    children: children
	  }, attrs);
	};
	
	var createContent = function createContent() {
	  return null;
	};
	
	var raisedButton = Object.freeze({
		getInitialState: getInitialState,
		onMount: onMount,
		onUnMount: onUnMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$1 = {
	  color_light_background: "#fff",
	  color_light_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_light_hover_background: "transparent",
	  color_light_focus_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover),
	  color_light_active_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_hover), // same as hover
	  color_light_disabled_background: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_disabled),
	  color_light_disabled_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	
	  color_dark_background: rgba(polytheneTheme.vars.color_primary),
	  color_dark_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_hover_background: polytheneTheme.vars.color_primary_active,
	  color_dark_focus_background: polytheneTheme.vars.color_primary_active,
	  color_dark_active_background: polytheneTheme.vars.color_primary_dark,
	  color_dark_disabled_background: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_background_disabled),
	  color_dark_disabled_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled)
	};
	
	exports.coreRaisedButton = raisedButton;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-raised-button.js.map


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var ANIMATION_END_EVENT = polytheneCore.getAnimationEndEvent();
	var DEFAULT_START_OPACITY = 0.2;
	var DEFAULT_END_OPACITY = 0.0;
	var DEFAULT_START_SCALE = 0.1;
	var DEFAULT_END_SCALE = 2.0;
	var OPACITY_DECAY_VELOCITY = 0.35;
	
	var addStyleToHead = function addStyleToHead(id, stylesheet) {
	  if (polytheneCore.isServer) return;
	  var documentRef = window.document;
	  var styleEl = documentRef.createElement("style");
	  styleEl.setAttribute("id", id);
	  styleEl.appendChild(documentRef.createTextNode(stylesheet));
	  documentRef.head.appendChild(styleEl);
	};
	
	var removeStyleFromHead = function removeStyleFromHead(id) {
	  if (polytheneCore.isServer) return;
	  var el = document.getElementById(id);
	  if (el && el.parentNode) {
	    el.parentNode.removeChild(el);
	  }
	};
	
	var animation = (function (_ref) {
	  var e = _ref.e,
	      id = _ref.id,
	      el = _ref.el,
	      attrs = _ref.attrs,
	      classes = _ref.classes;
	
	  return new Promise(function (resolve) {
	    var container = document.createElement("div");
	    container.setAttribute("class", classes.mask);
	    el.appendChild(container);
	    var waves = document.createElement("div");
	    waves.setAttribute("class", classes.waves);
	    container.appendChild(waves);
	    var rect = el.getBoundingClientRect();
	    var x = polytheneCore.isTouch && e.touches ? e.touches[0].pageX : e.clientX;
	    var y = polytheneCore.isTouch && e.touches ? e.touches[0].pageY : e.clientY;
	    var w = el.offsetWidth;
	    var h = el.offsetHeight;
	    var waveRadius = Math.sqrt(w * w + h * h);
	    var mx = attrs.center ? rect.left + rect.width / 2 : x;
	    var my = attrs.center ? rect.top + rect.height / 2 : y;
	    var rx = mx - rect.left - waveRadius / 2;
	    var ry = my - rect.top - waveRadius / 2;
	    var startOpacity = attrs.startOpacity !== undefined ? attrs.startOpacity : DEFAULT_START_OPACITY;
	    var opacityDecayVelocity = attrs.opacityDecayVelocity !== undefined ? attrs.opacityDecayVelocity : OPACITY_DECAY_VELOCITY;
	    var endOpacity = attrs.endOpacity || DEFAULT_END_OPACITY;
	    var startScale = attrs.startScale || DEFAULT_START_SCALE;
	    var endScale = attrs.endScale || DEFAULT_END_SCALE;
	    var duration = attrs.duration ? attrs.duration : 1 / opacityDecayVelocity * 0.2;
	    var color = window.getComputedStyle(el).color;
	
	    var style = waves.style;
	    style.width = style.height = waveRadius + "px";
	    style.top = ry + "px";
	    style.left = rx + "px";
	    style["animation-duration"] = style["-webkit-animation-duration"] = style["-moz-animation-duration"] = style["-o-animation-duration"] = duration + "s";
	    style.backgroundColor = color;
	    style.opacity = startOpacity;
	    style.animationName = id;
	    style.animationTimingFunction = attrs.animationTimingFunction || polytheneTheme.vars.animation_curve_default;
	
	    var rippleStyleSheet = "@keyframes " + id + " {\n      0% {\n        transform:scale(" + startScale + ");\n        opacity: " + startOpacity + "\n      }\n      100% {\n        transform:scale(" + endScale + ");\n        opacity: " + endOpacity + ";\n      }\n    }";
	    addStyleToHead(id, rippleStyleSheet);
	
	    var animationDone = function animationDone(evt) {
	      removeStyleFromHead(id);
	      waves.removeEventListener(ANIMATION_END_EVENT, animationDone, false);
	      if (attrs.persistent) {
	        style.opacity = endOpacity;
	        style.transform = "scale(" + endScale + ")";
	      } else {
	        waves.classList.remove(classes.wavesAnimating);
	        container.removeChild(waves);
	        el.removeChild(container);
	      }
	      resolve(evt);
	    };
	
	    waves.addEventListener(ANIMATION_END_EVENT, animationDone, false);
	    waves.classList.add(classes.wavesAnimating);
	  });
	});
	
	var classes = {
	  component: "pe-ripple",
	
	  // elements
	  mask: "pe-ripple__mask",
	  waves: "pe-ripple__waves",
	
	  // states
	  unconstrained: "pe-ripple--unconstrained",
	  wavesAnimating: "pe-ripple__waves--animating"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var getInitialState = function getInitialState() {
	  return {
	    animations: {},
	    animating: false,
	    cleanUp: undefined
	  };
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.unconstrained ? classes.unconstrained : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var updateAnimationState = function updateAnimationState(state) {
	  return state.animating = Object.keys(state.animations).length > 0;
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom && polytheneCore.isServer) {
	    return;
	  }
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  var tap = function tap(e) {
	    if (attrs.disabled || !attrs.multi && state.animating) {
	      return;
	    }
	    if (attrs.start) {
	      attrs.start(e);
	    }
	    var id = "ripple_animation_" + new Date().getTime();
	    state.animations[id] = animation({ e: e, id: id, el: vnode.dom, attrs: attrs, classes: classes }).then(function (evt) {
	      if (attrs.end) {
	        attrs.end(evt);
	      }
	      delete state.animations[id];
	      updateAnimationState(state);
	    });
	    updateAnimationState(state);
	  };
	  var triggerEl = attrs.target ? attrs.target : vnode.dom && vnode.dom.parentElement;
	
	  triggerEl.addEventListener(polytheneCore.pointerEndEvent, tap, false);
	  state.cleanUp = function () {
	    return triggerEl.removeEventListener(polytheneCore.pointerEndEvent, tap, false);
	  };
	};
	
	var onUnMount = function onUnMount(_ref2) {
	  var state = _ref2.state;
	  return state.cleanUp && state.cleanUp();
	};
	
	var ripple = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		createProps: createProps,
		onMount: onMount,
		onUnMount: onUnMount
	});
	
	var vars$1 = {
	  color: "inherit" // only specify this variable to get both states
	  // color_light:   "inherit",
	  // color_dark:    "inherit"
	};
	
	exports.coreRipple = ripple;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-ripple.js.map


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-search",
	
	  // elements
	  content: "pe-search__content",
	
	  // states
	  searchFullWidth: "pe-search--full-width",
	  searchInset: "pe-search--inset"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var getNameOfState = function getNameOfState(state) {
	  return state.focus && state.dirty ? "focus_dirty" : state.focus ? "focus" : state.dirty ? "dirty" : "none";
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var searchState = createStream({});
	  return {
	    searchState: searchState
	  };
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.fullWidth ? classes.searchFullWidth : classes.searchInset, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.events);
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer,
	      TextField = _ref2.TextField;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var searchState = getNameOfState(state.searchState());
	  var buttons = (attrs.buttons || {})[searchState] || {};
	  var textfieldAttrs = attrs.textfield || {};
	  return h("div", { className: classes.content }, [buttons.before, h(TextField, _extends({}, textfieldAttrs, {
	    key: "input",
	    onChange: function onChange(newState) {
	      state.searchState(newState);
	      if (textfieldAttrs.onChange) {
	        textfieldAttrs.onChange(newState);
	      }
	    }
	  })), buttons.after]);
	};
	
	var search = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var insetSideMargin = 8;
	var line_height_input = 20;
	var font_size_input = 20;
	var inset_height = 48;
	var inset_input_indent = 16;
	var inset_input_right_padding = 0;
	var inset_side_padding = 0;
	var inset_border_radius = polytheneTheme.vars.unit_block_border_radius;
	var full_width_side_margin = 0;
	var full_width_height = 56;
	var full_width_side_padding = insetSideMargin;
	var full_width_input_right_padding = 0;
	var full_width_border_radius = 0;
	
	var vars$1 = {
	  font_size_input: font_size_input,
	  line_height_input: line_height_input,
	
	  inset_height: inset_height,
	  inset_input_indent: inset_input_indent,
	  inset_side_padding: inset_side_padding,
	  inset_input_right_padding: inset_input_right_padding,
	  inset_border_radius: inset_border_radius,
	
	  full_width_height: full_width_height,
	  full_width_side_margin: full_width_side_margin,
	  full_width_side_padding: full_width_side_padding,
	  full_width_input_right_padding: full_width_input_right_padding,
	  full_width_border_radius: full_width_border_radius,
	
	  color_light_label_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	  color_light_input_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_light_background: rgba(polytheneTheme.vars.color_light_background),
	
	  color_dark_label_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled),
	  color_dark_input_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_background: rgba(polytheneTheme.vars.color_dark_background)
	};
	
	exports.coreSearch = search;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-search.js.map


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-shadow",
	
	  // elements
	  bottomShadow: "pe-shadow__bottom",
	  topShadow: "pe-shadow__top",
	
	  // states
	  animated: "pe-shadow--animated",
	  depth_n: "pe-shadow--z-"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.animated && classes.animated, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref2) {
	  var h = _ref2.renderer;
	
	  var attrs = vnode.attrs;
	  var content = attrs.content ? attrs.content : attrs.children || vnode.children;
	  var depthClass = "" + classes.depth_n + Math.min(5, attrs.z !== undefined ? attrs.z : 1);
	  return [content, h("div", {
	    key: "bottom",
	    className: [classes.bottomShadow, depthClass].join(" ")
	  }), h("div", {
	    key: "top",
	    className: [classes.topShadow, depthClass].join(" ")
	  })];
	};
	
	var shadow = Object.freeze({
		getElement: getElement,
		createProps: createProps,
		createContent: createContent
	});
	
	var vars$1 = {
	  transition: "box-shadow " + polytheneTheme.vars.animation_duration + " ease-out",
	
	  "shadow-top-z-1": "initial",
	  "shadow-bottom-z-1": "0 1px 4px 0 rgba(0, 0, 0, 0.37)",
	
	  "shadow-top-z-2": "0 2px 2px 0 rgba(0, 0, 0, 0.2)",
	  "shadow-bottom-z-2": "0 6px 10px 0 rgba(0, 0, 0, 0.3)",
	
	  "shadow-top-z-3": "0 11px 7px 0 rgba(0, 0, 0, 0.19)",
	  "shadow-bottom-z-3": "0 13px 25px 0 rgba(0, 0, 0, 0.3)",
	
	  "shadow-top-z-4": "0 14px 12px 0 rgba(0, 0, 0, 0.17)",
	  "shadow-bottom-z-4": "0 20px 40px 0 rgba(0, 0, 0, 0.3)",
	
	  "shadow-top-z-5": "0 17px 17px 0 rgba(0, 0, 0, 0.15)",
	  "shadow-bottom-z-5": "0 27px 55px 0 rgba(0, 0, 0, 0.3)",
	
	  "shadow-down-z-1": "inset 0px 1px 2px -1px rgba(0, 0, 0, 0.15)",
	  "shadow-down-z-2": "inset 0px 4px 6px -3px rgba(0, 0, 0, 0.25)"
	};
	
	exports.coreShadow = shadow;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-shadow.js.map


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var lightForeground = polytheneTheme.vars.color_light_foreground;
	var darkForeground = polytheneTheme.vars.color_dark_foreground;
	var activeColor = polytheneTheme.vars.color_primary; // or override in CSS by setting 'color' property on '.pe-slider'
	var thumb_size = 12;
	var thumb_touch_size = Math.max(40, thumb_size);
	var thumb_border_width = 2;
	var active_thumb_scale = 3 / 2;
	var disabled_thumb_scale = 1 / 2;
	var active_pin_thumb_scale = 2 / 6;
	var largestThumbSize = active_thumb_scale * thumb_size;
	var largestElement = Math.max(thumb_touch_size, largestThumbSize);
	var height = Math.max(52, largestThumbSize);
	var side_spacing = Math.max(10, largestElement / 2 - thumb_size / 2);
	var horizontal_layout_side_spacing = side_spacing + 4; // optimization for horizontal layout
	
	var themeVars = {
	  height: height,
	  side_spacing: side_spacing,
	  horizontal_layout_side_spacing: horizontal_layout_side_spacing,
	  thumb_size: thumb_size,
	  thumb_touch_size: thumb_touch_size,
	  track_height: height,
	  bar_height: 2,
	  thumb_border_width: thumb_border_width,
	  active_thumb_scale: active_thumb_scale,
	  animation_duration: polytheneTheme.vars.animation_duration,
	  disabled_thumb_scale: disabled_thumb_scale,
	  active_pin_thumb_scale: active_pin_thumb_scale,
	
	  step_width: 2,
	  pin_height: 32,
	  pin_width: 26,
	  pin_font_size: 10,
	
	  color_light_track_active: rgba(lightForeground, .38),
	  color_light_track_inactive: rgba(lightForeground, .26),
	  color_light_track_value: rgba(activeColor),
	  // background color may be set in theme; disabled by default
	  // color_light_thumb_background:        undefined,
	  color_light_thumb_off: rgba(lightForeground, .26),
	  color_light_thumb_off_focus: rgba(lightForeground),
	  color_light_thumb_off_focus_opacity: .08,
	  color_light_thumb_on: rgba(activeColor),
	  color_light_thumb_on_focus_opacity: .11,
	  color_light_thumb_inactive: rgba(lightForeground, .26),
	  color_light_tick: rgba(lightForeground, 1),
	  color_light_icon: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_disabled_icon: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	  color_light_label: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_secondary),
	  color_light_disabled_label: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	
	  color_dark_track_active: rgba(darkForeground, .3),
	  color_dark_track_inactive: rgba(darkForeground, .2),
	  color_dark_track_value: rgba(activeColor),
	  // background color may be set in theme; disabled by default
	  // color_dark_thumb_background:         undefined,
	  color_dark_thumb_off: rgba(darkForeground, .2),
	  color_dark_thumb_off_focus: rgba(darkForeground),
	  color_dark_thumb_off_focus_opacity: .08,
	  color_dark_thumb_on: rgba(activeColor),
	  color_dark_thumb_on_focus_opacity: .11,
	  color_dark_thumb_inactive: rgba(darkForeground, .2),
	  color_dark_tick: rgba(darkForeground, 1),
	  color_dark_icon: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_disabled_icon: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled),
	  color_dark_label: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_secondary),
	  color_dark_disabled_label: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled)
	};
	
	var classes = {
	  component: "pe-slider",
	
	  // elements
	  control: "pe-slider__control",
	  label: "pe-slider__label",
	  pin: "pe-slider__pin",
	  thumb: "pe-slider__thumb",
	  tick: "pe-slider__ticks-tick",
	  ticks: "pe-slider__ticks",
	  track: "pe-slider__track",
	  trackBar: "pe-slider__track-bar",
	  trackBarValue: "pe-slider__track-bar-value",
	  trackPart: "pe-slider__track-part",
	  trackPartRest: "pe-slider__track-rest",
	  trackPartValue: "pe-slider__track-value",
	
	  // states
	  hasFocus: "pe-slider--focus",
	  hasPin: "pe-slider--pin",
	  hasTicks: "pe-slider--ticks",
	  hasTrack: "pe-slider--track",
	  isActive: "pe-slider--active",
	  isAtMin: "pe-slider--min",
	  isDisabled: "pe-slider--disabled"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MAX_TICKS = 100;
	var focusElement = void 0;
	
	var deFocus = function deFocus(state) {
	  if (focusElement) {
	    focusElement.blur();
	  }
	  focusElement = undefined;
	  state.hasFocus(false);
	};
	
	var focus = function focus(state, el) {
	  deFocus(state);
	  focusElement = el;
	  state.hasFocus(true);
	};
	
	var positionFromEvent = function positionFromEvent(e, isVertical) {
	  return (
	    // isVertical not yet implemented
	    polytheneCore.isTouch && e.touches ? isVertical ? e.touches[0].pageY : e.touches[0].pageX : isVertical ? e.pageY : e.pageX
	  );
	};
	
	var updatePinPosition = function updatePinPosition(state) {
	  if (state.controlEl && state.pinEl) {
	    var left = state.fraction() * state.rangeWidth;
	    state.pinEl.style.left = left + "px";
	  }
	};
	
	var updateValue = function updateValue(state, value) {
	  state.setValue(value, true);
	  updatePinPosition(state);
	};
	
	var generateTickMarks = function generateTickMarks(h, stepCount) {
	  var items = [];
	  var s = stepCount + 1;
	  while (s > 0) {
	    items.push(h("div", {
	      className: classes.tick,
	      key: "tick-" + s
	    }));
	    s--;
	  }
	  return items;
	};
	
	var readRangeData = function readRangeData(state) {
	  if (state.controlEl && polytheneCore.isClient) {
	    // range is from the far left to the far right minus the thumb width (max x is at the left side of the thumb)
	    state.controlWidth = themeVars.thumb_size;
	    state.rangeWidth = state.trackEl.getBoundingClientRect().width - state.controlWidth;
	    var styles = window.getComputedStyle(state.trackEl);
	    state.rangeOffset = parseFloat(styles.marginLeft);
	  }
	};
	
	var calculateClickOffset = function calculateClickOffset(state) {
	  var controlOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  state.clickOffset = state.trackEl.getBoundingClientRect().left - (state.rangeOffset - state.controlWidth / 2) + controlOffset;
	};
	
	var initControlEvent = function initControlEvent(state, e) {
	  var controlPos = state.controlEl.getBoundingClientRect().left;
	  var eventPos = positionFromEvent(e);
	  var controlOffset = eventPos - controlPos - state.controlWidth / 2;
	  calculateClickOffset(state, controlOffset);
	};
	
	var initTrackEvent = function initTrackEvent(state) {
	  return calculateClickOffset(state, 0);
	};
	
	var handlePosEvent = function handlePosEvent(state, e) {
	  var pos = positionFromEvent(e) - state.clickOffset;
	  var value = state.min + (pos - state.rangeOffset) / state.rangeWidth * (state.max - state.min);
	  updateValue(state, value);
	};
	
	var startDrag = function startDrag(state, attrs, e) {
	  if (state.isDragging()) return;
	  e.preventDefault();
	  state.isDragging(true);
	  state.isActive(true);
	  deFocus(state);
	
	  var drag = function drag(e) {
	    if (!state.isDragging()) return;
	    handlePosEvent(state, e);
	  };
	
	  var endDrag = function endDrag() {
	    if (!state.isDragging()) return;
	    deFocus(state);
	    if (polytheneCore.isClient) {
	      window.removeEventListener(polytheneCore.pointerMoveEvent, drag);
	      window.removeEventListener(polytheneCore.pointerEndMoveEvent, endDrag);
	    }
	    state.isDragging(false);
	    state.isActive(false);
	  };
	
	  if (polytheneCore.isClient) {
	    window.addEventListener(polytheneCore.pointerMoveEvent, drag);
	    window.addEventListener(polytheneCore.pointerEndMoveEvent, endDrag);
	  }
	  readRangeData(state);
	
	  if (attrs.pin) {
	    updatePinPosition(state);
	  }
	};
	
	var startTrack = function startTrack(state, attrs, e) {
	  e.preventDefault();
	  if (state.isDragging()) {
	    return;
	  }
	  readRangeData(state);
	  initTrackEvent(state);
	  handlePosEvent(state, e);
	  startDrag(state, attrs, e);
	};
	
	var createSlider = function createSlider(vnode, _ref) {
	  var _ref3;
	
	  var h = _ref.h,
	      k = _ref.k,
	      hasTicks = _ref.hasTicks,
	      interactiveTrack = _ref.interactiveTrack;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var fraction = state.fraction();
	  var range = state.max - state.min;
	  var stepCount = Math.min(MAX_TICKS, parseInt(range / state.stepSize, 10));
	
	  var onStartTrack = function onStartTrack(e) {
	    return startTrack(state, attrs, e);
	  };
	
	  var onInitDrag = function onInitDrag(e) {
	    readRangeData(state);
	    initControlEvent(state, e);
	    startDrag(state, attrs, e);
	  };
	
	  var flexValueCss = fraction + " 1 0%";
	  var flexRestValue = 1 - fraction;
	  var flexRestCss = flexRestValue + " 1 0%";
	
	  return h("div", _extends({}, { className: classes.track }, interactiveTrack && !attrs.disabled && _defineProperty({}, k["on" + polytheneCore.pointerStartMoveEvent], onStartTrack)), [h("div", {
	    className: classes.trackPart + " " + classes.trackPartValue,
	    key: "trackPartValue",
	    style: {
	      flex: flexValueCss,
	      msFlex: flexValueCss,
	      WebkitFlex: flexValueCss
	    }
	  }, h("div", { className: classes.trackBar }, h("div", { className: classes.trackBarValue }))), h("div", _extends({}, {
	    className: classes.control,
	    key: "control"
	  }, attrs.disabled ? { disabled: true } : (_ref3 = {}, _defineProperty(_ref3, k.tabindex, attrs[k.tabindex] || 0), _defineProperty(_ref3, k.onfocus, function () {
	    return focus(state, state.controlEl);
	  }), _defineProperty(_ref3, k.onblur, function () {
	    return deFocus(state);
	  }), _defineProperty(_ref3, k.onkeydown, function (e) {
	    if (e.key !== "Tab") {
	      e.preventDefault();
	    }
	    if (e.key === "Escape" || e.key === "Esc") {
	      state.controlEl.blur(e);
	    } else if (e.key === "ArrowLeft" || e.key === "ArrowDown" || e.key === "Left" || e.key === "Down") {
	      state.decrement(state, e.shiftKey);
	    } else if (e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "Right" || e.key === "Up") {
	      state.increment(state, e.shiftKey);
	    } else if (e.key === "Home") {
	      updateValue(state, state.min);
	    } else if (e.key === "End") {
	      updateValue(state, state.max);
	    } else if (e.key === "PageDown") {
	      state.decrement(state, true);
	    } else if (e.key === "PageUp") {
	      state.increment(state, true);
	    }
	    readRangeData(state);
	    updatePinPosition(state);
	  }), _ref3), !attrs.disabled && _defineProperty({}, k["on" + polytheneCore.pointerStartMoveEvent], onInitDrag), attrs.events ? attrs.events : null, hasTicks ? { step: stepCount } : null), attrs.icon ? h("div", {
	    className: classes.thumb,
	    key: "icon"
	  }, attrs.icon) : null), h("div", {
	    className: classes.trackPart + " " + classes.trackPartRest,
	    key: "trackPartRest",
	    style: {
	      flex: flexRestCss,
	      msFlex: flexRestCss,
	      WebkitFlex: flexRestCss,
	      maxWidth: flexRestValue * 100 + "%" // for IE Edge
	    }
	  }, h("div", { className: classes.trackBar }, h("div", { className: classes.trackBarValue }))), hasTicks && !attrs.disabled ? h("div", {
	    className: classes.ticks,
	    key: "ticks"
	  }, generateTickMarks(h, stepCount)) : null, hasTicks && attrs.pin && !attrs.disabled ? h("div", {
	    className: classes.pin,
	    key: "pin",
	    value: state.value()
	  }) : null]);
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var attrs = vnode.attrs;
	
	  var min = attrs.min !== undefined ? attrs.min : 0;
	  var max = attrs.max !== undefined ? attrs.max : 100;
	  var range = max - min;
	  var stepSize = attrs.stepSize !== undefined ? attrs.stepSize : 1;
	  var defaultValue = attrs.defaultValue !== undefined ? attrs.defaultValue : attrs.value !== undefined ? attrs.value : 0;
	  var previousValue = createStream(undefined);
	  var isActive = createStream(false);
	  var hasFocus = createStream(false);
	  var isDragging = createStream(false);
	  var fraction = createStream(min);
	  var value = createStream(0);
	  var normalizeFactor = 1 / stepSize;
	
	  var setValue = function setValue(v) {
	    var shouldNotify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (v < min) v = min;
	    if (v > max) v = max;
	    value(stepSize ? Math.round(v * normalizeFactor) / normalizeFactor : v);
	    fraction((value() - min) / range);
	    if (shouldNotify && attrs.onChange) {
	      attrs.onChange({
	        value: value()
	      });
	    }
	    previousValue(v);
	  };
	
	  var increment = function increment(state, useLargeStep) {
	    return updateValue(state, value() + (useLargeStep ? 10 : 1) * (stepSize || 1));
	  };
	
	  var decrement = function decrement(state, useLargeStep) {
	    return updateValue(state, value() - (useLargeStep ? 10 : 1) * (stepSize || 1));
	  };
	
	  setValue(defaultValue);
	
	  return {
	    min: min,
	    max: max,
	    stepSize: stepSize,
	    fraction: fraction,
	    // DOM elements
	    trackEl: null,
	    controlEl: null,
	    pinEl: null,
	    // functions
	    setValue: setValue,
	    increment: increment,
	    decrement: decrement,
	    // streams
	    isDragging: isDragging,
	    isActive: isActive,
	    value: value,
	    previousValue: previousValue,
	    hasFocus: hasFocus,
	    // coordinates
	    controlWidth: 0,
	    rangeWidth: 0,
	    rangeOffset: 0,
	    clickOffset: 0,
	    redrawOnUpdate: createStream.merge([isActive, value])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  var dom = vnode.dom;
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  state.trackEl = dom.querySelector("." + classes.track);
	  state.controlEl = dom.querySelector("." + classes.control);
	  state.pinEl = dom.querySelector("." + classes.pin);
	
	  readRangeData(state);
	
	  if (attrs.pin) {
	    setTimeout(function () {
	      updateValue(state, state.value());
	    }, 0);
	  }
	};
	
	var createProps = function createProps(vnode, _ref5) {
	  var k = _ref5.keys;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  if (attrs.value !== undefined) {
	    if (state.previousValue() !== attrs.value) {
	      state.previousValue(attrs.value);
	      setTimeout(function () {
	        return state.setValue(state.previousValue());
	      }, 0); // perform in next tick to play nice with React
	    }
	  }
	  var hasTicks = attrs.ticks !== undefined && attrs.ticks !== false;
	  var interactiveTrack = attrs.interactiveTrack !== undefined ? attrs.interactiveTrack : true;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.disabled ? classes.isDisabled : null, attrs.pin ? classes.hasPin : null, interactiveTrack ? classes.hasTrack : null, state.isActive() ? classes.isActive : null, state.hasFocus() ? classes.hasFocus : null, state.fraction() === 0 ? classes.isAtMin : null, hasTicks ? classes.hasTicks : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref6) {
	  var h = _ref6.renderer,
	      k = _ref6.keys;
	
	  var attrs = vnode.attrs;
	  var hasTicks = attrs.ticks !== undefined && attrs.ticks !== false;
	  var interactiveTrack = attrs.interactiveTrack !== undefined ? attrs.interactiveTrack : true;
	  return createSlider(vnode, { h: h, k: k, hasTicks: hasTicks, interactiveTrack: interactiveTrack });
	};
	
	var slider = Object.freeze({
		getInitialState: getInitialState,
		onMount: onMount,
		createProps: createProps,
		createContent: createContent
	});
	
	exports.coreSlider = slider;
	exports.vars = themeVars;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-slider.js.map


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(37), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core-notification', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core-notification'],global['polythene-theme']));
	}(this, (function (exports,polytheneCoreNotification,polytheneTheme) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var coreSnackbarInstance = _extends({}, polytheneCoreNotification.coreNotificationInstance);
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var vars$2 = _extends$1({}, polytheneCoreNotification.vars, {
	  border_radius: 0,
	  min_width: 288,
	  max_width: 568,
	  min_height: 0,
	
	  color_dark_background: rgba(polytheneTheme.vars.color_dark_background)
	});
	
	var show = function show(_ref) {
	  var containerEl = _ref.containerEl,
	      el = _ref.el,
	      showDuration = _ref.showDuration,
	      showDelay = _ref.showDelay;
	
	  return {
	    el: containerEl,
	    showDuration: showDuration || .4,
	    showDelay: showDelay || 0,
	    beforeShow: function beforeShow() {
	      el.style.display = "block";
	      var height = el.getBoundingClientRect().height;
	      containerEl.style.transform = "translate3d(0, " + height + "px, 0)";
	    },
	    show: function show() {
	      return containerEl.style.transform = "translate3d(0, 0px, 0)";
	    }
	  };
	};
	
	var hide = function hide(_ref2) {
	  var containerEl = _ref2.containerEl,
	      el = _ref2.el,
	      hideDuration = _ref2.hideDuration,
	      hideDelay = _ref2.hideDelay;
	
	  return {
	    el: containerEl,
	    hideDuration: hideDuration || .4,
	    hideDelay: hideDelay || 0,
	    hide: function hide() {
	      var height = el.getBoundingClientRect().height;
	      containerEl.style.transform = "translate3d(0, " + height + "px, 0)";
	    },
	    // reset to original position to counter the removal of the snackbar instance
	    afterHide: function afterHide() {
	      // prevent a "bounce back"
	      el.style.display = "none";
	      containerEl.style.transitionDuration = "0ms";
	      containerEl.style.transform = "translate3d(0, 0px, 0)";
	    }
	  };
	};
	
	var transitions = {
	  show: show,
	  hide: hide
	};
	
	exports.coreSnackbarInstance = coreSnackbarInstance;
	exports.vars = vars$2;
	exports.transitions = transitions;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-snackbar.js.map


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core'], factory) :
		(factory((global.polythene = {}),global['polythene-core']));
	}(this, (function (exports,polytheneCore) { 'use strict';
	
	var classes = {
	  component: "pe-svg"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var onMount = function onMount(vnode) {
	  if (!vnode.dom) {
	    return;
	  }
	  // Prevent that SVG gets keyboard focus
	  var elem = vnode.dom.querySelector("svg");
	  if (elem) {
	    elem.setAttribute("focusable", "false");
	  }
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode) {
	  var attrs = vnode.attrs;
	  return attrs.content ? attrs.content : attrs.children || vnode.children || attrs;
	};
	
	var svg = Object.freeze({
		getElement: getElement,
		onMount: onMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var vars = {
	  color_light: "currentcolor",
	  color_dark: "currentcolor"
	};
	
	exports.coreSVG = svg;
	exports.vars = vars;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-svg.js.map


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(3), __webpack_require__(14), __webpack_require__(22)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-theme', 'polythene-core-selection-control', 'polythene-core-icon-button'], factory) :
		(factory((global.polythene = {}),global['polythene-theme'],global['polythene-core-selection-control'],global['polythene-core-icon-button']));
	}(this, (function (exports,polytheneTheme,polytheneCoreSelectionControl,polytheneCoreIconButton) { 'use strict';
	
	var classes = {
	  component: "pe-switch-control",
	
	  // elements
	  knob: "pe-switch-control__knob",
	  thumb: "pe-switch-control__thumb",
	  track: "pe-switch-control__track"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Don't export 'element': it will be the wrapped selection control component (set in polythene-xxx-checkbox)
	
	// Props to be passed to a selection control
	
	var createProps = function createProps(vnode) {
	  var attrs = vnode.attrs;
	  return _extends({}, attrs, {
	    selectable: attrs.selectable || function () {
	      return true;
	    }, // default: always selectable, regardless of the checked state
	    instanceClass: classes.component,
	    type: "checkbox"
	  });
	};
	
	var _switch = Object.freeze({
		createProps: createProps
	});
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var createContent = function createContent(vnode, _ref) {
	  var h = _ref.renderer,
	      Shadow = _ref.Shadow,
	      IconButton = _ref.IconButton;
	
	  var attrs = vnode.attrs;
	
	  var zOff = attrs.zOff !== undefined ? attrs.zOff : 1;
	  var zOn = attrs.zOn !== undefined ? attrs.zOn : 2;
	  var z = attrs.checked ? zOn : zOff;
	  var raised = attrs.disabled ? false : attrs.raised !== undefined ? attrs.raised : true;
	
	  return [h("div", {
	    className: classes.track,
	    key: "track"
	  }), h(IconButton, _extends$1({}, {
	    className: classes.thumb,
	    key: "button",
	    content: h("div", { className: classes.knob }, [attrs.icon ? attrs.icon : null, raised ? h(Shadow, {
	      z: z,
	      animated: true
	    }) : null]),
	    style: attrs.style,
	    disabled: attrs.disabled,
	    events: attrs.events,
	    ink: attrs.ink || false,
	    inactive: attrs.inactive
	  }, attrs.iconButton))];
	};
	
	var viewControl = Object.freeze({
		getElement: getElement,
		createContent: createContent
	});
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var hit_area_padding = (polytheneTheme.vars.grid_unit_icon_button - polytheneTheme.vars.unit_icon_size) / 2; // 12
	
	var vars$3 = _extends$2({}, polytheneCoreSelectionControl.vars, {
	  track_height: 14,
	  track_length: 36,
	  thumb_size: 20,
	  padding: polytheneTheme.vars.grid_unit_component,
	  icon_button_padding: polytheneCoreIconButton.vars.padding,
	  hit_area_padding: hit_area_padding,
	
	  animation_duration: polytheneTheme.vars.animation_duration,
	
	  color_light_thumb_on: rgba(polytheneTheme.vars.color_primary),
	  color_light_thumb_off: "#f1f1f1",
	  color_light_thumb_disabled: "#bdbdbd",
	  color_light_wash_on: rgba(polytheneTheme.vars.color_primary),
	  color_light_wash_off: polytheneCoreIconButton.vars.color_light_wash,
	
	  color_light_track_on: rgba(polytheneTheme.vars.color_primary_faded),
	  color_light_track_on_opacity: .55,
	  color_light_track_off: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_regular),
	  color_light_track_off_opacity: .55,
	  color_light_track_disabled: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_background_disabled),
	  color_light_track_disabled_opacity: 1,
	
	  // icon color may be set in theme; default "currentcolor"
	  // color_light_icon_on:                   "currentcolor",
	  // color_light_icon_off:                  "currentcolor",
	
	  // color_light_focus_on and so on taken from selectionControlVars
	
	  color_dark_thumb_on: rgba(polytheneTheme.vars.color_primary),
	  color_dark_thumb_off: "#bdbdbd",
	  color_dark_thumb_disabled: "#555",
	  color_dark_wash_on: rgba(polytheneTheme.vars.color_primary),
	  color_dark_wash_off: polytheneCoreIconButton.vars.color_dark_wash,
	
	  color_dark_track_on: rgba(polytheneTheme.vars.color_primary_faded, polytheneTheme.vars.blend_dark_text_tertiary), // or "#5a7f7c"
	  color_dark_track_on_opacity: 9,
	  color_dark_track_off: "#717171",
	  color_dark_track_off_opacity: .55,
	  color_dark_track_disabled: "#717171",
	  color_dark_track_disabled_opacity: .3
	
	  // icon color may be set in theme; default "currentcolor"
	  // color_dark_icon_on:                    "currentcolor"
	  // color_dark_icon_off:                   "currentcolor"
	
	  // color_dark_focus_on and so on taken from selectionControlVars
	});
	
	exports.coreSwitch = _switch;
	exports.viewControl = viewControl;
	exports.vars = vars$3;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-switch.js.map


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(26), __webpack_require__(3), __webpack_require__(36), __webpack_require__(22)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-utilities', 'polythene-theme', 'polythene-core-button', 'polythene-core-icon-button'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-utilities'],global['polythene-theme'],global['polythene-core-button'],global['polythene-core-icon-button']));
	}(this, (function (exports,polytheneCore,polytheneUtilities,polytheneTheme,polytheneCoreButton,polytheneCoreIconButton) { 'use strict';
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var fontSize = polytheneCoreButton.vars.font_size;
	var tab_label_line_height = 1.1 * fontSize;
	
	var vars$3 = {
	  tab_min_width: 72,
	  tab_min_width_tablet: 160,
	  tab_max_width: "initial",
	  tab_height: 48,
	  label_max_width: 264,
	  menu_tab_height: 44,
	  menu_tab_icon_label_height: 44,
	  tab_icon_label_height: 72,
	  tab_icon_label_icon_spacing: 7,
	  indicator_slide_speed: 600, // px per second
	  indicator_slide_min_duration: .250,
	  tabs_indent: polytheneTheme.vars.unit_indent,
	  tabs_scroll_speed: 600, // px per second
	  tabs_scroll_delay: .15,
	  tabs_scroll_min_duration: .5,
	  scroll_button_fade_duration: .2,
	  scroll_button_fade_delay: .25,
	  tab_content_padding_v: 12,
	  tab_menu_content_padding_v: 6,
	  tab_indicator_height: 2,
	  scrollbar_offset: 20,
	  scroll_button_opacity: .7,
	  label_opacity: .7,
	
	  tab_label_line_height: tab_label_line_height,
	  tab_label_vertical_offset: tab_label_line_height - fontSize,
	  tab_label_transition_property: "opacity, color, backgroundColor",
	
	  color_light: "inherit",
	  color_light_selected: rgba(polytheneTheme.vars.color_primary),
	  color_light_selected_background: "transparent",
	  color_light_tab_indicator: rgba(polytheneTheme.vars.color_primary),
	  color_light_icon: polytheneCoreIconButton.vars.color_light,
	
	  color_dark: "inherit",
	  color_dark_selected: rgba(polytheneTheme.vars.color_primary),
	  color_dark_selected_background: "transparent",
	  color_dark_tab_indicator: rgba(polytheneTheme.vars.color_primary),
	  color_dark_icon: polytheneCoreIconButton.vars.color_dark
	};
	
	var buttonClasses = {
	  base: "pe-button",
	  component: "pe-button pe-text-button",
	  row: "pe-button-row",
	
	  // elements
	  content: "pe-button__content",
	  focus: "pe-button__focus",
	  label: "pe-button__label",
	  wash: "pe-button__wash",
	
	  // states
	  borders: "pe-button--borders",
	  disabled: "pe-button--disabled",
	  focused: "pe-button--focus",
	  inactive: "pe-button--inactive",
	  selected: "pe-button--selected"
	};
	
	var classes = {
	  component: "pe-tabs",
	
	  // elements
	  indicator: "pe-tabs__indicator",
	  scrollButton: "pe-tabs__scroll-button",
	  scrollButtonAtEnd: "pe-tabs__scroll-button-end",
	  scrollButtonAtStart: "pe-tabs__scroll-button-start",
	  scrollButtonOffset: "pe-tabs__scroll-button-offset",
	  tab: "pe-tabs__tab",
	  tabContent: "pe-tabs__tab-content",
	  tabRow: "pe-tabs__row",
	
	  // states
	  activeSelectable: "pe-tabs__active--selectable",
	  isAtEnd: "pe-tabs--end",
	  isAtStart: "pe-tabs--start",
	  isAutofit: "pe-tabs--autofit",
	  isMenu: "pe-tabs--menu",
	  scrollable: "pe-tabs--scrollable",
	  compactTabs: "pe-tabs--compact",
	  tabHasIcon: "pe-tabs__tab---icon",
	  tabRowCentered: "pe-tabs__row--centered",
	  tabRowIndent: "pe-tabs__row--indent",
	
	  // lookup
	  label: buttonClasses.label
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var whenCreateDone = function whenCreateDone() {
	  return Promise.resolve();
	};
	
	var getNewIndex = function getNewIndex(index, tabs) {
	  var minTabIndex = 0;
	  var maxTabIndex = tabs.length - 1;
	  return {
	    backward: Math.max(index - 1, minTabIndex),
	    forward: Math.min(index + 1, maxTabIndex)
	  };
	};
	
	var handleScrollButtonClick = function handleScrollButtonClick(state, attrs, e, direction) {
	  e.stopPropagation();
	  e.preventDefault();
	  var currentTabIndex = state.selectedTabIndex();
	  var newIndex = getNewIndex(currentTabIndex, state.tabs)[direction];
	  if (newIndex !== currentTabIndex) {
	    setSelectedTab(state, attrs, newIndex, true);
	  } else {
	    scrollToTab(state, newIndex);
	  }
	};
	
	/*
	Moves the first tab to the left so that the text label is as position 0. 
	*/
	var alignToTitle = function alignToTitle(state) {
	  var firstTab = state.tabs[0].dom;
	  var firstInnerLabel = firstTab.querySelector("." + classes.label + " span");
	  var firstOuterLabelWidth = firstTab.getBoundingClientRect().width;
	  var firstInnerLabelWidth = firstInnerLabel.getBoundingClientRect().width;
	  var firstTabOffset = (firstOuterLabelWidth - firstInnerLabelWidth) / 2;
	  firstTab.style.marginLeft = -firstTabOffset + "px";
	};
	
	var createRightButtonOffset = function createRightButtonOffset(state) {
	  // add padding to right so that last item is not hidden behind scroll button
	  var scrollButtonAtEndWidth = state.scrollButtons["end"].getBoundingClientRect().width;
	  var scrollButtonOffsetEl = state.tabsEl.querySelector("." + classes.scrollButtonOffset);
	  scrollButtonOffsetEl.style.width = scrollButtonAtEndWidth + "px";
	};
	
	var scrollToTab = function scrollToTab(state, tabIndex) {
	  var tabs = state.tabs;
	  var scroller = state.scrollerEl;
	  // Scroll to position of selected tab
	  var tabLeft = tabs.slice(0, tabIndex).reduce(function (totalWidth, tabData) {
	    return totalWidth + tabData.dom.getBoundingClientRect().width;
	  }, 0);
	  // Tabs at the far right will not fully move to the left
	  // because the scrollable row will stick to the right 
	  // to get the max scroll left, we subtract the visible viewport from the scroll width
	  var scrollerWidth = scroller.getBoundingClientRect().width; // frame width
	  var scrollingWidth = scroller.scrollWidth;
	  var maxScroll = scrollingWidth - scrollerWidth;
	  var left = Math.min(tabLeft, maxScroll);
	  var currentLeft = scroller.scrollLeft;
	  if (currentLeft !== left) {
	    var duration = Math.abs(currentLeft - left) / vars$3.tabs_scroll_speed;
	    var delaySeconds = vars$3.tabs_scroll_delay || 0;
	    setTimeout(function () {
	      polytheneUtilities.scrollTo({
	        element: scroller,
	        to: left,
	        duration: Math.max(vars$3.tabs_scroll_min_duration, duration),
	        direction: "horizontal"
	      }).then(function () {
	        return updateScrollButtons(state);
	      });
	    }, delaySeconds * 1000);
	  }
	};
	
	var updateScrollButtons = function updateScrollButtons(state) {
	  var scrollerEl = state.scrollerEl;
	  var scrollLeft = scrollerEl.scrollLeft;
	  var currentTabIndex = state.selectedTabIndex();
	  var tabsEl = state.tabsEl;
	  var minTabIndex = 0;
	  var maxTabIndex = state.tabs.length - 1;
	  var isAtStart = scrollerEl.scrollLeft === 0 && currentTabIndex === minTabIndex;
	  var isAtEnd = scrollLeft >= scrollerEl.scrollWidth - tabsEl.getBoundingClientRect().width - 1 && currentTabIndex === maxTabIndex;
	  state.scrollButtonAtStart(isAtStart);
	  state.scrollButtonAtEnd(isAtEnd);
	};
	
	var animateIndicator = function animateIndicator(selectedTabEl, animate, state) {
	  var parentRect = state.tabsEl.getBoundingClientRect();
	  var rect = selectedTabEl.getBoundingClientRect();
	  var style = state.tabIndicatorEl.style;
	  var translateX = rect.left - parentRect.left + state.scrollerEl.scrollLeft;
	  var scaleX = 1 / parentRect.width * rect.width;
	  var transformCmd = "translate(" + translateX + "px, 0) scaleX(" + scaleX + ")";
	  var duration = animate ? vars$3.indicator_slide_min_duration : 0;
	  style["transition-duration"] = duration + "s";
	  style.transform = transformCmd;
	};
	
	var setSelectedTab = function setSelectedTab(state, attrs, index, animate) {
	  state.selectedTabIndex(index);
	  if (!state.tabs.length) return;
	  var selectedTabEl = state.tabs[index].dom;
	  if (selectedTabEl && state.tabIndicatorEl && state.tabsEl) {
	    animateIndicator(selectedTabEl, animate, state);
	  }
	  if (state.managesScroll) {
	    updateScrollButtons(state);
	  }
	  scrollToTab(state, index);
	  if (attrs.onChange) {
	    attrs.onChange({
	      index: index,
	      options: state.tabs[index].attrs,
	      el: selectedTabEl
	    });
	  }
	};
	
	var sortByLargestWidth = function sortByLargestWidth(a, b) {
	  return a < b ? 1 : a > b ? -1 : 0;
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var attrs = vnode.attrs;
	  var selectedTabIndex = createStream(vnode.attrs.selectedTab || 0);
	  var scrollButtonAtStart = createStream(true);
	  var scrollButtonAtEnd = createStream(true);
	  var registerTabButton = function registerTabButton(state) {
	    return function (index, data) {
	      return state.tabs[index] = data;
	    };
	  };
	  var registerScrollButton = function registerScrollButton(state) {
	    return function (position, dom) {
	      return state.scrollButtons[position] = dom;
	    };
	  };
	  return {
	    tabsEl: undefined,
	    scrollerEl: undefined,
	    tabs: [], // {data, el}
	    tabRow: undefined,
	    tabIndicatorEl: undefined,
	    selectedTabIndex: selectedTabIndex,
	    previousSelectedTab: undefined,
	    managesScroll: attrs.scrollable && !polytheneCore.isTouch,
	    scrollButtonAtStart: scrollButtonAtStart,
	    scrollButtonAtEnd: scrollButtonAtEnd,
	    scrollButtons: {
	      start: undefined,
	      end: undefined
	    },
	    registerTabButton: registerTabButton,
	    registerScrollButton: registerScrollButton,
	    cleanUp: undefined, // set in onMount
	    redrawOnUpdate: createStream.merge([selectedTabIndex, scrollButtonAtStart, scrollButtonAtEnd])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  var dom = vnode.dom;
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  state.tabsEl = dom;
	  if (!attrs.hideIndicator) {
	    state.tabIndicatorEl = dom.querySelector("." + classes.indicator);
	  }
	  state.scrollerEl = dom.querySelector("." + classes.tabRow);
	
	  // A promise can't resolve during the oncreate loop
	  // The Mithril draw loop is synchronous - there is no delay between one this oncreate and the tab button's oncreate
	  whenCreateDone().then(function () {
	    if (state.tabs && attrs.largestWidth) {
	      var widths = state.tabs.map(function (tabData) {
	        return tabData.dom.getBoundingClientRect().width;
	      });
	      var largest = widths.sort(sortByLargestWidth)[0];
	      state.tabs.forEach(function (tabData) {
	        return tabData.dom.style.width = largest + "px";
	      });
	    }
	    // Align first scrollable tab to title
	    if (attrs.scrollable) {
	      alignToTitle(state);
	    }
	    // Handle scroll
	    if (state.managesScroll) {
	      createRightButtonOffset(state);
	    }
	    setSelectedTab(state, attrs, state.selectedTabIndex(), false);
	  });
	
	  var onResize = function onResize() {
	    return setSelectedTab(state, attrs, state.selectedTabIndex(), false);
	  };
	
	  polytheneCore.subscribe("resize", onResize), state.cleanUp = function () {
	    return polytheneCore.unsubscribe("resize", onResize);
	  };
	};
	
	var onUnMount = function onUnMount(_ref) {
	  var state = _ref.state;
	  return state.cleanUp();
	};
	
	var createProps = function createProps(vnode, _ref2) {
	  var k = _ref2.keys;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var autofit = attrs.scrollable || attrs.centered ? false : attrs.autofit ? true : false;
	
	  // Keep selected tab up to date
	  if (attrs.selectedTab !== undefined && state.previousSelectedTab !== attrs.selectedTab) {
	    setSelectedTab(state, attrs, attrs.selectedTab, true);
	  }
	  state.previousSelectedTab = attrs.selectedTab;
	
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.scrollable ? classes.scrollable : null, state.scrollButtonAtStart() ? classes.isAtStart : null, state.scrollButtonAtEnd() ? classes.isAtEnd : null, attrs.activeSelected ? classes.activeSelectable : null, autofit ? classes.isAutofit : null, attrs.compact ? classes.compactTabs : null, attrs.menu ? classes.isMenu : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref3) {
	  var h = _ref3.renderer,
	      k = _ref3.keys,
	      Tab = _ref3.Tab,
	      ScrollButton = _ref3.ScrollButton;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  var buttons = attrs.content ? attrs.content : attrs.tabs ? attrs.tabs : attrs.children || vnode.children || [];
	
	  if (buttons.length === 0) {
	    console.error("No tabs specified"); // eslint-disable-line no-console
	  }
	
	  var tabRowButtons = buttons.map(function () {
	    var buttonOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var index = arguments[1];
	
	    var buttonOptsCombined = _extends({}, buttonOpts, {
	      // These options can be overridden by `all`
	      selected: index === state.selectedTabIndex(),
	      animateOnTap: attrs.animateOnTap !== false ? true : false
	    }, attrs.all, {
	      // Internal options, should not get overridden
	      index: index,
	      key: "tab-" + index,
	      register: state.registerTabButton(state),
	      onSelect: function onSelect() {
	        return setSelectedTab(state, attrs, index, attrs.noIndicatorSlide ? false : true);
	      }
	    });
	    return h(Tab, buttonOptsCombined);
	  });
	
	  var tabRow = attrs.scrollable ? tabRowButtons.concat([
	  // offset for right scroll button
	  h("div", {
	    key: "offset",
	    className: classes.scrollButtonOffset
	  })]) : tabRowButtons;
	
	  var scrollButtonAtStart = void 0,
	      scrollButtonAtEnd = void 0;
	  if (attrs.scrollable) {
	    scrollButtonAtStart = h(ScrollButton, _extends({}, {
	      key: "backward",
	      icon: attrs.scrollIconBackward,
	      className: classes.scrollButtonAtStart,
	      position: "start",
	      register: state.registerScrollButton(state),
	      events: _defineProperty({}, k.onclick, function (e) {
	        return handleScrollButtonClick(state, attrs, e, "backward");
	      })
	    }));
	    scrollButtonAtEnd = h(ScrollButton, _extends({}, {
	      key: "forward",
	      icon: attrs.scrollIconForward,
	      className: classes.scrollButtonAtEnd,
	      position: "end",
	      register: state.registerScrollButton(state),
	      events: _defineProperty({}, k.onclick, function (e) {
	        return handleScrollButtonClick(state, attrs, e, "forward");
	      })
	    }));
	  }
	
	  var tabIndicator = attrs.hideIndicator ? null : h("div", {
	    key: "indicator",
	    className: classes.indicator
	  });
	
	  return [attrs.scrollable ? scrollButtonAtStart : null, h("div", {
	    key: "tabrow",
	    className: [classes.tabRow, attrs.centered ? classes.tabRowCentered : null, attrs.scrollable ? classes.tabRowIndent : null].join(" ")
	  }, [tabRow, tabIndicator]), attrs.scrollable ? scrollButtonAtEnd : null];
	};
	
	var tabs = Object.freeze({
		getInitialState: getInitialState,
		onMount: onMount,
		onUnMount: onUnMount,
		createProps: createProps,
		createContent: createContent
	});
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Don't export 'element': it will be the wrapped Button component (set in polythene-xxx-tabs/tab)
	
	var onMount$1 = function onMount(vnode) {
	  var dom = vnode.dom;
	  if (!dom) {
	    return;
	  }
	  var attrs = vnode.attrs;
	  attrs.register(attrs.index, {
	    attrs: attrs,
	    dom: dom
	  });
	};
	
	var createProps$1 = function createProps(vnode, _ref) {
	  var h = _ref.renderer,
	      k = _ref.keys,
	      Icon = _ref.Icon;
	
	  var attrs = vnode.attrs;
	  // Let internal onclick function co-exist with passed button option
	  attrs.events = attrs.events || {};
	  attrs.events[k.onclick] = attrs.events[k.onclick] || function () {};
	  return _extends$1({}, attrs, {
	    content: h("div", { className: classes.tabContent }, [attrs.icon ? h(Icon, attrs.icon) : null, attrs.label ? h("div", { className: classes.label }, h("span", attrs.label)) : null]),
	    className: [classes.tab, attrs.icon && attrs.label ? classes.tabHasIcon : null, attrs.className || attrs[k.class]].join(" "),
	    selected: attrs.selected,
	    wash: false,
	    ripple: true,
	    events: _extends$1({}, attrs.events, _defineProperty$1({}, k.onclick, function (e) {
	      attrs.onSelect();
	      attrs.events[k.onclick](e);
	    }))
	  });
	};
	
	var createContent$1 = function createContent() {
	  return null;
	};
	
	var tab = Object.freeze({
		onMount: onMount$1,
		createProps: createProps$1,
		createContent: createContent$1
	});
	
	// Don't export 'element': it will be the wrapped IconButton component (set in polythene-xxx-tabs/scroll-button)
	
	var arrowBackward = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"/></svg>";
	var arrowForward = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"/></svg>";
	
	var onMount$2 = function onMount(vnode) {
	  var dom = vnode.dom;
	  if (!dom) {
	    return;
	  }
	  var attrs = vnode.attrs;
	  attrs.register(attrs.position, dom);
	};
	
	var createProps$2 = function createProps(vnode, _ref) {
	  var h = _ref.renderer,
	      k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  var icon = attrs.position === "start" ? attrs.icon || { svg: { content: h.trust(arrowBackward) } } : attrs.icon || { svg: { content: h.trust(arrowForward) } };
	  return {
	    className: [classes.scrollButton, attrs.className || attrs[k.class]].join(" "),
	    icon: icon,
	    ripple: { center: true },
	    events: attrs.events
	  };
	};
	
	var scrollButton = Object.freeze({
		onMount: onMount$2,
		createProps: createProps$2
	});
	
	exports.coreTabs = tabs;
	exports.coreTab = tab;
	exports.coreScrollButton = scrollButton;
	exports.vars = vars$3;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-tabs.js.map


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	  component: "pe-textfield",
	
	  // elements
	  counter: "pe-textfield__counter",
	  error: "pe-textfield__error",
	  errorPlaceholder: "pe-textfield__error-placeholder",
	  focusHelp: "pe-textfield__help-focus",
	  help: "pe-textfield__help",
	  input: "pe-textfield__input",
	  inputArea: "pe-textfield__input-area",
	  label: "pe-textfield__label",
	  optionalIndicator: "pe-textfield__optional-indicator",
	  requiredIndicator: "pe-textfield__required-indicator",
	
	  // states
	  hasCounter: "pe-textfield--counter",
	  hasFloatingLabel: "pe-textfield--floating-label",
	  hasFullWidth: "pe-textfield--full-width",
	  hideClear: "pe-textfield--hide-clear",
	  hideSpinner: "pe-textfield--hide-spinner",
	  hideValidation: "pe-textfield--hide-validation",
	  isDense: "pe-textfield--dense",
	  isRequired: "pe-textfield--required",
	  stateDirty: "pe-textfield--dirty",
	  stateDisabled: "pe-textfield--disabled",
	  stateFocused: "pe-textfield--focused",
	  stateInvalid: "pe-textfield--invalid",
	  stateReadonly: "pe-textfield--readonly"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var DEFAULT_VALID_STATE = {
	  invalid: false,
	  message: undefined
	};
	
	var validateCustom = function validateCustom(state, attrs) {
	  var el = state.inputEl();
	  if (!el) {
	    return DEFAULT_VALID_STATE;
	  }
	  var validState = attrs.validate(state.inputEl().value);
	  return {
	    invalid: validState && !validState.valid,
	    message: validState && validState.error
	  };
	};
	
	var validateCounter = function validateCounter(state, attrs) {
	  return {
	    invalid: state.inputEl().value.length > attrs.counter,
	    message: attrs.error
	  };
	};
	
	var validateHTML = function validateHTML(state, attrs) {
	  return {
	    invalid: !state.inputEl().checkValidity(),
	    message: attrs.error
	  };
	};
	
	var getValidStatus = function getValidStatus(state, attrs) {
	  var status = DEFAULT_VALID_STATE;
	
	  // attrs.validateResetOnClear: reset validation when field is cleared
	  if (state.isTouched() && state.isInvalid() && state.inputEl().value.length === 0 && attrs.validateResetOnClear) {
	    state.isTouched(false);
	    state.isInvalid(false);
	    state.error(undefined);
	  }
	  if (!status.invalid && attrs.counter) {
	    status = validateCounter(state, attrs);
	  }
	  if (!status.invalid && state.inputEl() && state.inputEl().checkValidity) {
	    status = validateHTML(state, attrs);
	  }
	  if (!status.invalid && attrs.validate) {
	    status = validateCustom(state, attrs);
	  }
	  return status;
	};
	
	var checkValidity = function checkValidity(vnode) {
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  // default
	
	  var status = attrs.valid !== undefined ? {
	    invalid: !attrs.valid,
	    message: attrs.error
	  } : !state.isTouched() && !attrs.validateAtStart ? DEFAULT_VALID_STATE : getValidStatus(state, attrs);
	  var previousInvalid = state.isInvalid();
	  state.error(status.message);
	
	  if (status.invalid !== previousInvalid) {
	    state.isInvalid(status.invalid);
	  }
	  if (!status.invalid) {
	    state.error(undefined);
	  }
	};
	
	var notifyState = function notifyState(vnode) {
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  if (attrs.onChange) {
	    var status = getValidStatus(state, attrs);
	    attrs.onChange({
	      focus: state.hasFocus(),
	      dirty: state.isDirty(),
	      el: state.inputEl(),
	      invalid: status.invalid,
	      error: status.error,
	      value: state.inputEl().value,
	      setInputState: function setInputState(newState) {
	        return state.setInputState(newState);
	      }
	    });
	  }
	};
	
	var ignoreEvent = function ignoreEvent(attrs, name) {
	  return attrs.ignoreEvents && attrs.ignoreEvents.indexOf(name) !== -1;
	};
	
	var getInitialState = function getInitialState(vnode, createStream) {
	  var attrs = vnode.attrs;
	
	  var defaultValue = attrs.defaultValue !== undefined && attrs.defaultValue !== null ? attrs.defaultValue.toString() : attrs.value !== undefined && attrs.value !== null ? attrs.value.toString() : "";
	
	  var el = createStream(null);
	  var inputEl = createStream(null);
	  var setInputState = createStream({});
	  var error = createStream(attrs.error);
	  var hasFocus = createStream(false);
	  var isTouched = createStream(false); // true when any change is made
	  var isDirty = createStream(defaultValue !== ""); // true for any input
	  var isInvalid = createStream(false);
	  var previousValue = createStream(undefined);
	  var didSetFocusTime = 0;
	
	  return {
	    defaultValue: defaultValue,
	    didSetFocusTime: didSetFocusTime,
	    el: el,
	    error: error,
	    hasFocus: hasFocus,
	    inputEl: inputEl,
	    isDirty: isDirty,
	    isInvalid: isInvalid,
	    isTouched: isTouched,
	    previousValue: previousValue,
	    setInputState: setInputState,
	    redrawOnUpdate: createStream.merge([inputEl, isInvalid, isDirty])
	  };
	};
	
	var onMount = function onMount(vnode) {
	  var dom = vnode.dom;
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  state.el(dom);
	  var inputType = attrs.multiLine ? "textarea" : "input";
	  var inputEl = dom.querySelector(inputType);
	  vnode.state.inputEl(inputEl);
	  state.inputEl().value = state.defaultValue;
	
	  state.setInputState.map(function (_ref) {
	    var type = _ref.type,
	        focus = _ref.focus,
	        value = _ref.value;
	    return value !== undefined ? state.inputEl().value = value : null, focus !== undefined && (state.hasFocus(focus), focus ? state.inputEl().focus() : state.inputEl().blur()), type === "input" && (attrs.validateOnInput || attrs.counter) && state.isTouched(state.inputEl().value !== state.defaultValue), type !== "input" && state.isTouched(state.inputEl().value !== state.defaultValue), type === "onblur" && state.isTouched(true), state.isDirty(state.inputEl().value !== ""), checkValidity(vnode), notifyState(vnode), state.previousValue(state.inputEl().value);
	  });
	
	  notifyState(vnode);
	};
	
	var onUpdate = function onUpdate(vnode) {
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  checkValidity(vnode);
	
	  var inputEl = state.inputEl();
	  var value = attrs.value !== undefined && attrs.value !== null ? attrs.value : inputEl ? inputEl.value : state.previousValue();
	  var valueStr = value === undefined || value === null ? "" : value.toString();
	
	  if (inputEl && state.previousValue() !== valueStr) {
	    inputEl.value = valueStr;
	    state.previousValue(valueStr);
	    state.setInputState({ type: "input" });
	  }
	};
	
	var createProps = function createProps(vnode, _ref2) {
	  var k = _ref2.keys;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	  var isInvalid = state.isInvalid();
	
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, isInvalid ? classes.stateInvalid : "", state.hasFocus() ? classes.stateFocused : "", state.isDirty() ? classes.stateDirty : "", attrs.floatingLabel ? classes.hasFloatingLabel : "", attrs.disabled ? classes.stateDisabled : "", attrs.readonly ? classes.stateReadonly : "", attrs.dense ? classes.isDense : "", attrs.required ? classes.isRequired : "", attrs.fullWidth ? classes.hasFullWidth : "", attrs.counter ? classes.hasCounter : "", attrs.hideSpinner !== false && attrs.hideSpinner !== undefined ? classes.hideSpinner : "", attrs.hideClear !== false && attrs.hideClear !== undefined ? classes.hideClear : "", attrs.hideValidation ? classes.hideValidation : "", attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  });
	};
	
	var createContent = function createContent(vnode, _ref3) {
	  var h = _ref3.renderer,
	      k = _ref3.keys;
	
	  var state = vnode.state;
	  var attrs = vnode.attrs;
	
	  var inputEl = state.inputEl();
	  var error = attrs.error || state.error();
	  var isInvalid = state.isInvalid();
	  var inputType = attrs.multiLine ? "textarea" : "input";
	  var type = attrs.multiLine ? null : !attrs.type || attrs.type === "submit" || attrs.type === "search" ? "text" : attrs.type;
	  var showError = isInvalid && error !== undefined;
	
	  var validates = !!(attrs.valid !== undefined || attrs.validate || attrs.min || attrs.max || attrs[k.minlength] || attrs[k.maxlength] || attrs.required || attrs.pattern);
	  var inactive = attrs.disabled || attrs[k.readonly];
	
	  var requiredIndicator = attrs.required && attrs.requiredIndicator !== "" ? h("span", {
	    key: "required",
	    className: classes.requiredIndicator
	  }, attrs.requiredIndicator || "*") : null;
	  var optionalIndicator = !attrs.required && attrs.optionalIndicator ? h("span", {
	    key: "optional",
	    className: classes.optionalIndicator
	  }, attrs.optionalIndicator) : null;
	  var label = attrs.label ? [attrs.label, requiredIndicator, optionalIndicator] : null;
	
	  return [h("div", {
	    className: classes.inputArea,
	    key: "input-area"
	  }, [label ? h("label", {
	    key: "label",
	    className: classes.label
	  }, label) : null, h(inputType, _extends({}, {
	    key: "input",
	    className: classes.input,
	    disabled: attrs.disabled
	  }, type ? { type: type } : null, attrs.name ? { name: attrs.name } : null, !ignoreEvent(attrs, k.onclick) ? _defineProperty({}, k.onclick, function () {
	    if (inactive) {
	      return;
	    }
	    // in case the browser does not give the field focus,
	    // for instance when the user tapped to the current field off screen
	    state.setInputState({ focus: true });
	    notifyState(vnode);
	  }) : null, !ignoreEvent(attrs, k.onfocus) ? _defineProperty({}, k.onfocus, function () {
	    if (inactive) {
	      return;
	    }
	    state.setInputState({ focus: true });
	
	    // set CSS class manually in case field gets focus but is off screen
	    // and no redraw is triggered
	    // at the next redraw state.hasFocus() will be read and the focus class be set
	    // in the props.class statement
	    if (state.el()) {
	      state.el().classList.add(classes.stateFocused);
	    }
	    notifyState(vnode);
	  }) : null, !ignoreEvent(attrs, k.onblur) ? _defineProperty({}, k.onblur, function () {
	    state.setInputState({ type: "onblur", focus: false });
	    // same principle as onfocus
	    state.el().classList.remove(classes.stateFocused);
	  }) : null, !ignoreEvent(attrs, k.oninput) ? _defineProperty({}, k.oninput, function () {
	    // default input event
	    // may be overwritten by attrs.events
	    state.setInputState({ type: "input" });
	  }) : null, !ignoreEvent(attrs, k.onkeydown) ? _defineProperty({}, k.onkeydown, function (e) {
	    if (e.key === "Enter") {
	      state.isTouched(true);
	    } else if (e.key === "Escape" || e.key === "Esc") {
	      state.setInputState({ focus: false });
	    }
	  }) : null, attrs.events ? attrs.events : null, // NOTE: may overwrite oninput
	  attrs.required !== undefined && !!attrs.required ? { required: true } : null, attrs[k.readonly] !== undefined && !!attrs[k.readonly] ? _defineProperty({}, k.readonly, true) : null, attrs.pattern !== undefined ? { pattern: attrs.pattern } : null, attrs[k.maxlength] !== undefined ? _defineProperty({}, k.maxlength, attrs[k.maxlength]) : null, attrs[k.minlength] !== undefined ? _defineProperty({}, k.minlength, attrs[k.minlength]) : null, attrs.max !== undefined ? { max: attrs.max } : null, attrs.min !== undefined ? { min: attrs.min } : null, attrs[k.autofocus] !== undefined ? _defineProperty({}, k.autofocus, attrs[k.autofocus]) : null, attrs[k.tabindex] !== undefined ? _defineProperty({}, k.tabindex, attrs[k.tabindex]) : null, attrs.rows !== undefined ? { rows: attrs.rows } : null))]), attrs.counter ? h("div", {
	    key: "counter",
	    className: classes.counter
	  }, (inputEl && inputEl.value.length || 0) + " / " + attrs.counter) : null, attrs.help && !showError ? h("div", {
	    key: "help",
	    className: [classes.help, attrs.focusHelp ? classes.focusHelp : null].join(" ")
	  }, attrs.help) : null, showError ? h("div", {
	    key: "error",
	    className: classes.error
	  }, error) : validates && !attrs.help ? h("div", {
	    key: "error-placeholder",
	    className: classes.errorPlaceholder
	  }) : null];
	};
	
	var textfield = Object.freeze({
		getElement: getElement,
		getInitialState: getInitialState,
		onMount: onMount,
		onUpdate: onUpdate,
		createProps: createProps,
		createContent: createContent
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var line_height_input = 20;
	var input_padding_v = 7;
	
	var vars$1 = {
	  vertical_spacing_top: 6, // 8 minus natural label height padding (1)
	  vertical_spacing_bottom: 7, // 8 minus natural label height padding (1)
	  input_focus_border_width: 2,
	  input_focus_border_animation_duration: polytheneTheme.vars.animation_duration,
	
	  floating_label_vertical_spacing_top: 30, // 16 + 8 + 8 minus natural label height padding (2)
	  floating_label_vertical_spacing_bottom: 7, // 8 minus natural label height padding (1)
	  floating_label_top: 14,
	  floating_label_animation_duration: ".12s",
	
	  input_padding_h: 0,
	  input_padding_v: input_padding_v,
	  input_border_width: 1,
	  margin_top_error_message: 6,
	  font_size_input: 16,
	  font_size_error: 12,
	  font_size_floating_label: 12,
	
	  line_height_input: line_height_input,
	
	  dense_floating_label_vertical_spacing_top: 23, // 12 + 8 + 4 minus natural label height padding (1)
	  dense_floating_label_vertical_spacing_bottom: 4, // 8 minus natural label height padding (1)
	  dense_floating_label_top: 10,
	  dense_font_size_input: 13,
	  dense_font_size_floating_label: 13,
	
	  full_width_input_padding_h: 20,
	  full_width_input_padding_v: 18, // 20 minus natural label height padding (2)
	
	  dense_full_width_input_padding_h: 16,
	  dense_full_width_input_padding_v: 15, // 16 minus natural label height padding (1)
	  dense_full_width_font_size_input: 13,
	
	  color_light_input_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_light_input_background: "transparent", // only used to "remove" autofill color
	  color_light_highlight_text: rgba(polytheneTheme.vars.color_primary, polytheneTheme.vars.blend_light_text_primary),
	  color_light_input_bottom_border: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_border_light),
	  color_light_input_error_text: rgba("221, 44, 0"),
	  color_light_input_error_border: rgba("221, 44, 0"),
	  color_light_input_placeholder: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_tertiary),
	  color_light_label_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_tertiary),
	  color_light_disabled_label_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_disabled),
	  color_light_readonly_label_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_tertiary),
	  color_light_help_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_tertiary),
	  color_light_required_symbol: rgba("221, 44, 0"),
	  color_light_focus_border: rgba(polytheneTheme.vars.color_primary),
	  color_light_counter_ok_border: rgba(polytheneTheme.vars.color_primary),
	
	  color_dark_input_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_input_background: "transparent", // only used to "remove" autofill color
	  color_dark_highlight_text: rgba(polytheneTheme.vars.color_primary, polytheneTheme.vars.blend_dark_text_primary),
	  color_dark_input_bottom_border: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_border_light),
	  color_dark_input_error_text: rgba("222, 50, 38"),
	  color_dark_input_error_border: rgba("222, 50, 38"),
	  color_dark_input_placeholder: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_tertiary),
	  color_dark_label_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_tertiary),
	  color_dark_disabled_label_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_disabled),
	  color_dark_readonly_label_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_tertiary),
	  color_dark_help_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_tertiary),
	  color_dark_required_symbol: rgba("221, 44, 0"),
	  color_dark_focus_border: rgba(polytheneTheme.vars.color_primary),
	  color_dark_counter_ok_border: rgba(polytheneTheme.vars.color_primary)
	};
	
	exports.coreTextField = textfield;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-textfield.js.map


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(3)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-core', 'polythene-theme'], factory) :
		(factory((global.polythene = {}),global['polythene-core'],global['polythene-theme']));
	}(this, (function (exports,polytheneCore,polytheneTheme) { 'use strict';
	
	var classes = {
	
	  // Toolbar
	
	  component: "pe-toolbar",
	
	  // states
	  compact: "pe-toolbar--compact",
	
	  // Toolbar title
	
	  // elements
	  title: "pe-toolbar__title",
	
	  // states
	  centeredTitle: "pe-toolbar__title--center",
	  indentedTitle: "pe-toolbar__title--indent"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var createProps = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.component, attrs.compact ? classes.compact : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.events);
	};
	
	var createContent = function createContent(vnode) {
	  var attrs = vnode.attrs;
	  return attrs.content ? attrs.content : attrs.children || vnode.children;
	};
	
	var toolbar = Object.freeze({
		getElement: getElement,
		createProps: createProps,
		createContent: createContent
	});
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getElement$1 = function getElement(vnode) {
	  return vnode.attrs.element || "div";
	};
	
	var createProps$1 = function createProps(vnode, _ref) {
	  var k = _ref.keys;
	
	  var attrs = vnode.attrs;
	  return _extends$1({}, polytheneCore.filterSupportedAttributes(attrs), {
	    className: [classes.title, attrs.indent ? classes.indentedTitle : null, attrs.center ? classes.centeredTitle : null, attrs.tone === "dark" ? "pe-dark-tone" : null, attrs.tone === "light" ? "pe-light-tone" : null, attrs.className || attrs[k.class]].join(" ")
	  }, attrs.events);
	};
	
	var createContent$1 = function createContent(vnode) {
	  var attrs = vnode.attrs;
	  return attrs.text ? attrs.text : attrs.content ? attrs.content : attrs.children || vnode.children || attrs;
	};
	
	var toolbarTitle = Object.freeze({
		getElement: getElement$1,
		createProps: createProps$1,
		createContent: createContent$1
	});
	
	var rgba = function rgba(colorStr) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return "rgba(" + colorStr + ", " + opacity + ")";
	};
	
	var padding_side = polytheneTheme.vars.grid_unit_component * 2 - 12; // 16 - 12 = 4
	var padding_side_large = polytheneTheme.vars.grid_unit_component * 3 - 12; // 24 - 12 = 12
	var title_padding = 12; // icon padding
	var title_after_icon_padding = polytheneTheme.vars.grid_unit_component * 9 - polytheneTheme.vars.grid_unit_component * 6 - padding_side; // 72 - 48 - 4 = 20
	var height = polytheneTheme.vars.grid_unit_component * 7; // 56
	var height_compact = polytheneTheme.vars.grid_unit_component * 6; // 48
	var height_large = polytheneTheme.vars.grid_unit_component * 8; // 64
	
	var vars$1 = {
	  padding_side: padding_side,
	  padding_side_large: padding_side_large,
	  height: height,
	  height_compact: height_compact,
	  height_large: height_large,
	
	  // title vars
	  title_padding: title_padding,
	  title_after_icon_padding: title_after_icon_padding,
	  indent: polytheneTheme.vars.unit_indent,
	  transition_duration: polytheneTheme.vars.animation_duration,
	  font_size: 18,
	  line_height: polytheneTheme.vars.line_height,
	
	  // color vars
	  color_light_text: rgba(polytheneTheme.vars.color_light_foreground, polytheneTheme.vars.blend_light_text_primary),
	  color_dark_text: rgba(polytheneTheme.vars.color_dark_foreground, polytheneTheme.vars.blend_dark_text_primary),
	
	  color_light_background: rgba(polytheneTheme.vars.color_light_background),
	  color_dark_background: rgba(polytheneTheme.vars.color_dark_background)
	};
	
	exports.coreToolbar = toolbar;
	exports.coreToolbarTitle = toolbarTitle;
	exports.vars = vars$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-core-toolbar.js.map


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(63), __webpack_require__(9), __webpack_require__(24), __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-card', 'polythene-react-icon', 'polythene-react-list-tile', 'polythene-react-shadow'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-card'],global['polythene-react-icon'],global['polythene-react-list-tile'],global['polythene-react-shadow']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreCard,polytheneReactIcon,polytheneReactListTile,polytheneReactShadow) { 'use strict';
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CardActions = polytheneReactBase.ViewComponent(_extends$1({}, polytheneCoreCard.coreCardActions));
	
	CardActions.displayName = "CardActions";
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CardMedia = polytheneReactBase.StateComponent(_extends$2({}, polytheneCoreCard.coreCardMedia));
	
	CardMedia.displayName = "CardMedia";
	
	var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CardPrimary = polytheneReactBase.ViewComponent(_extends$3({}, polytheneCoreCard.coreCardPrimary));
	
	CardPrimary.displayName = "CardPrimary";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Card = polytheneReactBase.ViewComponent(_extends({}, polytheneCoreCard.coreCard, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreCard.coreCard.createContent(vnode, _extends(args, { CardActions: CardActions, CardMedia: CardMedia, CardPrimary: CardPrimary, Icon: polytheneReactIcon.Icon, ListTile: polytheneReactListTile.ListTile, Shadow: polytheneReactShadow.Shadow }));
	  }
	}));
	
	Card.displayName = "Card";
	
	exports.Card = Card;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-card.js.map


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(64), __webpack_require__(14), __webpack_require__(9), __webpack_require__(16)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-checkbox', 'polythene-core-selection-control', 'polythene-react-icon', 'polythene-react-icon-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-checkbox'],global['polythene-core-selection-control'],global['polythene-react-icon'],global['polythene-react-icon-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreCheckbox,polytheneCoreSelectionControl,polytheneReactIcon,polytheneReactIconButton) { 'use strict';
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ViewControl = polytheneReactBase.ViewComponent(_extends$2({}, polytheneCoreSelectionControl.viewControl, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSelectionControl.viewControl.createContent(vnode, _extends$2(args, { Icon: polytheneReactIcon.Icon, IconButton: polytheneReactIconButton.IconButton }));
	  }
	}));
	
	ViewControl.displayName = "ViewControl";
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SelectionControl = polytheneReactBase.StateComponent(_extends$1({}, polytheneCoreSelectionControl.coreSelectionControl, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSelectionControl.coreSelectionControl.createContent(vnode, _extends$1(args, { ViewControl: ViewControl }));
	  }
	}));
	
	SelectionControl.displayName = "SelectionControl";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Checkbox = polytheneReactBase.StateComponent(_extends({}, polytheneCoreCheckbox.coreCheckbox, {
	  component: SelectionControl
	}));
	
	Checkbox.displayName = "Checkbox";
	
	exports.Checkbox = Checkbox;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-checkbox.js.map


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(66), __webpack_require__(38), __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-dialog', 'polythene-react-dialog-pane', 'polythene-react-shadow'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-dialog'],global['polythene-react-dialog-pane'],global['polythene-react-shadow']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreDialog,polytheneReactDialogPane,polytheneReactShadow) { 'use strict';
	
	var listTileClasses = {
	  component: "pe-list-tile",
	
	  // elements
	  content: "pe-list-tile__content",
	  highSubtitle: "pe-list-tile__high-subtitle",
	  primary: "pe-list-tile__primary",
	  secondary: "pe-list-tile__secondary",
	  subtitle: "pe-list-tile__subtitle",
	  title: "pe-list-tile__title",
	  contentFront: "pe-list-tile__content-front",
	
	  // states
	  compact: "pe-list-tile--compact",
	  compactFront: "pe-list-tile--compact-front",
	  disabled: "pe-list-tile--disabled",
	  hasFront: "pe-list-tile--front",
	  hasHighSubtitle: "pe-list-tile--high-subtitle",
	  hasSubtitle: "pe-list-tile--subtitle",
	  header: "pe-list-tile--header",
	  hoverable: "pe-list-tile--hoverable",
	  selectable: "pe-list-tile--selectable",
	  selected: "pe-list-tile--selected",
	  highlight: "pe-list-tile--highlight",
	  sticky: "pe-list-tile--sticky"
	};
	
	var menuClasses = {
	  component: "pe-menu",
	
	  // elements
	  content: "pe-menu__content",
	  placeholder: "pe-menu__placeholder",
	  target: "pe-menu__target",
	
	  // states
	  permanent: "pe-menu--permanent",
	  visible: "pe-menu--visible",
	  width_auto: "pe-menu--width-auto",
	  width_n: "pe-menu--width-",
	
	  // lookup
	  listTile: listTileClasses.component,
	  selectedListTile: listTileClasses.selected
	};
	
	var classes = {
	  component: "pe-dialog",
	
	  // elements
	  placeholder: "pe-dialog__placeholder",
	  holder: "pe-dialog__holder",
	  content: "pe-dialog__content",
	
	  // states
	  fullScreen: "pe-dialog--full-screen",
	  backdrop: "pe-dialog--backdrop",
	  open: "pe-dialog--open",
	
	  // lookup
	  menuContent: menuClasses.content
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var DialogInstance = polytheneReactBase.StateComponent(_extends({}, polytheneCoreDialog.coreDialogInstance, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreDialog.coreDialogInstance.createProps(vnode, _extends(args, { Shadow: polytheneReactShadow.Shadow, DialogPane: polytheneReactDialogPane.DialogPane }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreDialog.coreDialogInstance.createContent(vnode, _extends(args, { Shadow: polytheneReactShadow.Shadow, DialogPane: polytheneReactDialogPane.DialogPane }));
	  }
	}));
	
	DialogInstance.displayName = "DialogInstance";
	
	var options = {
	  name: "dialog",
	  htmlShowClass: classes.open,
	  defaultId: "default_dialog",
	  holderSelector: "div." + classes.holder,
	  instance: DialogInstance,
	  placeholder: "span." + classes.placeholder,
	  transitions: polytheneCoreDialog.transitions
	};
	
	var Multiple = polytheneCore.Multi({ options: options, renderer: polytheneReactBase.renderer });
	var Dialog = polytheneReactBase.StateComponent(Multiple);
	Object.getOwnPropertyNames(Multiple).forEach(function (p) {
	  return Dialog[p] = Multiple[p];
	});
	
	Dialog.displayName = "Dialog";
	
	exports.DialogInstance = DialogInstance;
	exports.Dialog = Dialog;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-dialog.js.map


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(67), __webpack_require__(9), __webpack_require__(40)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-fab', 'polythene-react-icon', 'polythene-react-raised-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-fab'],global['polythene-react-icon'],global['polythene-react-raised-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreFab,polytheneReactIcon,polytheneReactRaisedButton) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var FAB = polytheneReactBase.StateComponent(_extends({}, polytheneCoreFab.coreFAB, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreFab.coreFAB.createProps(vnode, _extends(args, { Icon: polytheneReactIcon.Icon }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreFab.coreFAB.createContent(vnode, _extends(args, { Icon: polytheneReactIcon.Icon }));
	  },
	  component: polytheneReactRaisedButton.RaisedButton
	}));
	
	FAB.displayName = "FAB";
	
	exports.FAB = FAB;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-fab.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(69), __webpack_require__(23)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-ios-spinner', 'polythene-react-base-spinner'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-ios-spinner'],global['polythene-react-base-spinner']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreIosSpinner,polytheneReactBaseSpinner) { 'use strict';
	
	var classes = {
	  component: "pe-ios-spinner",
	
	  // elements
	  blades: "pe-ios-spinner__blades",
	  blade: "pe-ios-spinner__blade"
	};
	
	var baseSpinnerClasses = {
	  component: "pe-spinner",
	
	  // elements
	  animation: "pe-spinner__animation",
	  placeholder: "pe-spinner__placeholder",
	
	  // states
	  animated: "pe-spinner--animated",
	  fab: "pe-spinner--fab",
	  large: "pe-spinner--large",
	  medium: "pe-spinner--medium",
	  permanent: "pe-spinner--permanent",
	  raised: "pe-spinner--raised",
	  regular: "pe-spinner--regular",
	  singleColor: "pe-spinner--single-color",
	  small: "pe-spinner--small",
	  visible: "pe-spinner--visible"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SpinnerInstance = polytheneReactBase.StateComponent(_extends({}, polytheneCoreIosSpinner.coreIOSSpinner, { component: polytheneReactBaseSpinner.BaseSpinner }));
	
	var SpinnerToggle = polytheneReactBase.StateComponent(polytheneCore.Conditional);
	SpinnerToggle.displayName = "IOSSpinnerToggle";
	
	var IOSSpinner = function IOSSpinner(props) {
	  return polytheneReactBase.renderer(SpinnerToggle, _extends({}, props, {
	    placeholderClassName: baseSpinnerClasses.placeholder,
	    instance: SpinnerInstance
	  }));
	};
	
	IOSSpinner.classes = classes;
	IOSSpinner.displayName = "IOSSpinner";
	
	exports.IOSSpinner = IOSSpinner;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-ios-spinner.js.map


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(71), __webpack_require__(24)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-list', 'polythene-react-list-tile'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-list'],global['polythene-react-list-tile']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreList,polytheneReactListTile) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var List = polytheneReactBase.ViewComponent(_extends({}, polytheneCoreList.coreList, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreList.coreList.createProps(vnode, _extends(args, { ListTile: polytheneReactListTile.ListTile }));
	  },
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreList.coreList.createContent(vnode, _extends(args, { ListTile: polytheneReactListTile.ListTile }));
	  }
	}));
	
	List.displayName = "List";
	
	exports.List = List;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-list.js.map


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(72), __webpack_require__(23)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-material-design-progress-spinner', 'polythene-react-base-spinner'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-material-design-progress-spinner'],global['polythene-react-base-spinner']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreMaterialDesignProgressSpinner,polytheneReactBaseSpinner) { 'use strict';
	
	var classes = {
	  component: "pe-md-progress-spinner",
	
	  // elements
	  animation: "pe-md-progress-spinner__animation",
	  circle: "pe-md-progress-spinner__circle",
	  circleRight: "pe-md-progress-spinner__circle-right",
	  circleLeft: "pe-md-progress-spinner__circle-left"
	};
	
	var baseSpinnerClasses = {
	  component: "pe-spinner",
	
	  // elements
	  animation: "pe-spinner__animation",
	  placeholder: "pe-spinner__placeholder",
	
	  // states
	  animated: "pe-spinner--animated",
	  fab: "pe-spinner--fab",
	  large: "pe-spinner--large",
	  medium: "pe-spinner--medium",
	  permanent: "pe-spinner--permanent",
	  raised: "pe-spinner--raised",
	  regular: "pe-spinner--regular",
	  singleColor: "pe-spinner--single-color",
	  small: "pe-spinner--small",
	  visible: "pe-spinner--visible"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SpinnerInstance = polytheneReactBase.StateComponent(_extends({}, polytheneCoreMaterialDesignProgressSpinner.coreMaterialDesignProgressSpinner, { component: polytheneReactBaseSpinner.BaseSpinner }));
	
	var SpinnerToggle = polytheneReactBase.StateComponent(polytheneCore.Conditional);
	SpinnerToggle.displayName = "MaterialDesignProgressSpinnerToggle";
	
	var MaterialDesignProgressSpinner = function MaterialDesignProgressSpinner(props) {
	  return polytheneReactBase.renderer(SpinnerToggle, _extends({}, props, {
	    placeholderClassName: baseSpinnerClasses.placeholder,
	    instance: SpinnerInstance
	  }));
	};
	
	MaterialDesignProgressSpinner.classes = classes;
	MaterialDesignProgressSpinner.displayName = "MaterialDesignProgressSpinner";
	
	exports.MaterialDesignProgressSpinner = MaterialDesignProgressSpinner;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-material-design-progress-spinner.js.map


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(73), __webpack_require__(23)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-material-design-spinner', 'polythene-react-base-spinner'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-material-design-spinner'],global['polythene-react-base-spinner']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreMaterialDesignSpinner,polytheneReactBaseSpinner) { 'use strict';
	
	var classes = {
	  component: "pe-md-spinner",
	
	  // elements
	  animation: "pe-md-spinner__animation",
	  circle: "pe-md-spinner__circle",
	  circleClipper: "pe-md-spinner__circle-clipper",
	  circleClipperLeft: "pe-md-spinner__circle-clipper-left",
	  circleClipperRight: "pe-md-spinner__circle-clipper-right",
	  gapPatch: "pe-md-spinner__gap-patch",
	  layer: "pe-md-spinner__layer",
	  layerN: "pe-md-spinner__layer-"
	};
	
	var baseSpinnerClasses = {
	  component: "pe-spinner",
	
	  // elements
	  animation: "pe-spinner__animation",
	  placeholder: "pe-spinner__placeholder",
	
	  // states
	  animated: "pe-spinner--animated",
	  fab: "pe-spinner--fab",
	  large: "pe-spinner--large",
	  medium: "pe-spinner--medium",
	  permanent: "pe-spinner--permanent",
	  raised: "pe-spinner--raised",
	  regular: "pe-spinner--regular",
	  singleColor: "pe-spinner--single-color",
	  small: "pe-spinner--small",
	  visible: "pe-spinner--visible"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SpinnerInstance = polytheneReactBase.StateComponent(_extends({}, polytheneCoreMaterialDesignSpinner.coreMaterialDesignSpinner, { component: polytheneReactBaseSpinner.BaseSpinner }));
	
	var SpinnerToggle = polytheneReactBase.StateComponent(polytheneCore.Conditional);
	SpinnerToggle.displayName = "MaterialDesignSpinnerToggle";
	
	var MaterialDesignSpinner = function MaterialDesignSpinner(props) {
	  return polytheneReactBase.renderer(SpinnerToggle, _extends({}, props, {
	    placeholderClassName: baseSpinnerClasses.placeholder,
	    instance: SpinnerInstance
	  }));
	};
	
	MaterialDesignSpinner.classes = classes;
	MaterialDesignSpinner.displayName = "MaterialDesignSpinner";
	
	exports.MaterialDesignSpinner = MaterialDesignSpinner;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-material-design-spinner.js.map


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(74), __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-menu', 'polythene-react-shadow'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-menu'],global['polythene-react-shadow']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreMenu,polytheneReactShadow) { 'use strict';
	
	var listTileClasses = {
	  component: "pe-list-tile",
	
	  // elements
	  content: "pe-list-tile__content",
	  highSubtitle: "pe-list-tile__high-subtitle",
	  primary: "pe-list-tile__primary",
	  secondary: "pe-list-tile__secondary",
	  subtitle: "pe-list-tile__subtitle",
	  title: "pe-list-tile__title",
	  contentFront: "pe-list-tile__content-front",
	
	  // states
	  compact: "pe-list-tile--compact",
	  compactFront: "pe-list-tile--compact-front",
	  disabled: "pe-list-tile--disabled",
	  hasFront: "pe-list-tile--front",
	  hasHighSubtitle: "pe-list-tile--high-subtitle",
	  hasSubtitle: "pe-list-tile--subtitle",
	  header: "pe-list-tile--header",
	  hoverable: "pe-list-tile--hoverable",
	  selectable: "pe-list-tile--selectable",
	  selected: "pe-list-tile--selected",
	  highlight: "pe-list-tile--highlight",
	  sticky: "pe-list-tile--sticky"
	};
	
	var classes = {
	  component: "pe-menu",
	
	  // elements
	  content: "pe-menu__content",
	  placeholder: "pe-menu__placeholder",
	  target: "pe-menu__target",
	
	  // states
	  permanent: "pe-menu--permanent",
	  visible: "pe-menu--visible",
	  width_auto: "pe-menu--width-auto",
	  width_n: "pe-menu--width-",
	
	  // lookup
	  listTile: listTileClasses.component,
	  selectedListTile: listTileClasses.selected
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var MenuInstance = polytheneReactBase.StateComponent(_extends({}, polytheneCoreMenu.coreMenu, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreMenu.coreMenu.createContent(vnode, _extends(args, { Shadow: polytheneReactShadow.Shadow }));
	  }
	}));
	
	var MenuToggle = polytheneReactBase.StateComponent(polytheneCore.Conditional);
	MenuToggle.displayName = "MenuToggle";
	
	var Menu = function Menu(props) {
	  return polytheneReactBase.renderer(MenuToggle, _extends({}, props, {
	    placeholderClassName: classes.placeholder,
	    instance: MenuInstance
	  }));
	};
	
	Menu.displayName = "Menu";
	
	exports.Menu = Menu;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-menu.js.map


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(37)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-notification'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-notification']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreNotification) { 'use strict';
	
	var classes = {
	  component: "pe-notification",
	
	  // elements
	  action: "pe-notification__action",
	  content: "pe-notification__content",
	  holder: "pe-notification__holder",
	  placeholder: "pe-notification__placeholder",
	  title: "pe-notification__title",
	
	  // states
	  hasContainer: "pe-notification--container",
	  horizontal: "pe-notification--horizontal",
	  multilineTitle: "pe-notification__title--multi-line",
	  vertical: "pe-notification--vertical"
	};
	
	var NotificationInstance = polytheneReactBase.StateComponent(polytheneCoreNotification.coreNotificationInstance);
	
	NotificationInstance.displayName = "NotificationInstance";
	
	var options = {
	  name: "notification",
	  className: classes.component,
	  htmlShowClass: classes.open,
	  defaultId: "default_notification",
	  holderSelector: "." + classes.holder,
	  instance: NotificationInstance,
	  placeholder: "span." + classes.placeholder,
	  queue: true,
	  transitions: polytheneCoreNotification.transitions
	};
	
	var Multiple = polytheneCore.Multi({ options: options, renderer: polytheneReactBase.renderer });
	var Notification = polytheneReactBase.StateComponent(Multiple);
	Object.getOwnPropertyNames(Multiple).forEach(function (p) {
	  return Notification[p] = Multiple[p];
	});
	
	Notification.displayName = "Notification";
	
	exports.NotificationInstance = NotificationInstance;
	exports.Notification = Notification;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-notification.js.map


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(76), __webpack_require__(39)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-radio-group', 'polythene-react-radio-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-radio-group'],global['polythene-react-radio-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreRadioGroup,polytheneReactRadioButton) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var RadioGroup = polytheneReactBase.StateComponent(_extends({}, polytheneCoreRadioGroup.coreRadioGroup, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreRadioGroup.coreRadioGroup.createContent(vnode, _extends(args, { RadioButton: polytheneReactRadioButton.RadioButton }));
	  }
	}));
	
	RadioGroup.displayName = "RadioGroup";
	
	exports.RadioGroup = RadioGroup;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-radio-group.js.map


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(79), __webpack_require__(42)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-search', 'polythene-react-textfield'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-search'],global['polythene-react-textfield']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreSearch,polytheneReactTextfield) { 'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Search = polytheneReactBase.StateComponent(_extends({}, polytheneCoreSearch.coreSearch, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSearch.coreSearch.createContent(vnode, _extends(args, { TextField: polytheneReactTextfield.TextField }));
	  }
	}));
	
	Search.displayName = "Search";
	
	exports.Search = Search;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-search.js.map


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(81)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-slider'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-slider']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreSlider) { 'use strict';
	
	var Slider = polytheneReactBase.StateComponent(polytheneCoreSlider.coreSlider);
	
	Slider.displayName = "Slider";
	
	exports.Slider = Slider;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-slider.js.map


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(82)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core', 'polythene-core-snackbar'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core'],global['polythene-core-snackbar']));
	}(this, (function (exports,polytheneReactBase,polytheneCore,polytheneCoreSnackbar) { 'use strict';
	
	var notificationClasses = {
	  component: "pe-notification",
	
	  // elements
	  action: "pe-notification__action",
	  content: "pe-notification__content",
	  holder: "pe-notification__holder",
	  placeholder: "pe-notification__placeholder",
	  title: "pe-notification__title",
	
	  // states
	  hasContainer: "pe-notification--container",
	  horizontal: "pe-notification--horizontal",
	  multilineTitle: "pe-notification__title--multi-line",
	  vertical: "pe-notification--vertical"
	};
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var classes = _extends({}, notificationClasses, {
	  component: "pe-notification pe-snackbar",
	
	  // elements
	  holder: "pe-snackbar__holder",
	  placeholder: "pe-snackbar__placeholder",
	
	  // states
	  open: "pe-snackbar--open"
	});
	
	var SnackbarInstance = polytheneReactBase.StateComponent(polytheneCoreSnackbar.coreSnackbarInstance);
	
	SnackbarInstance.displayName = "SnackbarInstance";
	
	var options = {
	  name: "snackbar",
	  className: classes.component,
	  htmlShowClass: classes.open,
	  defaultId: "default_snackbar",
	  holderSelector: "." + classes.holder,
	  instance: SnackbarInstance,
	  placeholder: "span." + classes.placeholder,
	  queue: true,
	  transitions: polytheneCoreSnackbar.transitions
	};
	
	var Multiple = polytheneCore.Multi({ options: options, renderer: polytheneReactBase.renderer });
	var Snackbar = polytheneReactBase.StateComponent(Multiple);
	Object.getOwnPropertyNames(Multiple).forEach(function (p) {
	  return Snackbar[p] = Multiple[p];
	});
	
	Snackbar.displayName = "Snackbar";
	
	exports.SnackbarInstance = SnackbarInstance;
	exports.Snackbar = Snackbar;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-snackbar.js.map


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(84), __webpack_require__(14), __webpack_require__(11), __webpack_require__(16)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-switch', 'polythene-core-selection-control', 'polythene-react-shadow', 'polythene-react-icon-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-switch'],global['polythene-core-selection-control'],global['polythene-react-shadow'],global['polythene-react-icon-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreSwitch,polytheneCoreSelectionControl,polytheneReactShadow,polytheneReactIconButton) { 'use strict';
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ViewControl = polytheneReactBase.ViewComponent(_extends$2({}, polytheneCoreSwitch.viewControl, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSwitch.viewControl.createContent(vnode, _extends$2(args, { Shadow: polytheneReactShadow.Shadow, IconButton: polytheneReactIconButton.IconButton }));
	  }
	}));
	
	ViewControl.displayName = "ViewControl";
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SelectionControl = polytheneReactBase.StateComponent(_extends$1({}, polytheneCoreSelectionControl.coreSelectionControl, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreSelectionControl.coreSelectionControl.createContent(vnode, _extends$1(args, { ViewControl: ViewControl }));
	  }
	}));
	
	SelectionControl.displayName = "SelectionControl";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Switch = polytheneReactBase.StateComponent(_extends({}, polytheneCoreSwitch.coreSwitch, {
	  component: SelectionControl
	}));
	
	Switch.displayName = "Switch";
	
	exports.Switch = Switch;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-switch.js.map


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(85), __webpack_require__(9), __webpack_require__(18), __webpack_require__(16)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-tabs', 'polythene-react-icon', 'polythene-react-button', 'polythene-react-icon-button'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-tabs'],global['polythene-react-icon'],global['polythene-react-button'],global['polythene-react-icon-button']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreTabs,polytheneReactIcon,polytheneReactButton,polytheneReactIconButton) { 'use strict';
	
	var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Tab = polytheneReactBase.ViewComponent(_extends$1({}, polytheneCoreTabs.coreTab, {
	  createProps: function createProps(vnode, args) {
	    return polytheneCoreTabs.coreTab.createProps(vnode, _extends$1(args, { Icon: polytheneReactIcon.Icon }));
	  },
	  component: polytheneReactButton.Button
	}));
	
	Tab.displayName = "Tab";
	
	var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ScrollButton = polytheneReactBase.ViewComponent(_extends$2({}, polytheneCoreTabs.coreScrollButton, {
	  component: polytheneReactIconButton.IconButton
	}));
	
	ScrollButton.displayName = "ScrollButton";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Tabs = polytheneReactBase.StateComponent(_extends({}, polytheneCoreTabs.coreTabs, {
	  createContent: function createContent(vnode, args) {
	    return polytheneCoreTabs.coreTabs.createContent(vnode, _extends(args, { Tab: Tab, ScrollButton: ScrollButton }));
	  }
	}));
	
	Tabs.displayName = "Tabs";
	
	exports.Tabs = Tabs;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-tabs.js.map


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(87)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-toolbar'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-toolbar']));
	}(this, (function (exports,polytheneReactBase,polytheneCoreToolbar) { 'use strict';
	
	var Toolbar = polytheneReactBase.ViewComponent(polytheneCoreToolbar.coreToolbar);
	
	Toolbar.displayName = "Toolbar";
	
	var ToolbarTitle = polytheneReactBase.ViewComponent(polytheneCoreToolbar.coreToolbarTitle);
	
	ToolbarTitle.displayName = "ToolbarTitle";
	
	exports.Toolbar = Toolbar;
	exports.ToolbarTitle = ToolbarTitle;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react-toolbar.js.map


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(2), __webpack_require__(18), __webpack_require__(88), __webpack_require__(89), __webpack_require__(90), __webpack_require__(38), __webpack_require__(91), __webpack_require__(9), __webpack_require__(16), __webpack_require__(92), __webpack_require__(93), __webpack_require__(24), __webpack_require__(94), __webpack_require__(95), __webpack_require__(96), __webpack_require__(97), __webpack_require__(39), __webpack_require__(98), __webpack_require__(40), __webpack_require__(25), __webpack_require__(99), __webpack_require__(11), __webpack_require__(100), __webpack_require__(101), __webpack_require__(41), __webpack_require__(102), __webpack_require__(103), __webpack_require__(42), __webpack_require__(104)) :
		typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-react-button', 'polythene-react-card', 'polythene-react-checkbox', 'polythene-react-dialog', 'polythene-react-dialog-pane', 'polythene-react-fab', 'polythene-react-icon', 'polythene-react-icon-button', 'polythene-react-ios-spinner', 'polythene-react-list', 'polythene-react-list-tile', 'polythene-react-material-design-progress-spinner', 'polythene-react-material-design-spinner', 'polythene-react-menu', 'polythene-react-notification', 'polythene-react-radio-button', 'polythene-react-radio-group', 'polythene-react-raised-button', 'polythene-react-ripple', 'polythene-react-search', 'polythene-react-shadow', 'polythene-react-slider', 'polythene-react-snackbar', 'polythene-react-svg', 'polythene-react-switch', 'polythene-react-tabs', 'polythene-react-textfield', 'polythene-react-toolbar'], factory) :
		(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-react-button'],global['polythene-react-card'],global['polythene-react-checkbox'],global['polythene-react-dialog'],global['polythene-react-dialog-pane'],global['polythene-react-fab'],global['polythene-react-icon'],global['polythene-react-icon-button'],global['polythene-react-ios-spinner'],global['polythene-react-list'],global['polythene-react-list-tile'],global['polythene-react-material-design-progress-spinner'],global['polythene-react-material-design-spinner'],global['polythene-react-menu'],global['polythene-react-notification'],global['polythene-react-radio-button'],global['polythene-react-radio-group'],global['polythene-react-raised-button'],global['polythene-react-ripple'],global['polythene-react-search'],global['polythene-react-shadow'],global['polythene-react-slider'],global['polythene-react-snackbar'],global['polythene-react-svg'],global['polythene-react-switch'],global['polythene-react-tabs'],global['polythene-react-textfield'],global['polythene-react-toolbar']));
	}(this, (function (exports,polytheneReactBase,polytheneReactButton,polytheneReactCard,polytheneReactCheckbox,polytheneReactDialog,polytheneReactDialogPane,polytheneReactFab,polytheneReactIcon,polytheneReactIconButton,polytheneReactIosSpinner,polytheneReactList,polytheneReactListTile,polytheneReactMaterialDesignProgressSpinner,polytheneReactMaterialDesignSpinner,polytheneReactMenu,polytheneReactNotification,polytheneReactRadioButton,polytheneReactRadioGroup,polytheneReactRaisedButton,polytheneReactRipple,polytheneReactSearch,polytheneReactShadow,polytheneReactSlider,polytheneReactSnackbar,polytheneReactSvg,polytheneReactSwitch,polytheneReactTabs,polytheneReactTextfield,polytheneReactToolbar) { 'use strict';
	
	Object.keys(polytheneReactBase).forEach(function (key) { exports[key] = polytheneReactBase[key]; });
	Object.keys(polytheneReactButton).forEach(function (key) { exports[key] = polytheneReactButton[key]; });
	Object.keys(polytheneReactCard).forEach(function (key) { exports[key] = polytheneReactCard[key]; });
	Object.keys(polytheneReactCheckbox).forEach(function (key) { exports[key] = polytheneReactCheckbox[key]; });
	Object.keys(polytheneReactDialog).forEach(function (key) { exports[key] = polytheneReactDialog[key]; });
	Object.keys(polytheneReactDialogPane).forEach(function (key) { exports[key] = polytheneReactDialogPane[key]; });
	Object.keys(polytheneReactFab).forEach(function (key) { exports[key] = polytheneReactFab[key]; });
	Object.keys(polytheneReactIcon).forEach(function (key) { exports[key] = polytheneReactIcon[key]; });
	Object.keys(polytheneReactIconButton).forEach(function (key) { exports[key] = polytheneReactIconButton[key]; });
	Object.keys(polytheneReactIosSpinner).forEach(function (key) { exports[key] = polytheneReactIosSpinner[key]; });
	Object.keys(polytheneReactList).forEach(function (key) { exports[key] = polytheneReactList[key]; });
	Object.keys(polytheneReactListTile).forEach(function (key) { exports[key] = polytheneReactListTile[key]; });
	Object.keys(polytheneReactMaterialDesignProgressSpinner).forEach(function (key) { exports[key] = polytheneReactMaterialDesignProgressSpinner[key]; });
	Object.keys(polytheneReactMaterialDesignSpinner).forEach(function (key) { exports[key] = polytheneReactMaterialDesignSpinner[key]; });
	Object.keys(polytheneReactMenu).forEach(function (key) { exports[key] = polytheneReactMenu[key]; });
	Object.keys(polytheneReactNotification).forEach(function (key) { exports[key] = polytheneReactNotification[key]; });
	Object.keys(polytheneReactRadioButton).forEach(function (key) { exports[key] = polytheneReactRadioButton[key]; });
	Object.keys(polytheneReactRadioGroup).forEach(function (key) { exports[key] = polytheneReactRadioGroup[key]; });
	Object.keys(polytheneReactRaisedButton).forEach(function (key) { exports[key] = polytheneReactRaisedButton[key]; });
	Object.keys(polytheneReactRipple).forEach(function (key) { exports[key] = polytheneReactRipple[key]; });
	Object.keys(polytheneReactSearch).forEach(function (key) { exports[key] = polytheneReactSearch[key]; });
	Object.keys(polytheneReactShadow).forEach(function (key) { exports[key] = polytheneReactShadow[key]; });
	Object.keys(polytheneReactSlider).forEach(function (key) { exports[key] = polytheneReactSlider[key]; });
	Object.keys(polytheneReactSnackbar).forEach(function (key) { exports[key] = polytheneReactSnackbar[key]; });
	Object.keys(polytheneReactSvg).forEach(function (key) { exports[key] = polytheneReactSvg[key]; });
	Object.keys(polytheneReactSwitch).forEach(function (key) { exports[key] = polytheneReactSwitch[key]; });
	Object.keys(polytheneReactTabs).forEach(function (key) { exports[key] = polytheneReactTabs[key]; });
	Object.keys(polytheneReactTextfield).forEach(function (key) { exports[key] = polytheneReactTextfield[key]; });
	Object.keys(polytheneReactToolbar).forEach(function (key) { exports[key] = polytheneReactToolbar[key]; });
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-react.js.map


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.polythene = {})));
	}(this, (function (exports) { 'use strict';
	
	// Global style variables
	
	var grid_unit = 4;
	var grid_unit_component = 8;
	
	var animation_curve_slow_in_fast_out = "cubic-bezier(.4, 0, .2, 1)";
	var animation_curve_slow_in_linear_out = "cubic-bezier(0, 0, .2, 1)";
	var animation_curve_linear_in_fast_out = "cubic-bezier(.4, 0, 1, 1)";
	
	var vars = {
	  // grid
	  grid_unit: grid_unit,
	  grid_unit_component: grid_unit_component,
	  grid_unit_menu: 56,
	  grid_unit_icon_button: 6 * grid_unit_component, // 48
	
	  // common sizes
	  unit_block_border_radius: 2,
	  unit_item_border_radius: 2,
	  unit_indent: 72,
	  unit_side_padding: 16,
	
	  // buttons
	  unit_touch_height: 48,
	  unit_icon_size_small: 2 * grid_unit_component, // 16
	  unit_icon_size: 3 * grid_unit_component, // 24
	  unit_icon_size_medium: 4 * grid_unit_component, // 32
	  unit_icon_size_large: 5 * grid_unit_component, // 40
	
	  // screen dimensions
	  unit_screen_size_extra_large: 1280,
	  unit_screen_size_large: 960,
	  unit_screen_size_medium: 480,
	  unit_screen_size_small: 320,
	
	  // transitions
	  animation_duration: ".18s",
	  animation_curve_slow_in_fast_out: animation_curve_slow_in_fast_out,
	  animation_curve_slow_in_linear_out: animation_curve_slow_in_linear_out,
	  animation_curve_linear_in_fast_out: animation_curve_linear_in_fast_out,
	  animation_curve_default: "ease-out",
	
	  // font
	  font_weight_light: 300,
	  font_weight_normal: 400,
	  font_weight_medium: 500,
	  font_weight_bold: 700,
	  font_size_title: 20,
	  line_height: 1.3,
	
	  // base colors
	  color_primary: "33, 150, 243", // blue 500
	  color_primary_active: "30, 136, 229", // blue 600
	  color_primary_dark: "25, 118, 210", // blue 700
	  color_primary_faded: "100, 181, 249", // blue 300
	  color_primary_foreground: "255, 255, 255",
	
	  color_light_background: "255, 255, 255",
	  color_light_foreground: "0, 0, 0",
	  color_dark_background: "34, 34, 34",
	  color_dark_foreground: "255, 255, 255",
	
	  // blends
	  blend_light_text_primary: .87,
	  blend_light_text_regular: .73,
	  blend_light_text_secondary: .54,
	  blend_light_text_tertiary: .40,
	  blend_light_text_disabled: .26,
	  blend_light_border_light: .11,
	  blend_light_background_active: .14,
	  blend_light_background_hover: .06,
	  blend_light_background_hover_medium: .12, // for the lighter tinted icon buttons
	  blend_light_background_disabled: .09,
	  blend_light_overlay_background: .3,
	
	  blend_dark_text_primary: 1,
	  blend_dark_text_regular: .87,
	  blend_dark_text_secondary: .70,
	  blend_dark_text_tertiary: .40,
	  blend_dark_text_disabled: .26,
	  blend_dark_border_light: .10,
	  blend_dark_background_active: .14,
	  blend_dark_background_hover: .08,
	  blend_dark_background_hoverMedium: .12, // for the lighter tinted icon buttons
	  blend_dark_background_disabled: .12,
	  blend_dark_overlay_background: .3,
	
	  /*
	  Breakpoints
	  Specs: https://material.io/guidelines/layout/responsive-ui.html#responsive-ui-breakpoints
	  Breakbpoint naming: inspiration from
	  https://medium.freecodecamp.org/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862
	  */
	  breakpoint_for_phone_only: 599, // set max-width  cols: 4,  gutter: 16
	  breakpoint_for_tablet_portrait_up: 600, // set min-width  cols: 8,  gutter: 24
	  breakpoint_for_tablet_landscape_up: 840, // etc.           cols: 12, gutter: 24
	  breakpoint_for_desktop_up: 1280,
	  breakpoint_for_big_desktop_up: 1600,
	  breakpoint_for_tv_up: 1920,
	
	  // z-index
	  z_menu: 1000,
	  z_header_container: 2000,
	  z_fixed_header_container: 3000,
	  z_notification: 4000,
	  z_dialog: 5000
	};
	
	exports.vars = vars;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=polythene-style.js.map


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var React = __webpack_require__(5);
	
	var parseTag = __webpack_require__(114);
	
	module.exports = h;
	
	function h(componentOrTag, properties, children) {
	  // If a child array or text node are passed as the second argument, shift them
	  if (!children && isChildren(properties)) {
	    children = properties;
	    properties = {};
	  } else if (arguments.length === 2) {
	    // If no children were passed, we don't want to pass "undefined"
	    // and potentially overwrite the `children` prop
	    children = [];
	  }
	
	  properties = properties ? Object.assign({}, properties) : {};
	
	  // Supported nested dataset attributes
	  if (properties.dataset) {
	    Object.keys(properties.dataset).forEach(function unnest(attrName) {
	      var dashedAttr = attrName.replace(/([a-z])([A-Z])/, function dash(match) {
	        return match[0] + '-' + match[1].toLowerCase();
	      });
	      properties['data-' + dashedAttr] = properties.dataset[attrName];
	    });
	
	    properties.dataset = undefined;
	  }
	
	  // Support nested attributes
	  if (properties.attributes) {
	    Object.keys(properties.attributes).forEach(function unnest(attrName) {
	      properties[attrName] = properties.attributes[attrName];
	    });
	
	    properties.attributes = undefined;
	  }
	
	  // When a selector, parse the tag name and fill out the properties object
	  if (typeof componentOrTag === 'string') {
	    componentOrTag = parseTag(componentOrTag, properties);
	  }
	
	  // Create the element
	  var args = [componentOrTag, properties].concat(children);
	  return React.createElement.apply(React, args);
	}
	
	function isChildren(x) {
	  return typeof x === 'string' || typeof x === 'number' || Array.isArray(x);
	}


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	/* eslint-disable complexity, max-statements */
	'use strict';
	
	var classIdSplit = /([\.#]?[a-zA-Z0-9_:-]+)/;
	var notClassId = /^\.|#/;
	
	module.exports = parseTag;
	
	function parseTag(tag, props) {
	  if (!tag) {
	    return 'div';
	  }
	
	  var noId = !('id' in props);
	
	  var tagParts = tag.split(classIdSplit);
	  var tagName = null;
	
	  if (notClassId.test(tagParts[1])) {
	    tagName = 'div';
	  }
	
	  var classes;
	  var part;
	  var type;
	  var i;
	  for (i = 0; i < tagParts.length; i++) {
	    part = tagParts[i];
	
	    if (!part) {
	      continue;
	    }
	
	    type = part.charAt(0);
	
	    if (!tagName) {
	      tagName = part;
	    } else if (type === '.') {
	      classes = classes || [];
	      classes.push(part.substring(1, part.length));
	    } else if (type === '#' && noId) {
	      props.id = part.substring(1, part.length);
	    }
	  }
	
	  if (classes) {
	    if (props.className) {
	      classes.push(props.className);
	    }
	
	    props.className = classes.join(' ');
	  }
	
	  return tagName ? tagName.toLowerCase() : 'div';
	}


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(154);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polytheneReact = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apps = [{
	  path: '/SubFire2Mobile',
	  title: 'SubFire 2 Mobile',
	  summary: 'A Progressive Web App Subsonic client for Browsers and Mobile Devices'
	}, {
	  path: '/SubFire2Dash',
	  title: 'SubFire 2 Dash',
	  summary: 'A Progressive Web App Optimized for Portrait Orientation'
	}, {
	  path: '/SubFire2TV',
	  title: 'SubFire 2 TV',
	  summary: "A New SubFire Client for Amazon's Fire TV/Stick"
	}, {
	  path: '/SubFire2Timer',
	  title: 'SubFire 2 Timer',
	  summary: 'A "Toothbrush Timer" Progressive Web App player for mobile'
	}, {
	  path: '/SubFire2Quick',
	  title: 'SubFire 2 Quick',
	  summary: 'A Simpler Player Modeled After Perisonic'
	}, {
	  path: '/SubFire2Baseline',
	  title: 'SubFire 2 Baseline',
	  summary: 'An Experimental App for testing new SubFire 2 Features'
	}];
	
	var developmentApps = [{
	  path: '/SubFire3PlaylistEditor',
	  title: 'SubFire 3 Playlist Editor',
	  summary: "A 'Desktop' Web Player with Playlist and Radio Station Editing, Stars, and Ratings"
	}, {
	  path: '/SubFire3Mobile',
	  title: 'SubFire 3 Mobile',
	  summary: 'A Progressive Web App Subsonic client for Browsers and Mobile Devices'
	}, {
	  path: '/SubFire3Tags',
	  title: 'SubFire 3 Tags',
	  summary: 'A Desktop editor for ID3 tags and file organizer'
	}];
	
	var retiredApps = [{
	  path: '/SubFirePlayer1',
	  title: 'SubFire Player 1',
	  summary: 'A full-featured Subsonic client for FireTV, Fire Tablets, Chromebooks, and the Web'
	}, {
	  path: '/SubFireMobile',
	  title: 'SubFire Mobile (Legacy)',
	  summary: 'A Full-featured Progressive Web App player for mobile'
	}, {
	  path: '/SubFireRadio',
	  title: 'SubFire Radio',
	  summary: 'A Rules-based Playlist Generation Tool'
	}];
	
	var subfire5Apps = [{
	  path: '/SubFire5Demo',
	  title: 'SubFire 5 Demo',
	  summary: 'An in development Progressive Web App player for mobile and desktop'
	}];
	
	var AppCard = function AppCard(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid-50' },
	    _react2.default.createElement(_polytheneReact.Card, {
	      className: 'app-card',
	      content: [{
	        primary: {
	          title: _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: 'flow-text',
	              style: {
	                color: 'white'
	              },
	              to: props.path
	            },
	            props.title
	          )
	        }
	      }, {
	        text: {
	          content: _react2.default.createElement(
	            'div',
	            { className: 'flow-text summary-content' },
	            props.summary
	          )
	        }
	      }]
	    })
	  );
	};
	
	var Apps = function Apps(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'app-cardlist grid-70 grid-parent flow-text' },
	    _react2.default.createElement(
	      'h4',
	      { className: 'grid-100' },
	      'SubFire 5 Apps'
	    ),
	    subfire5Apps.map(function (x) {
	      return _react2.default.createElement(AppCard, {
	        key: x.path,
	        title: x.title,
	        summary: x.summary,
	        path: x.path
	      });
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      { className: 'grid-100' },
	      'SubFire 4 Apps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Tech note: SubFire 4 was an experiment in moving to a monorepo and attempt to upgrade the system to the latest react, storybook, mui, and more...and generally failed. I gave up and started SubFire 5 under a new approach.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      { className: 'grid-100' },
	      'SubFire 3 Apps'
	    ),
	    developmentApps.map(function (x) {
	      return _react2.default.createElement(AppCard, {
	        key: x.path,
	        title: x.title,
	        summary: x.summary,
	        path: x.path
	      });
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      { className: 'grid-100' },
	      'SubFire 2 Apps'
	    ),
	    apps.map(function (x) {
	      return _react2.default.createElement(AppCard, {
	        key: x.path,
	        title: x.title,
	        summary: x.summary,
	        path: x.path
	      });
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      { className: 'grid-100' },
	      'Retired and Deprecated Apps'
	    ),
	    retiredApps.map(function (x) {
	      return _react2.default.createElement(AppCard, {
	        key: x.path,
	        title: x.title,
	        summary: x.summary,
	        path: x.path
	      });
	    })
	  );
	};
	
	var Images = function Images(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid-30' },
	    _react2.default.createElement('img', {
	      src: 'https://subfiresuite.com/caps/uploads/big/545ab432018969952c0b57b06a67ef6a.png',
	      style: {
	        paddingTop: 10,
	        width: '100%',
	        height: 'auto',
	        paddingBottom: 20
	      }
	    }),
	    _react2.default.createElement('img', {
	      src: 'https://subfiresuite.com/caps/uploads/big/bb54489123c155de275966c3d56f0271.png',
	      style: {
	        width: '100%',
	        height: 'auto',
	        paddingBottom: 20
	      }
	    }),
	    _react2.default.createElement('img', {
	      src: 'https://subfiresuite.com/caps/uploads/big/1166e7436043130f941bc83e39233839.png',
	      style: {
	        width: '100%',
	        height: 'auto',
	        paddingBottom: 20
	      }
	    })
	  );
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'index grid-parent' },
	    _react2.default.createElement(
	      'h3',
	      { className: 'grid-100' },
	      'Welcome to the SubFire Suite of Apps for Subsonic'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-100 flow-text' },
	      'SubFire is a suite of applications, including players, playlist editors, and more, for the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://subsonic.org/' },
	        'Subsonic media server'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(Apps, null),
	    _react2.default.createElement(Images, null),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'grid-100 privacy-row flow-text',
	        style: {
	          paddingBottom: 20
	        }
	      },
	      'SubFire\'s ',
	      _react2.default.createElement(
	        'a',
	        { href: '/Privacy' },
	        'Privacy Policy'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-73ef81c761f16fe68bbb.js